function _typeof(t) {
  "@babel/helpers - typeof";
  return (_typeof =
    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
      ? function (t) {
          return typeof t;
        }
      : function (t) {
          return t &&
            "function" == typeof Symbol &&
            t.constructor === Symbol &&
            t !== Symbol.prototype
            ? "symbol"
            : typeof t;
        })(t);
}
function createCommonjsModule(t, e, i) {
  return (
    (i = {
      path: e,
      exports: {},
      require: function (t, e) {
        return commonjsRequire(t, void 0 === e || null === e ? i.path : e);
      },
    }),
    t(i, i.exports),
    i.exports
  );
}
function commonjsRequire() {
  throw new Error("Error commonjs");
}
function onYouTubeIframeAPIReady() {
  document.dispatchEvent(new CustomEvent("youtube:ready"));
}
"undefined" != typeof exports && (exports = void 0),
  (function (t, e) {
    (t = "undefined" != typeof globalThis ? globalThis : t || self).jarallax =
      (function () {
        "use strict";
        function t(t) {
          "complete" === document.readyState ||
          "interactive" === document.readyState
            ? t()
            : document.addEventListener("DOMContentLoaded", t, {
                capture: !0,
                once: !0,
                passive: !0,
              });
        }
        function e() {
          (l = o.innerWidth || document.documentElement.clientWidth),
            d
              ? (!u &&
                  document.body &&
                  ((u = document.createElement("div")),
                  (u.style.cssText =
                    "position: fixed; top: -9999px; left: 0; height: 100vh; width: 0;"),
                  document.body.appendChild(u)),
                (c =
                  (u ? u.clientHeight : 0) ||
                  o.innerHeight ||
                  document.documentElement.clientHeight))
              : (c = o.innerHeight || document.documentElement.clientHeight);
        }
        function i() {
          return { width: l, height: c };
        }
        function a() {
          if (!f.length) return;
          const { width: t, height: e } = i();
          f.forEach((i, a) => {
            const { instance: n, oldData: o } = i;
            if (!n.isVisible()) return;
            const s = n.$item.getBoundingClientRect(),
              r = {
                width: s.width,
                height: s.height,
                top: s.top,
                bottom: s.bottom,
                wndW: t,
                wndH: e,
              },
              d =
                !o ||
                o.wndW !== r.wndW ||
                o.wndH !== r.wndH ||
                o.width !== r.width ||
                o.height !== r.height,
              l = d || !o || o.top !== r.top || o.bottom !== r.bottom;
            (f[a].oldData = r), d && n.onResize(), l && n.onScroll();
          }),
            o.requestAnimationFrame(a);
        }
        let n;
        var o = (n =
            "undefined" != typeof window
              ? window
              : "undefined" != typeof global
              ? global
              : "undefined" != typeof self
              ? self
              : {}),
          s = {
            type: "scroll",
            speed: 0.5,
            containerClass: "jarallax-container",
            imgSrc: null,
            imgElement: ".jarallax-img",
            imgSize: "cover",
            imgPosition: "50% 50%",
            imgRepeat: "no-repeat",
            keepImg: !1,
            elementInViewport: null,
            zIndex: -100,
            disableParallax: !1,
            onScroll: null,
            onInit: null,
            onDestroy: null,
            onCoverImage: null,
            videoClass: "jarallax-video",
            videoSrc: null,
            videoStartTime: 0,
            videoEndTime: 0,
            videoVolume: 0,
            videoLoop: !0,
            videoPlayOnlyVisible: !0,
            videoLazyLoading: !0,
            disableVideo: !1,
            onVideoInsert: null,
            onVideoWorkerInit: null,
          };
        const { navigator: r } = o,
          d =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
              r.userAgent
            );
        let l, c, u;
        e(),
          o.addEventListener("resize", e),
          o.addEventListener("orientationchange", e),
          o.addEventListener("load", e),
          t(() => {
            e();
          });
        const f = [];
        const p = new o.IntersectionObserver(
            (t) => {
              t.forEach((t) => {
                t.target.jarallax.isElementInViewport = t.isIntersecting;
              });
            },
            { rootMargin: "50px" }
          ),
          { navigator: h } = o;
        let m = 0;
        class g {
          constructor(t, e) {
            const i = this;
            (i.instanceID = m),
              (m += 1),
              (i.$item = t),
              (i.defaults = { ...s });
            const a = i.$item.dataset || {},
              n = {};
            if (
              (Object.keys(a).forEach((t) => {
                const e = t.substr(0, 1).toLowerCase() + t.substr(1);
                e && void 0 !== i.defaults[e] && (n[e] = a[t]);
              }),
              (i.options = i.extend({}, i.defaults, n, e)),
              (i.pureOptions = i.extend({}, i.options)),
              Object.keys(i.options).forEach((t) => {
                "true" === i.options[t]
                  ? (i.options[t] = !0)
                  : "false" === i.options[t] && (i.options[t] = !1);
              }),
              (i.options.speed = Math.min(
                2,
                Math.max(-1, parseFloat(i.options.speed))
              )),
              "string" == typeof i.options.disableParallax &&
                (i.options.disableParallax = new RegExp(
                  i.options.disableParallax
                )),
              i.options.disableParallax instanceof RegExp)
            ) {
              const t = i.options.disableParallax;
              i.options.disableParallax = () => t.test(h.userAgent);
            }
            if (
              ("function" != typeof i.options.disableParallax &&
                (i.options.disableParallax = () => !1),
              "string" == typeof i.options.disableVideo &&
                (i.options.disableVideo = new RegExp(i.options.disableVideo)),
              i.options.disableVideo instanceof RegExp)
            ) {
              const t = i.options.disableVideo;
              i.options.disableVideo = () => t.test(h.userAgent);
            }
            "function" != typeof i.options.disableVideo &&
              (i.options.disableVideo = () => !1);
            let o = i.options.elementInViewport;
            o && "object" == typeof o && void 0 !== o.length && ([o] = o),
              o instanceof Element || (o = null),
              (i.options.elementInViewport = o),
              (i.image = {
                src: i.options.imgSrc || null,
                $container: null,
                useImgTag: !1,
                position: "fixed",
              }),
              i.initImg() && i.canInitParallax() && i.init();
          }
          css(t, e) {
            return (function (t, e) {
              return "string" == typeof e
                ? o.getComputedStyle(t).getPropertyValue(e)
                : (Object.keys(e).forEach((i) => {
                    t.style[i] = e[i];
                  }),
                  t);
            })(t, e);
          }
          extend(t, ...e) {
            return (function (t, ...e) {
              return (
                (t = t || {}),
                Object.keys(e).forEach((i) => {
                  e[i] &&
                    Object.keys(e[i]).forEach((a) => {
                      t[a] = e[i][a];
                    });
                }),
                t
              );
            })(t, ...e);
          }
          getWindowData() {
            const { width: t, height: e } = i();
            return {
              width: t,
              height: e,
              y: document.documentElement.scrollTop,
            };
          }
          initImg() {
            const t = this;
            let e = t.options.imgElement;
            return (
              e && "string" == typeof e && (e = t.$item.querySelector(e)),
              e instanceof Element ||
                (t.options.imgSrc
                  ? ((e = new Image()), (e.src = t.options.imgSrc))
                  : (e = null)),
              e &&
                (t.options.keepImg
                  ? (t.image.$item = e.cloneNode(!0))
                  : ((t.image.$item = e), (t.image.$itemParent = e.parentNode)),
                (t.image.useImgTag = !0)),
              !(
                !t.image.$item &&
                (null === t.image.src &&
                  ((t.image.src =
                    "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"),
                  (t.image.bgImage = t.css(t.$item, "background-image"))),
                !t.image.bgImage || "none" === t.image.bgImage)
              )
            );
          }
          canInitParallax() {
            return !this.options.disableParallax();
          }
          init() {
            const t = this,
              e = {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                overflow: "hidden",
              };
            let i = {
              pointerEvents: "none",
              transformStyle: "preserve-3d",
              backfaceVisibility: "hidden",
            };
            if (!t.options.keepImg) {
              const e = t.$item.getAttribute("style");
              if (
                (e && t.$item.setAttribute("data-jarallax-original-styles", e),
                t.image.useImgTag)
              ) {
                const e = t.image.$item.getAttribute("style");
                e &&
                  t.image.$item.setAttribute(
                    "data-jarallax-original-styles",
                    e
                  );
              }
            }
            if (
              ("static" === t.css(t.$item, "position") &&
                t.css(t.$item, { position: "relative" }),
              "auto" === t.css(t.$item, "z-index") &&
                t.css(t.$item, { zIndex: 0 }),
              (t.image.$container = document.createElement("div")),
              t.css(t.image.$container, e),
              t.css(t.image.$container, { "z-index": t.options.zIndex }),
              "fixed" === this.image.position &&
                t.css(t.image.$container, {
                  "-webkit-clip-path":
                    "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                  "clip-path": "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                }),
              t.image.$container.setAttribute(
                "id",
                `jarallax-container-${t.instanceID}`
              ),
              t.options.containerClass &&
                t.image.$container.setAttribute(
                  "class",
                  t.options.containerClass
                ),
              t.$item.appendChild(t.image.$container),
              t.image.useImgTag
                ? (i = t.extend(
                    {
                      "object-fit": t.options.imgSize,
                      "object-position": t.options.imgPosition,
                      "max-width": "none",
                    },
                    e,
                    i
                  ))
                : ((t.image.$item = document.createElement("div")),
                  t.image.src &&
                    (i = t.extend(
                      {
                        "background-position": t.options.imgPosition,
                        "background-size": t.options.imgSize,
                        "background-repeat": t.options.imgRepeat,
                        "background-image":
                          t.image.bgImage || `url("${t.image.src}")`,
                      },
                      e,
                      i
                    ))),
              ("opacity" !== t.options.type &&
                "scale" !== t.options.type &&
                "scale-opacity" !== t.options.type &&
                1 !== t.options.speed) ||
                (t.image.position = "absolute"),
              "fixed" === t.image.position)
            ) {
              const e = (function (t) {
                const e = [];
                for (; null !== t.parentElement; )
                  1 === (t = t.parentElement).nodeType && e.push(t);
                return e;
              })(t.$item).filter((t) => {
                const e = o.getComputedStyle(t),
                  i =
                    e["-webkit-transform"] ||
                    e["-moz-transform"] ||
                    e.transform;
                return (
                  (i && "none" !== i) ||
                  /(auto|scroll)/.test(
                    e.overflow + e["overflow-y"] + e["overflow-x"]
                  )
                );
              });
              t.image.position = e.length ? "absolute" : "fixed";
            }
            var n;
            (i.position = t.image.position),
              t.css(t.image.$item, i),
              t.image.$container.appendChild(t.image.$item),
              t.onResize(),
              t.onScroll(!0),
              t.options.onInit && t.options.onInit.call(t),
              "none" !== t.css(t.$item, "background-image") &&
                t.css(t.$item, { "background-image": "none" }),
              (n = t),
              f.push({ instance: n }),
              1 === f.length && o.requestAnimationFrame(a),
              p.observe(n.options.elementInViewport || n.$item);
          }
          destroy() {
            const t = this;
            var e;
            (e = t),
              f.forEach((t, i) => {
                t.instance.instanceID === e.instanceID && f.splice(i, 1);
              }),
              p.unobserve(e.options.elementInViewport || e.$item);
            const i = t.$item.getAttribute("data-jarallax-original-styles");
            if (
              (t.$item.removeAttribute("data-jarallax-original-styles"),
              i
                ? t.$item.setAttribute("style", i)
                : t.$item.removeAttribute("style"),
              t.image.useImgTag)
            ) {
              const e = t.image.$item.getAttribute(
                "data-jarallax-original-styles"
              );
              t.image.$item.removeAttribute("data-jarallax-original-styles"),
                e
                  ? t.image.$item.setAttribute("style", i)
                  : t.image.$item.removeAttribute("style"),
                t.image.$itemParent &&
                  t.image.$itemParent.appendChild(t.image.$item);
            }
            t.image.$container &&
              t.image.$container.parentNode.removeChild(t.image.$container),
              t.options.onDestroy && t.options.onDestroy.call(t),
              delete t.$item.jarallax;
          }
          coverImage() {
            const t = this,
              { height: e } = i(),
              a = t.image.$container.getBoundingClientRect(),
              n = a.height,
              { speed: o } = t.options,
              s =
                "scroll" === t.options.type ||
                "scroll-opacity" === t.options.type;
            let r = 0,
              d = n,
              l = 0;
            return (
              s &&
                (o < 0
                  ? ((r = o * Math.max(n, e)), e < n && (r -= o * (n - e)))
                  : (r = o * (n + e)),
                o > 1
                  ? (d = Math.abs(r - e))
                  : o < 0
                  ? (d = r / o + Math.abs(r))
                  : (d += (e - n) * (1 - o)),
                (r /= 2)),
              (t.parallaxScrollDistance = r),
              (l = s ? (e - d) / 2 : (n - d) / 2),
              t.css(t.image.$item, {
                height: `${d}px`,
                marginTop: `${l}px`,
                left: "fixed" === t.image.position ? `${a.left}px` : "0",
                width: `${a.width}px`,
              }),
              t.options.onCoverImage && t.options.onCoverImage.call(t),
              { image: { height: d, marginTop: l }, container: a }
            );
          }
          isVisible() {
            return this.isElementInViewport || !1;
          }
          onScroll(t) {
            const e = this;
            if (!t && !e.isVisible()) return;
            const { height: a } = i(),
              n = e.$item.getBoundingClientRect(),
              o = n.top,
              s = n.height,
              r = {},
              d = Math.max(0, o),
              l = Math.max(0, s + o),
              c = Math.max(0, -o),
              u = Math.max(0, o + s - a),
              f = Math.max(0, s - (o + s - a)),
              p = Math.max(0, -o + a - s),
              h = 1 - ((a - o) / (a + s)) * 2;
            let m = 1;
            if (
              (s < a
                ? (m = 1 - (c || u) / s)
                : l <= a
                ? (m = l / a)
                : f <= a && (m = f / a),
              ("opacity" !== e.options.type &&
                "scale-opacity" !== e.options.type &&
                "scroll-opacity" !== e.options.type) ||
                ((r.transform = "translate3d(0,0,0)"), (r.opacity = m)),
              "scale" === e.options.type || "scale-opacity" === e.options.type)
            ) {
              let t = 1;
              e.options.speed < 0
                ? (t -= e.options.speed * m)
                : (t += e.options.speed * (1 - m)),
                (r.transform = `scale(${t}) translate3d(0,0,0)`);
            }
            if (
              "scroll" === e.options.type ||
              "scroll-opacity" === e.options.type
            ) {
              let t = e.parallaxScrollDistance * h;
              "absolute" === e.image.position && (t -= o),
                (r.transform = `translate3d(0,${t}px,0)`);
            }
            e.css(e.image.$item, r),
              e.options.onScroll &&
                e.options.onScroll.call(e, {
                  section: n,
                  beforeTop: d,
                  beforeTopEnd: l,
                  afterTop: c,
                  beforeBottom: u,
                  beforeBottomEnd: f,
                  afterBottom: p,
                  visiblePercent: m,
                  fromViewportCenter: h,
                });
          }
          onResize() {
            this.coverImage();
          }
        }
        const v = function (t, e, ...i) {
          ("object" == typeof HTMLElement
            ? t instanceof HTMLElement
            : t &&
              "object" == typeof t &&
              null !== t &&
              1 === t.nodeType &&
              "string" == typeof t.nodeName) && (t = [t]);
          const a = t.length;
          let n,
            o = 0;
          for (; o < a; o += 1)
            if (
              ("object" == typeof e || void 0 === e
                ? t[o].jarallax || (t[o].jarallax = new g(t[o], e))
                : t[o].jarallax &&
                  (n = t[o].jarallax[e].apply(t[o].jarallax, i)),
              void 0 !== n)
            )
              return n;
          return t;
        };
        v.constructor = g;
        const y = o.jQuery_T4NT;
        if (void 0 !== y) {
          const t = function (...t) {
            Array.prototype.unshift.call(t, this);
            const e = v.apply(o, t);
            return "object" != typeof e ? e : this;
          };
          t.constructor = v.constructor;
          const e = y.fn.jarallax;
          (y.fn.jarallax = t),
            (y.fn.jarallax.noConflict = function () {
              return (y.fn.jarallax = e), this;
            });
        }
        return (
          t(() => {
            v(document.querySelectorAll("[data-jarallax]"));
          }),
          v
        );
      })();
  })(this),
  (jQuery_T4NT.fn.t4sJarallax = jQuery_T4NT.fn.jarallax.noConflict()),
  (function (t) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jQuery_T4NT"], t)
      : t(jQuery_T4NT);
  })(function (t) {
    "use strict";
    function e(t) {
      var e = t.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
      return new RegExp(e);
    }
    function i(t) {
      return function (i) {
        var a = i.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
        if (a)
          for (var n = 0, o = a.length; n < o; ++n) {
            var r = a[n].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),
              d = e(r[0]),
              l = r[1] || "",
              c = r[3] || "",
              u = null;
            (r = r[2]),
              s.hasOwnProperty(r) && ((u = s[r]), (u = Number(t[u]))),
              null !== u &&
                ("!" === l &&
                  (u = (function (t, e) {
                    var i = "s",
                      a = "";
                    return (
                      t &&
                        (1 ===
                        (t = t.replace(/(:|;|\s)/gi, "").split(/\,/)).length
                          ? (i = t[0])
                          : ((a = t[0]), (i = t[1]))),
                      Math.abs(e) > 1 ? i : a
                    );
                  })(c, u)),
                "" === l && u < 10 && (u = "0" + u.toString()),
                (i = i.replace(d, u.toString())));
          }
        return (i = i.replace(/%%/, "%"));
      };
    }
    var a = [],
      n = [],
      o = { precision: 100, elapse: !1, defer: !1 };
    n.push(/^[0-9]*$/.source),
      n.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
      n.push(
        /[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source
      ),
      (n = new RegExp(n.join("|")));
    var s = {
        Y: "years",
        m: "months",
        n: "daysToMonth",
        d: "daysToWeek",
        w: "weeks",
        W: "weeksToMonth",
        H: "hours",
        M: "minutes",
        S: "seconds",
        D: "totalDays",
        I: "totalHours",
        N: "totalMinutes",
        T: "totalSeconds",
      },
      r = function (e, i, n) {
        (this.el = e),
          (this.$el = t(e)),
          (this.interval = null),
          (this.offset = {}),
          (this.options = t.extend({}, o)),
          (this.instanceNumber = a.length),
          a.push(this),
          this.$el.data("countdown-instance", this.instanceNumber),
          n &&
            ("function" == typeof n
              ? (this.$el.on("update.countdown", n),
                this.$el.on("stoped.countdown", n),
                this.$el.on("finish.countdown", n))
              : (this.options = t.extend({}, o, n))),
          this.setFinalDate(i),
          !1 === this.options.defer && this.start();
      };
    t.extend(r.prototype, {
      start: function () {
        null !== this.interval && clearInterval(this.interval);
        var t = this;
        this.update(),
          (this.interval = setInterval(function () {
            t.update.call(t);
          }, this.options.precision));
      },
      stop: function () {
        clearInterval(this.interval),
          (this.interval = null),
          this.dispatchEvent("stoped");
      },
      toggle: function () {
        this.interval ? this.stop() : this.start();
      },
      pause: function () {
        this.stop();
      },
      resume: function () {
        this.start();
      },
      remove: function () {
        this.stop.call(this),
          (a[this.instanceNumber] = null),
          delete this.$el.data().countdownInstance;
      },
      setFinalDate: function (t) {
        this.finalDate = (function (t) {
          if (t instanceof Date) return t;
          if (String(t).match(n))
            return (
              String(t).match(/^[0-9]*$/) && (t = Number(t)),
              String(t).match(/\-/) && (t = String(t).replace(/\-/g, "/")),
              new Date(t)
            );
          throw new Error("Couldn't cast `" + t + "` to a date object.");
        })(t);
      },
      update: function () {
        if (0 !== this.$el.closest("html").length) {
          var e,
            i = void 0 !== t._data(this.el, "events"),
            a = new Date();
          (e = this.finalDate.getTime() - a.getTime()),
            (e = Math.ceil(e / 1e3)),
            (e = !this.options.elapse && e < 0 ? 0 : Math.abs(e)),
            this.totalSecsLeft !== e &&
              i &&
              ((this.totalSecsLeft = e),
              (this.elapsed = a >= this.finalDate),
              (this.offset = {
                seconds: this.totalSecsLeft % 60,
                minutes: Math.floor(this.totalSecsLeft / 60) % 60,
                hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
                days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                daysToMonth: Math.floor(
                  (this.totalSecsLeft / 60 / 60 / 24) % 30.4368
                ),
                weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
                weeksToMonth:
                  Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7) % 4,
                months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
                years: Math.abs(this.finalDate.getFullYear() - a.getFullYear()),
                totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
                totalHours: Math.floor(this.totalSecsLeft / 60 / 60),
                totalMinutes: Math.floor(this.totalSecsLeft / 60),
                totalSeconds: this.totalSecsLeft,
              }),
              this.options.elapse || 0 !== this.totalSecsLeft
                ? this.dispatchEvent("update")
                : (this.stop(), this.dispatchEvent("finish")));
        } else this.remove();
      },
      dispatchEvent: function (e) {
        var a = t.Event(e + ".countdown");
        (a.finalDate = this.finalDate),
          (a.elapsed = this.elapsed),
          (a.offset = t.extend({}, this.offset)),
          (a.strftime = i(this.offset)),
          this.$el.trigger(a);
      },
    }),
      (t.fn.countdown = function () {
        var e = Array.prototype.slice.call(arguments, 0);
        return this.each(function () {
          var i = t(this).data("countdown-instance");
          if (void 0 !== i) {
            var n = a[i],
              o = e[0];
            r.prototype.hasOwnProperty(o)
              ? n[o].apply(n, e.slice(1))
              : null === String(o).match(/^[$A-Z_][0-9A-Z_$]*$/i)
              ? (n.setFinalDate.call(n, o), n.start())
              : t.error(
                  "Method %s does not exist on jQuery_T4NT.countdown".replace(
                    /\%s/gi,
                    o
                  )
                );
          } else new r(this, e[0], e[1]);
        });
      });
  }),
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define(e)
      : ((t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs =
          e());
  })(this, function () {
    "use strict";
    var t = "millisecond",
      e = "second",
      i = "minute",
      a = "hour",
      n = "day",
      o = "week",
      s = "month",
      r = "quarter",
      d = "year",
      l = "date",
      c = "Invalid Date",
      u =
        /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
      f =
        /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
      p = {
        name: "en",
        weekdays:
          "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months:
          "January_February_March_April_May_June_July_August_September_October_November_December".split(
            "_"
          ),
      },
      h = function (t, e, i) {
        var a = String(t);
        return !a || a.length >= e
          ? t
          : "" + Array(e + 1 - a.length).join(i) + t;
      },
      m = {
        s: h,
        z: function (t) {
          var e = -t.utcOffset(),
            i = Math.abs(e),
            a = Math.floor(i / 60),
            n = i % 60;
          return (e <= 0 ? "+" : "-") + h(a, 2, "0") + ":" + h(n, 2, "0");
        },
        m: function t(e, i) {
          if (e.date() < i.date()) return -t(i, e);
          var a = 12 * (i.year() - e.year()) + (i.month() - e.month()),
            n = e.clone().add(a, s),
            o = i - n < 0,
            r = e.clone().add(a + (o ? -1 : 1), s);
          return +(-(a + (i - n) / (o ? n - r : r - n)) || 0);
        },
        a: function (t) {
          return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function (c) {
          return (
            { M: s, y: d, w: o, d: n, D: l, h: a, m: i, s: e, ms: t, Q: r }[
              c
            ] ||
            String(c || "")
              .toLowerCase()
              .replace(/s$/, "")
          );
        },
        u: function (t) {
          return void 0 === t;
        },
      },
      g = "en",
      v = {};
    v[g] = p;
    var y = function (t) {
        return t instanceof T;
      },
      b = function (t, e, i) {
        var a;
        if (!t) return g;
        if ("string" == typeof t) v[t] && (a = t), e && ((v[t] = e), (a = t));
        else {
          var n = t.name;
          (v[n] = t), (a = n);
        }
        return !i && a && (g = a), a || (!i && g);
      },
      S = function (t, e) {
        if (y(t)) return t.clone();
        var i = "object" == typeof e ? e : {};
        return (i.date = t), (i.args = arguments), new T(i);
      },
      w = m;
    (w.l = b),
      (w.i = y),
      (w.w = function (t, e) {
        return S(t, { locale: e.$L, utc: e.$u, x: e.$x, $offset: e.$offset });
      });
    var T = (function () {
        function p(t) {
          (this.$L = b(t.locale, null, !0)), this.parse(t);
        }
        var h = p.prototype;
        return (
          (h.parse = function (t) {
            (this.$d = (function (t) {
              var e = t.date,
                i = t.utc;
              if (null === e) return new Date(NaN);
              if (w.u(e)) return new Date();
              if (e instanceof Date) return new Date(e);
              if ("string" == typeof e && !/Z$/i.test(e)) {
                var a = e.match(u);
                if (a) {
                  var n = a[2] - 1 || 0,
                    o = (a[7] || "0").substring(0, 3);
                  return i
                    ? new Date(
                        Date.UTC(
                          a[1],
                          n,
                          a[3] || 1,
                          a[4] || 0,
                          a[5] || 0,
                          a[6] || 0,
                          o
                        )
                      )
                    : new Date(
                        a[1],
                        n,
                        a[3] || 1,
                        a[4] || 0,
                        a[5] || 0,
                        a[6] || 0,
                        o
                      );
                }
              }
              return new Date(e);
            })(t)),
              (this.$x = t.x || {}),
              this.init();
          }),
          (h.init = function () {
            var t = this.$d;
            (this.$y = t.getFullYear()),
              (this.$M = t.getMonth()),
              (this.$D = t.getDate()),
              (this.$W = t.getDay()),
              (this.$H = t.getHours()),
              (this.$m = t.getMinutes()),
              (this.$s = t.getSeconds()),
              (this.$ms = t.getMilliseconds());
          }),
          (h.$utils = function () {
            return w;
          }),
          (h.isValid = function () {
            return !(this.$d.toString() === c);
          }),
          (h.isSame = function (t, e) {
            var i = S(t);
            return this.startOf(e) <= i && i <= this.endOf(e);
          }),
          (h.isAfter = function (t, e) {
            return S(t) < this.startOf(e);
          }),
          (h.isBefore = function (t, e) {
            return this.endOf(e) < S(t);
          }),
          (h.$g = function (t, e, i) {
            return w.u(t) ? this[e] : this.set(i, t);
          }),
          (h.unix = function () {
            return Math.floor(this.valueOf() / 1e3);
          }),
          (h.valueOf = function () {
            return this.$d.getTime();
          }),
          (h.startOf = function (t, r) {
            var c = this,
              u = !!w.u(r) || r,
              f = w.p(t),
              p = function (t, e) {
                var i = w.w(
                  c.$u ? Date.UTC(c.$y, e, t) : new Date(c.$y, e, t),
                  c
                );
                return u ? i : i.endOf(n);
              },
              h = function (t, e) {
                return w.w(
                  c
                    .toDate()
                    [t].apply(
                      c.toDate("s"),
                      (u ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)
                    ),
                  c
                );
              },
              m = this.$W,
              g = this.$M,
              v = this.$D,
              y = "set" + (this.$u ? "UTC" : "");
            switch (f) {
              case d:
                return u ? p(1, 0) : p(31, 11);
              case s:
                return u ? p(1, g) : p(0, g + 1);
              case o:
                var b = this.$locale().weekStart || 0,
                  S = (m < b ? m + 7 : m) - b;
                return p(u ? v - S : v + (6 - S), g);
              case n:
              case l:
                return h(y + "Hours", 0);
              case a:
                return h(y + "Minutes", 1);
              case i:
                return h(y + "Seconds", 2);
              case e:
                return h(y + "Milliseconds", 3);
              default:
                return this.clone();
            }
          }),
          (h.endOf = function (t) {
            return this.startOf(t, !1);
          }),
          (h.$set = function (o, r) {
            var c,
              u = w.p(o),
              f = "set" + (this.$u ? "UTC" : ""),
              p = ((c = {}),
              (c[n] = f + "Date"),
              (c[l] = f + "Date"),
              (c[s] = f + "Month"),
              (c[d] = f + "FullYear"),
              (c[a] = f + "Hours"),
              (c[i] = f + "Minutes"),
              (c[e] = f + "Seconds"),
              (c[t] = f + "Milliseconds"),
              c)[u],
              h = u === n ? this.$D + (r - this.$W) : r;
            if (u === s || u === d) {
              var m = this.clone().set(l, 1);
              m.$d[p](h),
                m.init(),
                (this.$d = m.set(l, Math.min(this.$D, m.daysInMonth())).$d);
            } else p && this.$d[p](h);
            return this.init(), this;
          }),
          (h.set = function (t, e) {
            return this.clone().$set(t, e);
          }),
          (h.get = function (t) {
            return this[w.p(t)]();
          }),
          (h.add = function (t, r) {
            var l,
              c = this;
            t = Number(t);
            var u = w.p(r),
              f = function (e) {
                var i = S(c);
                return w.w(i.date(i.date() + Math.round(e * t)), c);
              };
            if (u === s) return this.set(s, this.$M + t);
            if (u === d) return this.set(d, this.$y + t);
            if (u === n) return f(1);
            if (u === o) return f(7);
            var p =
                ((l = {}), (l[i] = 6e4), (l[a] = 36e5), (l[e] = 1e3), l)[u] ||
                1,
              h = this.$d.getTime() + t * p;
            return w.w(h, this);
          }),
          (h.subtract = function (t, e) {
            return this.add(-1 * t, e);
          }),
          (h.format = function (t) {
            var e = this,
              i = this.$locale();
            if (!this.isValid()) return i.invalidDate || c;
            var a = t || "YYYY-MM-DDTHH:mm:ssZ",
              n = w.z(this),
              o = this.$H,
              s = this.$m,
              r = this.$M,
              d = i.weekdays,
              l = i.months,
              u = function (t, i, n, o) {
                return (t && (t[i] || t(e, a))) || n[i].substr(0, o);
              },
              p = function (t) {
                return w.s(o % 12 || 12, t, "0");
              },
              h =
                i.meridiem ||
                function (t, e, i) {
                  var a = t < 12 ? "AM" : "PM";
                  return i ? a.toLowerCase() : a;
                },
              m = {
                YY: String(this.$y).slice(-2),
                YYYY: this.$y,
                M: r + 1,
                MM: w.s(r + 1, 2, "0"),
                MMM: u(i.monthsShort, r, l, 3),
                MMMM: u(l, r),
                D: this.$D,
                DD: w.s(this.$D, 2, "0"),
                d: String(this.$W),
                dd: u(i.weekdaysMin, this.$W, d, 2),
                ddd: u(i.weekdaysShort, this.$W, d, 3),
                dddd: d[this.$W],
                H: String(o),
                HH: w.s(o, 2, "0"),
                h: p(1),
                hh: p(2),
                a: h(o, s, !0),
                A: h(o, s, !1),
                m: String(s),
                mm: w.s(s, 2, "0"),
                s: String(this.$s),
                ss: w.s(this.$s, 2, "0"),
                SSS: w.s(this.$ms, 3, "0"),
                Z: n,
              };
            return a.replace(f, function (t, e) {
              return e || m[t] || n.replace(":", "");
            });
          }),
          (h.utcOffset = function () {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
          }),
          (h.diff = function (t, l, c) {
            var u,
              f = w.p(l),
              p = S(t),
              h = 6e4 * (p.utcOffset() - this.utcOffset()),
              m = this - p,
              g = w.m(this, p);
            return (
              (g =
                ((u = {}),
                (u[d] = g / 12),
                (u[s] = g),
                (u[r] = g / 3),
                (u[o] = (m - h) / 6048e5),
                (u[n] = (m - h) / 864e5),
                (u[a] = m / 36e5),
                (u[i] = m / 6e4),
                (u[e] = m / 1e3),
                u)[f] || m),
              c ? g : w.a(g)
            );
          }),
          (h.daysInMonth = function () {
            return this.endOf(s).$D;
          }),
          (h.$locale = function () {
            return v[this.$L];
          }),
          (h.locale = function (t, e) {
            if (!t) return this.$L;
            var i = this.clone(),
              a = b(t, e, !0);
            return a && (i.$L = a), i;
          }),
          (h.clone = function () {
            return w.w(this.$d, this);
          }),
          (h.toDate = function () {
            return new Date(this.valueOf());
          }),
          (h.toJSON = function () {
            return this.isValid() ? this.toISOString() : null;
          }),
          (h.toISOString = function () {
            return this.$d.toISOString();
          }),
          (h.toString = function () {
            return this.$d.toUTCString();
          }),
          p
        );
      })(),
      _ = T.prototype;
    return (
      (S.prototype = _),
      [
        ["$ms", t],
        ["$s", e],
        ["$m", i],
        ["$H", a],
        ["$W", n],
        ["$M", s],
        ["$y", d],
        ["$D", l],
      ].forEach(function (t) {
        _[t[1]] = function (e) {
          return this.$g(e, t[0], t[1]);
        };
      }),
      (S.extend = function (t, e) {
        return t.$i || (t(e, T, S), (t.$i = !0)), S;
      }),
      (S.locale = b),
      (S.isDayjs = y),
      (S.unix = function (t) {
        return S(1e3 * t);
      }),
      (S.en = v[g]),
      (S.Ls = v),
      (S.p = {}),
      S
    );
  }),
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define(e)
      : ((t =
          "undefined" != typeof globalThis
            ? globalThis
            : t || self).dayjs_plugin_utc = e());
  })(this, function () {
    "use strict";
    var t = "minute",
      e = /[+-]\d\d(?::?\d\d)?/g,
      i = /([+-]|\d\d)/g;
    return function (a, n, o) {
      var s = n.prototype;
      (o.utc = function (t) {
        return new n({ date: t, utc: !0, args: arguments });
      }),
        (s.utc = function (e) {
          var i = o(this.toDate(), { locale: this.$L, utc: !0 });
          return e ? i.add(this.utcOffset(), t) : i;
        }),
        (s.local = function () {
          return o(this.toDate(), { locale: this.$L, utc: !1 });
        });
      var r = s.parse;
      s.parse = function (t) {
        t.utc && (this.$u = !0),
          this.$utils().u(t.$offset) || (this.$offset = t.$offset),
          r.call(this, t);
      };
      var d = s.init;
      s.init = function () {
        if (this.$u) {
          var t = this.$d;
          (this.$y = t.getUTCFullYear()),
            (this.$M = t.getUTCMonth()),
            (this.$D = t.getUTCDate()),
            (this.$W = t.getUTCDay()),
            (this.$H = t.getUTCHours()),
            (this.$m = t.getUTCMinutes()),
            (this.$s = t.getUTCSeconds()),
            (this.$ms = t.getUTCMilliseconds());
        } else d.call(this);
      };
      var l = s.utcOffset;
      s.utcOffset = function (a, n) {
        var o = this.$utils().u;
        if (o(a))
          return this.$u ? 0 : o(this.$offset) ? l.call(this) : this.$offset;
        if (
          "string" == typeof a &&
          null ===
            (a = (function (t) {
              void 0 === t && (t = "");
              var a = t.match(e);
              if (!a) return null;
              var n = ("" + a[0]).match(i) || ["-", 0, 0],
                o = 60 * +n[1] + +n[2];
              return 0 === o ? 0 : "+" === n[0] ? o : -o;
            })(a))
        )
          return this;
        var s = Math.abs(a) <= 16 ? 60 * a : a,
          r = this;
        if (n) return (r.$offset = s), (r.$u = 0 === a), r;
        if (0 !== a) {
          var d = this.$u
            ? this.toDate().getTimezoneOffset()
            : -1 * this.utcOffset();
          ((r = this.local().add(s + d, t)).$offset = s),
            (r.$x.$localOffset = d);
        } else r = this.utc();
        return r;
      };
      var c = s.format;
      (s.format = function (t) {
        var e = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return c.call(this, e);
      }),
        (s.valueOf = function () {
          var t = this.$utils().u(this.$offset)
            ? 0
            : this.$offset +
              (this.$x.$localOffset || new Date().getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * t;
        }),
        (s.isUTC = function () {
          return !!this.$u;
        }),
        (s.toISOString = function () {
          return this.toDate().toISOString();
        }),
        (s.toString = function () {
          return this.toDate().toUTCString();
        });
      var u = s.toDate;
      s.toDate = function (t) {
        return "s" === t && this.$offset
          ? o(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate()
          : u.call(this);
      };
      var f = s.diff;
      s.diff = function (t, e, i) {
        if (t && this.$u === t.$u) return f.call(this, t, e, i);
        var a = this.local(),
          n = o(t).local();
        return f.call(a, n, e, i);
      };
    };
  }),
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define(e)
      : ((t =
          "undefined" != typeof globalThis
            ? globalThis
            : t || self).dayjs_plugin_timezone = e());
  })(this, function () {
    "use strict";
    var t = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 },
      e = {};
    return function (i, a, n) {
      var o,
        s = function (t, i, a) {
          void 0 === a && (a = {});
          var n = new Date(t);
          return (function (t, i) {
            void 0 === i && (i = {});
            var a = i.timeZoneName || "short",
              n = t + "|" + a,
              o = e[n];
            return (
              o ||
                ((o = new Intl.DateTimeFormat("en-US", {
                  hour12: !1,
                  timeZone: t,
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  timeZoneName: a,
                })),
                (e[n] = o)),
              o
            );
          })(i, a).formatToParts(n);
        },
        r = function (e, i) {
          for (var a = s(e, i), o = [], r = 0; r < a.length; r += 1) {
            var d = a[r],
              l = d.type,
              c = d.value,
              u = t[l];
            u >= 0 && (o[u] = parseInt(c, 10));
          }
          var f = o[3],
            p = 24 === f ? 0 : f,
            h =
              o[0] +
              "-" +
              o[1] +
              "-" +
              o[2] +
              " " +
              p +
              ":" +
              o[4] +
              ":" +
              o[5] +
              ":000",
            m = +e;
          return (n.utc(h).valueOf() - (m -= m % 1e3)) / 6e4;
        },
        d = a.prototype;
      (d.tz = function (t, e) {
        void 0 === t && (t = o);
        var i = this.utcOffset(),
          a = this.toDate(),
          s = a.toLocaleString("en-US", { timeZone: t }),
          r = Math.round((a - new Date(s)) / 1e3 / 60),
          d = n(s)
            .$set("millisecond", this.$ms)
            .utcOffset(15 * -Math.round(a.getTimezoneOffset() / 15) - r, !0);
        if (e) {
          var l = d.utcOffset();
          d = d.add(i - l, "minute");
        }
        return (d.$x.$timezone = t), d;
      }),
        (d.offsetName = function (t) {
          var e = this.$x.$timezone || n.tz.guess(),
            i = s(this.valueOf(), e, { timeZoneName: t }).find(function (t) {
              return "timezonename" === t.type.toLowerCase();
            });
          return i && i.value;
        });
      var l = d.startOf;
      (d.startOf = function (t, e) {
        if (!this.$x || !this.$x.$timezone) return l.call(this, t, e);
        var i = n(this.format("YYYY-MM-DD HH:mm:ss:SSS"));
        return l.call(i, t, e).tz(this.$x.$timezone, !0);
      }),
        (n.tz = function (t, e, i) {
          var a = i && e,
            s = i || e || o,
            d = r(+n(), s);
          if ("string" != typeof t) return n(t).tz(s);
          var l = (function (t, e, i) {
              var a = t - 60 * e * 1e3,
                n = r(a, i);
              if (e === n) return [a, e];
              var o = r((a -= 60 * (n - e) * 1e3), i);
              return n === o
                ? [a, n]
                : [t - 60 * Math.min(n, o) * 1e3, Math.max(n, o)];
            })(n.utc(t, a).valueOf(), d, s),
            c = l[0],
            u = l[1],
            f = n(c).utcOffset(u);
          return (f.$x.$timezone = s), f;
        }),
        (n.tz.guess = function () {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }),
        (n.tz.setDefault = function (t) {
          o = t;
        });
    };
  });
var dayjs_utc = window.dayjs_plugin_utc,
  dayjs_timezone = window.dayjs_plugin_timezone;
dayjs.locale("en"),
  dayjs.extend(dayjs_utc),
  dayjs.extend(dayjs_timezone),
  (function (t) {
    "function" == typeof define && define.amd
      ? define(["jQuery_T4NT"], t)
      : t(
          "object" == typeof exports
            ? require("jQuery_T4NT")
            : window.jQuery_T4NT || window.Zepto
        );
  })(function (t) {
    var e,
      i,
      a,
      n,
      o,
      s,
      r = {},
      d = function () {},
      l = !!window.jQuery_T4NT,
      c = t(window),
      u = function (t, i) {
        e.ev.on("mfp" + t + ".mfp", i);
      },
      f = function (e, i, a, n) {
        var o = document.createElement("div");
        return (
          (o.className = "mfp-" + e),
          a && (o.innerHTML = a),
          n ? i && i.appendChild(o) : ((o = t(o)), i && o.appendTo(i)),
          o
        );
      },
      p = function (i, a) {
        e.ev.triggerHandler("mfp" + i, a),
          e.st.callbacks &&
            ((i = i.charAt(0).toLowerCase() + i.slice(1)),
            e.st.callbacks[i] &&
              e.st.callbacks[i].apply(e, t.isArray(a) ? a : [a]));
      },
      h = function (i) {
        return (
          (i === s && e.currTemplate.closeBtn) ||
            ((e.currTemplate.closeBtn = t(
              e.st.closeMarkup.replace("%title%", e.st.tClose)
            )),
            (s = i)),
          e.currTemplate.closeBtn
        );
      },
      m = function () {
        t.magnificPopupT4s.instance ||
          ((e = new d()).init(), (t.magnificPopupT4s.instance = e));
      };
    (d.prototype = {
      constructor: d,
      init: function () {
        var i = navigator.appVersion;
        (e.isLowIE = e.isIE8 = document.all && !document.addEventListener),
          (e.isAndroid = /android/gi.test(i)),
          (e.isIOS = /iphone|ipad|ipod/gi.test(i)),
          (e.supportsTransition = (function () {
            var t = document.createElement("p").style,
              e = ["ms", "O", "Moz", "Webkit"];
            if (void 0 !== t.transition) return !0;
            for (; e.length; ) if (e.pop() + "Transition" in t) return !0;
            return !1;
          })()),
          (e.probablyMobile =
            e.isAndroid ||
            e.isIOS ||
            /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(
              navigator.userAgent
            )),
          (a = t(document)),
          (e.popupsCache = {});
      },
      open: function (i) {
        var n;
        if (!1 === i.isObj) {
          (e.items = i.items.toArray()), (e.index = 0);
          var s,
            r = i.items;
          for (n = 0; n < r.length; n++)
            if (((s = r[n]).parsed && (s = s.el[0]), s === i.el[0])) {
              e.index = n;
              break;
            }
        } else
          (e.items = t.isArray(i.items) ? i.items : [i.items]),
            (e.index = i.index || 0);
        if (!e.isOpen) {
          (e.types = []),
            (o = ""),
            i.mainEl && i.mainEl.length ? (e.ev = i.mainEl.eq(0)) : (e.ev = a),
            i.key
              ? (e.popupsCache[i.key] || (e.popupsCache[i.key] = {}),
                (e.currTemplate = e.popupsCache[i.key]))
              : (e.currTemplate = {}),
            (e.st = t.extend(!0, {}, t.magnificPopupT4s.defaults, i)),
            (e.fixedContentPos =
              "auto" === e.st.fixedContentPos
                ? !e.probablyMobile
                : e.st.fixedContentPos),
            e.st.modal &&
              ((e.st.closeOnContentClick = !1),
              (e.st.closeOnBgClick = !1),
              (e.st.showCloseBtn = !1),
              (e.st.enableEscapeKey = !1)),
            e.bgOverlay ||
              ((e.bgOverlay = f("bg").on("click.mfp", function () {
                e.close();
              })),
              (e.wrap = f("wrap")
                .attr("tabindex", -1)
                .on("click.mfp", function (t) {
                  e._checkIfClose(t.target) && e.close();
                })),
              (e.container = f("container", e.wrap))),
            (e.contentContainer = f("content")),
            e.st.preloader &&
              (e.preloader = f("preloader", e.container, e.st.tLoading));
          var d = t.magnificPopupT4s.modules;
          for (n = 0; n < d.length; n++) {
            var l = d[n];
            (l = l.charAt(0).toUpperCase() + l.slice(1)), e["init" + l].call(e);
          }
          p("BeforeOpen"),
            e.st.showCloseBtn &&
              (e.st.closeBtnInside
                ? (u("MarkupParse", function (t, e, i, a) {
                    i.close_replaceWith = h(a.type);
                  }),
                  (o += " mfp-close-btn-in"))
                : e.wrap.append(h())),
            e.st.alignTop && (o += " mfp-align-top"),
            e.fixedContentPos
              ? e.wrap.css({
                  overflow: e.st.overflowY,
                  overflowX: "hidden",
                  overflowY: e.st.overflowY,
                })
              : e.wrap.css({ top: c.scrollTop(), position: "absolute" }),
            (!1 === e.st.fixedBgPos ||
              ("auto" === e.st.fixedBgPos && !e.fixedContentPos)) &&
              e.bgOverlay.css({ height: a.height(), position: "absolute" }),
            e.st.enableEscapeKey &&
              a.on("keyup.mfp", function (t) {
                27 === t.keyCode && e.close();
              }),
            c.on("resize.mfp", function () {
              e.updateSize();
            }),
            e.st.closeOnContentClick || (o += " mfp-auto-cursor"),
            o && e.wrap.addClass(o);
          var m = (e.wH = c.height()),
            g = {};
          if (e.fixedContentPos && e._hasScrollBar(m)) {
            var v = e._getScrollbarSize();
            v && (g.marginRight = v);
          }
          e.fixedContentPos &&
            (e.isIE7
              ? t("body, html").css("overflow", "hidden")
              : (g.overflow = "hidden"));
          var y = e.st.mainClass;
          return (
            e.isIE7 && (y += " mfp-ie7"),
            y && e._addClassToMFP(y),
            e.updateItemHTML(),
            p("BuildControls"),
            t("html").css(g),
            e.bgOverlay
              .add(e.wrap)
              .prependTo(e.st.prependTo || t(document.body)),
            (e._lastFocusedEl = document.activeElement),
            setTimeout(function () {
              e.content
                ? (e._addClassToMFP("mfp-ready"), e._setFocus())
                : e.bgOverlay.addClass("mfp-ready"),
                a.on("focusin.mfp", e._onFocusIn);
            }, 16),
            (e.isOpen = !0),
            e.updateSize(m),
            p("Open"),
            i
          );
        }
        e.updateItemHTML();
      },
      close: function () {
        e.isOpen &&
          (p("BeforeClose"),
          (e.isOpen = !1),
          e.st.removalDelay && !e.isLowIE && e.supportsTransition
            ? (e._addClassToMFP("mfp-removing"),
              setTimeout(function () {
                e._close();
              }, e.st.removalDelay))
            : e._close());
      },
      _close: function () {
        p("Close");
        var i = "mfp-removing mfp-ready ";
        if (
          (e.bgOverlay.detach(),
          e.wrap.detach(),
          e.container.empty(),
          e.st.mainClass && (i += e.st.mainClass + " "),
          e._removeClassFromMFP(i),
          e.fixedContentPos)
        ) {
          var n = { marginRight: "" };
          e.isIE7 ? t("body, html").css("overflow", "") : (n.overflow = ""),
            t("html").css(n);
        }
        a.off("keyup.mfp focusin.mfp"),
          e.ev.off(".mfp"),
          e.wrap.attr("class", "mfp-wrap").removeAttr("style"),
          e.bgOverlay.attr("class", "mfp-bg"),
          e.container.attr("class", "mfp-container"),
          !e.st.showCloseBtn ||
            (e.st.closeBtnInside && !0 !== e.currTemplate[e.currItem.type]) ||
            (e.currTemplate.closeBtn && e.currTemplate.closeBtn.detach()),
          e.st.autoFocusLast && e._lastFocusedEl && t(e._lastFocusedEl).focus(),
          (e.currItem = null),
          (e.content = null),
          (e.currTemplate = null),
          (e.prevHeight = 0),
          p("AfterClose");
      },
      updateSize: function (t) {
        if (e.isIOS) {
          var i = document.documentElement.clientWidth / window.innerWidth,
            a = window.innerHeight * i;
          e.wrap.css("height", a), (e.wH = a);
        } else e.wH = t || c.height();
        e.fixedContentPos || e.wrap.css("height", e.wH), p("Resize");
      },
      updateItemHTML: function () {
        var i = e.items[e.index];
        e.contentContainer.detach(),
          e.content && e.content.detach(),
          i.parsed || (i = e.parseEl(e.index));
        var a = i.type;
        if (
          (p("BeforeChange", [e.currItem ? e.currItem.type : "", a]),
          (e.currItem = i),
          !e.currTemplate[a])
        ) {
          var o = !!e.st[a] && e.st[a].markup;
          p("FirstMarkupParse", o), (e.currTemplate[a] = !o || t(o));
        }
        n && n !== i.type && e.container.removeClass("mfp-" + n + "-holder");
        var s = e["get" + a.charAt(0).toUpperCase() + a.slice(1)](
          i,
          e.currTemplate[a]
        );
        e.appendContent(s, a),
          (i.preloaded = !0),
          p("Change", i),
          (n = i.type),
          e.container.prepend(e.contentContainer),
          p("AfterChange");
      },
      appendContent: function (t, i, a) {
        if ("" == t && "ajax" == i) return !1;
        (e.content = t),
          t
            ? e.st.showCloseBtn &&
              e.st.closeBtnInside &&
              !0 === e.currTemplate[i]
              ? e.content.find(".mfp-close").length || e.content.append(h())
              : (e.content = t)
            : (e.content = ""),
          p("BeforeAppend"),
          e.container.addClass("mfp-" + i + "-holder"),
          e.contentContainer.append(e.content);
      },
      parseEl: function (i) {
        var a,
          n = e.items[i];
        if (
          (n.tagName
            ? (n = { el: t(n) })
            : ((a = n.type), (n = { data: n, src: n.src })),
          n.el)
        ) {
          for (var o = e.types, s = 0; s < o.length; s++)
            if (n.el.hasClass("mfp-" + o[s])) {
              a = o[s];
              break;
            }
          (n.src = n.el.attr("data-mfp-src")),
            n.src || (n.src = n.el.attr("href"));
        }
        return (
          (n.type = a || e.st.type || "inline"),
          (n.index = i),
          (n.parsed = !0),
          (e.items[i] = n),
          p("ElementParse", n),
          e.items[i]
        );
      },
      addGroup: function (t, i) {
        var a = function (a) {
          (a.mfpEl = this), e._openClick(a, t, i);
        };
        i || (i = {});
        var n = "click.magnificPopupT4s";
        (i.mainEl = t),
          i.items
            ? ((i.isObj = !0), t.off(n).on(n, a))
            : ((i.isObj = !1),
              i.delegate
                ? t.off(n).on(n, i.delegate, a)
                : ((i.items = t), t.off(n).on(n, a)));
      },
      _openClick: function (i, a, n) {
        if (
          (void 0 !== n.midClick
            ? n.midClick
            : t.magnificPopupT4s.defaults.midClick) ||
          !(2 === i.which || i.ctrlKey || i.metaKey || i.altKey || i.shiftKey)
        ) {
          var o =
            void 0 !== n.disableOn
              ? n.disableOn
              : t.magnificPopupT4s.defaults.disableOn;
          if (o)
            if (t.isFunction(o)) {
              if (!o.call(e)) return !0;
            } else if (c.width() < o) return !0;
          i.type && (i.preventDefault(), e.isOpen && i.stopPropagation()),
            (n.el = t(i.mfpEl)),
            n.delegate && (n.items = a.find(n.delegate)),
            e.open(n);
        }
      },
      updateStatus: function (t, a) {
        if (e.preloader) {
          i !== t && e.container.removeClass("mfp-s-" + i),
            a || "loading" !== t || (a = e.st.tLoading);
          var n = { status: t, text: a };
          p("UpdateStatus", n),
            (t = n.status),
            (a = n.text),
            e.preloader.html(a),
            e.preloader.find("a").on("click", function (t) {
              t.stopImmediatePropagation();
            }),
            e.container.addClass("mfp-s-" + t),
            (i = t);
        }
      },
      _checkIfClose: function (i) {
        if (!t(i).hasClass("mfp-prevent-close")) {
          var a = e.st.closeOnContentClick,
            n = e.st.closeOnBgClick;
          if (a && n) return !0;
          if (
            !e.content ||
            t(i).hasClass("mfp-close") ||
            (e.preloader && i === e.preloader[0])
          )
            return !0;
          if (i === e.content[0] || t.contains(e.content[0], i)) {
            if (a) return !0;
          } else if (n && t.contains(document, i)) return !0;
          return !1;
        }
      },
      _addClassToMFP: function (t) {
        e.bgOverlay.addClass(t), e.wrap.addClass(t);
      },
      _removeClassFromMFP: function (t) {
        this.bgOverlay.removeClass(t), e.wrap.removeClass(t);
      },
      _hasScrollBar: function (t) {
        return (
          (e.isIE7 ? a.height() : document.body.scrollHeight) >
          (t || c.height())
        );
      },
      _setFocus: function () {
        (e.st.focus ? e.content.find(e.st.focus).eq(0) : e.wrap).focus();
      },
      _onFocusIn: function (i) {
        if (i.target !== e.wrap[0] && !t.contains(e.wrap[0], i.target))
          return e._setFocus(), !1;
      },
      _parseMarkup: function (e, i, a) {
        var n;
        a.data && (i = t.extend(a.data, i)),
          p("MarkupParse", [e, i, a]),
          t.each(i, function (i, a) {
            if (void 0 === a || !1 === a) return !0;
            if ((n = i.split("_")).length > 1) {
              var o = e.find(".mfp-" + n[0]);
              if (o.length > 0) {
                var s = n[1];
                "replaceWith" === s
                  ? o[0] !== a[0] && o.replaceWith(a)
                  : "img" === s
                  ? o.is("img")
                    ? o.attr("src", a)
                    : o.replaceWith(
                        t("<img>").attr("src", a).attr("class", o.attr("class"))
                      )
                  : o.attr(n[1], a);
              }
            } else e.find(".mfp-" + i).html(a);
          });
      },
      _getScrollbarSize: function () {
        if (void 0 === e.scrollbarSize) {
          var t = document.createElement("div");
          (t.style.cssText =
            "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;"),
            document.body.appendChild(t),
            (e.scrollbarSize = t.offsetWidth - t.clientWidth),
            document.body.removeChild(t);
        }
        return e.scrollbarSize;
      },
    }),
      (t.magnificPopupT4s = {
        instance: null,
        proto: d.prototype,
        modules: [],
        open: function (e, i) {
          return (
            m(),
            ((e = e ? t.extend(!0, {}, e) : {}).isObj = !0),
            (e.index = i || 0),
            this.instance.open(e)
          );
        },
        close: function () {
          return (
            t.magnificPopupT4s.instance && t.magnificPopupT4s.instance.close()
          );
        },
        registerModule: function (e, i) {
          i.options && (t.magnificPopupT4s.defaults[e] = i.options),
            t.extend(this.proto, i.proto),
            this.modules.push(e);
        },
        defaults: {
          disableOn: 0,
          key: null,
          midClick: !1,
          mainClass: "",
          preloader: !0,
          focus: "",
          closeOnContentClick: !1,
          closeOnBgClick: !0,
          closeBtnInside: !0,
          showCloseBtn: !0,
          enableEscapeKey: !0,
          modal: !1,
          alignTop: !1,
          removalDelay: 0,
          prependTo: null,
          fixedContentPos: "auto",
          fixedBgPos: "auto",
          overflowY: "auto",
          closeMarkup:
            '<button title="%title%" type="button" class="mfp-close"><svg class="t4smfp-icon-close" role="presentation" viewBox="0 0 16 14"><path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path></svg></button>',
          tClose: "Close (Esc)",
          tLoading: "Loading...",
          autoFocusLast: !0,
        },
      }),
      (t.fn.magnificPopupT4s = function (i) {
        m();
        var a = t(this);
        if ("string" == typeof i)
          if ("open" === i) {
            var n,
              o = l ? a.data("magnificPopup") : a[0].magnificPopupT4s,
              s = parseInt(arguments[1], 10) || 0;
            o.items
              ? (n = o.items[s])
              : ((n = a),
                o.delegate && (n = n.find(o.delegate)),
                (n = n.eq(s))),
              e._openClick({ mfpEl: n }, a, o);
          } else
            e.isOpen && e[i].apply(e, Array.prototype.slice.call(arguments, 1));
        else
          (i = t.extend(!0, {}, i)),
            l ? a.data("magnificPopup", i) : (a[0].magnificPopupT4s = i),
            e.addGroup(a, i);
        return a;
      });
    var g,
      v,
      y,
      b = function () {
        y && (v.after(y.addClass(g)).detach(), (y = null));
      };
    t.magnificPopupT4s.registerModule("inline", {
      options: {
        hiddenClass: "hide",
        markup: "",
        tNotFound: "Content not found",
      },
      proto: {
        initInline: function () {
          e.types.push("inline"),
            u("Close.inline", function () {
              b();
            });
        },
        getInline: function (i, a) {
          if ((b(), i.src)) {
            var n = e.st.inline,
              o = t(i.src);
            if (o.length) {
              var s = o[0].parentNode;
              s &&
                s.tagName &&
                (v || ((g = n.hiddenClass), (v = f(g)), (g = "mfp-" + g)),
                (y = o.after(v).detach().removeClass(g))),
                e.updateStatus("ready");
            } else e.updateStatus("error", n.tNotFound), (o = t("<div>"));
            return (i.inlineElement = o), o;
          }
          return e.updateStatus("ready"), e._parseMarkup(a, {}, i), a;
        },
      },
    });
    var S,
      w = function () {
        S && t(document.body).removeClass(S);
      },
      T = function () {
        w(), e.req && e.req.abort();
      };
    t.magnificPopupT4s.registerModule("ajax", {
      options: {
        settings: null,
        cursor: "mfp-ajax-cur",
        tError: '<a href="%url%">The content</a> could not be loaded.',
      },
      proto: {
        initAjax: function () {
          e.types.push("ajax"),
            (S = e.st.ajax.cursor),
            u("Close.ajax", T),
            u("BeforeChange.ajax", T);
        },
        getAjax: function (i) {
          S && t(document.body).addClass(S), e.updateStatus("loading");
          var a = t(i.el).attr("data-storageid") || "nt94",
            n = t.extend(
              {
                url: i.src,
                success: function (n, o, s) {
                  var d = { data: n, xhr: s };
                  p("ParseAjax", d),
                    e.appendContent(t(d.data), "ajax"),
                    (i.finished = !0),
                    w(),
                    e._setFocus(),
                    setTimeout(function () {
                      e.wrap.addClass("mfp-ready");
                    }, 16),
                    e.updateStatus("ready"),
                    p("AjaxContentAdded"),
                    (r[a] = n);
                },
                error: function () {
                  w(),
                    (i.finished = i.loadError = !0),
                    e.updateStatus(
                      "error",
                      e.st.ajax.tError.replace("%url%", i.src)
                    );
                },
              },
              e.st.ajax.settings
            ),
            o = r[a];
          if (void 0 !== o) {
            var s = { data: o };
            p("ParseAjax", s),
              e.appendContent(t(s.data), "ajax"),
              w(),
              e._setFocus(),
              setTimeout(function () {
                e.wrap.addClass("mfp-ready");
              }, 16),
              e.updateStatus("ready"),
              p("AjaxContentAdded");
          } else e.req = t.ajax(n);
          return "";
        },
      },
    });
    var _;
    t.magnificPopupT4s.registerModule("image", {
      options: {
        markup:
          '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
        cursor: "mfp-zoom-out-cur",
        titleSrc: "title",
        verticalFit: !0,
        tError: '<a href="%url%">The image</a> could not be loaded.',
      },
      proto: {
        initImage: function () {
          var i = e.st.image,
            a = ".image";
          e.types.push("image"),
            u("Open" + a, function () {
              "image" === e.currItem.type &&
                i.cursor &&
                t(document.body).addClass(i.cursor);
            }),
            u("Close" + a, function () {
              i.cursor && t(document.body).removeClass(i.cursor),
                c.off("resize.mfp");
            }),
            u("Resize" + a, e.resizeImage),
            e.isLowIE && u("AfterChange", e.resizeImage);
        },
        resizeImage: function () {
          var t = e.currItem;
          if (t && t.img && e.st.image.verticalFit) {
            var i = 0;
            e.isLowIE &&
              (i =
                parseInt(t.img.css("padding-top"), 10) +
                parseInt(t.img.css("padding-bottom"), 10)),
              t.img.css("max-height", e.wH - i);
          }
        },
        _onImageHasSize: function (t) {
          t.img &&
            ((t.hasSize = !0),
            _ && clearInterval(_),
            (t.isCheckingImgSize = !1),
            p("ImageHasSize", t),
            t.imgHidden &&
              (e.content && e.content.removeClass("mfp-loading"),
              (t.imgHidden = !1)));
        },
        findImageSize: function (t) {
          var i = 0,
            a = t.img[0],
            n = function (o) {
              _ && clearInterval(_),
                (_ = setInterval(function () {
                  a.naturalWidth > 0
                    ? e._onImageHasSize(t)
                    : (i > 200 && clearInterval(_),
                      3 == ++i
                        ? n(10)
                        : 40 === i
                        ? n(50)
                        : 100 === i && n(500));
                }, o));
            };
          n(1);
        },
        getImage: function (i, a) {
          var n = 0,
            o = function () {
              i &&
                (i.img[0].complete
                  ? (i.img.off(".mfploader"),
                    i === e.currItem &&
                      (e._onImageHasSize(i), e.updateStatus("ready")),
                    (i.hasSize = !0),
                    (i.loaded = !0),
                    p("ImageLoadComplete"))
                  : ++n < 200
                  ? setTimeout(o, 100)
                  : s());
            },
            s = function () {
              i &&
                (i.img.off(".mfploader"),
                i === e.currItem &&
                  (e._onImageHasSize(i),
                  e.updateStatus("error", r.tError.replace("%url%", i.src))),
                (i.hasSize = !0),
                (i.loaded = !0),
                (i.loadError = !0));
            },
            r = e.st.image,
            d = a.find(".mfp-img");
          if (d.length) {
            var l = document.createElement("img");
            (l.className = "mfp-img"),
              i.el &&
                i.el.find("img").length &&
                (l.alt = i.el.find("img").attr("alt")),
              (i.img = t(l).on("load.mfploader", o).on("error.mfploader", s)),
              (l.src = i.src),
              d.is("img") && (i.img = i.img.clone()),
              (l = i.img[0]).naturalWidth > 0
                ? (i.hasSize = !0)
                : l.width || (i.hasSize = !1);
          }
          return (
            e._parseMarkup(
              a,
              {
                title: (function (i) {
                  if (i.data && void 0 !== i.data.title) return i.data.title;
                  var a = e.st.image.titleSrc;
                  if (a) {
                    if (t.isFunction(a)) return a.call(e, i);
                    if (i.el) return i.el.attr(a) || "";
                  }
                  return "";
                })(i),
                img_replaceWith: i.img,
              },
              i
            ),
            e.resizeImage(),
            i.hasSize
              ? (_ && clearInterval(_),
                i.loadError
                  ? (a.addClass("mfp-loading"),
                    e.updateStatus("error", r.tError.replace("%url%", i.src)))
                  : (a.removeClass("mfp-loading"), e.updateStatus("ready")),
                a)
              : (e.updateStatus("loading"),
                (i.loading = !0),
                i.hasSize ||
                  ((i.imgHidden = !0),
                  a.addClass("mfp-loading"),
                  e.findImageSize(i)),
                a)
          );
        },
      },
    });
    var $;
    t.magnificPopupT4s.registerModule("zoom", {
      options: {
        enabled: !1,
        easing: "ease-in-out",
        duration: 300,
        opener: function (t) {
          return t.is("img") ? t : t.find("img");
        },
      },
      proto: {
        initZoom: function () {
          var t,
            i = e.st.zoom,
            a = ".zoom";
          if (i.enabled && e.supportsTransition) {
            var n,
              o,
              s = i.duration,
              r = function (t) {
                var e = t
                    .clone()
                    .removeAttr("style")
                    .removeAttr("class")
                    .addClass("mfp-animated-image"),
                  a = "all " + i.duration / 1e3 + "s " + i.easing,
                  n = {
                    position: "fixed",
                    zIndex: 9999,
                    left: 0,
                    top: 0,
                    "-webkit-backface-visibility": "hidden",
                  },
                  o = "transition";
                return (
                  (n["-webkit-" + o] =
                    n["-moz-" + o] =
                    n["-o-" + o] =
                    n[o] =
                      a),
                  e.css(n),
                  e
                );
              },
              d = function () {
                e.content.css("visibility", "visible");
              };
            u("BuildControls" + a, function () {
              if (e._allowZoom()) {
                if (
                  (clearTimeout(n),
                  e.content.css("visibility", "hidden"),
                  !(t = e._getItemToZoom()))
                )
                  return void d();
                (o = r(t)).css(e._getOffset()),
                  e.wrap.append(o),
                  (n = setTimeout(function () {
                    o.css(e._getOffset(!0)),
                      (n = setTimeout(function () {
                        d(),
                          setTimeout(function () {
                            o.remove(), (t = o = null), p("ZoomAnimationEnded");
                          }, 16);
                      }, s));
                  }, 16));
              }
            }),
              u("BeforeClose" + a, function () {
                if (e._allowZoom()) {
                  if ((clearTimeout(n), (e.st.removalDelay = s), !t)) {
                    if (!(t = e._getItemToZoom())) return;
                    o = r(t);
                  }
                  o.css(e._getOffset(!0)),
                    e.wrap.append(o),
                    e.content.css("visibility", "hidden"),
                    setTimeout(function () {
                      o.css(e._getOffset());
                    }, 16);
                }
              }),
              u("Close" + a, function () {
                e._allowZoom() && (d(), o && o.remove(), (t = null));
              });
          }
        },
        _allowZoom: function () {
          return "image" === e.currItem.type;
        },
        _getItemToZoom: function () {
          return !!e.currItem.hasSize && e.currItem.img;
        },
        _getOffset: function (i) {
          var a,
            n = (a = i
              ? e.currItem.img
              : e.st.zoom.opener(e.currItem.el || e.currItem)).offset(),
            o = parseInt(a.css("padding-top"), 10),
            s = parseInt(a.css("padding-bottom"), 10);
          n.top -= t(window).scrollTop() - o;
          var r = {
            width: a.width(),
            height: (l ? a.innerHeight() : a[0].offsetHeight) - s - o,
          };
          return (
            void 0 === $ &&
              ($ = void 0 !== document.createElement("p").style.MozTransform),
            $
              ? (r["-moz-transform"] = r.transform =
                  "translate(" + n.left + "px," + n.top + "px)")
              : ((r.left = n.left), (r.top = n.top)),
            r
          );
        },
      },
    });
    var C = function (t) {
      if (e.currTemplate.iframe) {
        var i = e.currTemplate.iframe.find("iframe");
        i.length &&
          (t || (i[0].src = "//about:blank"),
          e.isIE8 && i.css("display", t ? "block" : "none"));
      }
    };
    t.magnificPopupT4s.registerModule("iframe", {
      options: {
        markup:
          '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
        srcAction: "iframe_src",
        patterns: {
          youtube: {
            index: "youtube.com",
            id: "v=",
            src: "//www.youtube.com/embed/%id%?autoplay=1",
          },
          vimeo: {
            index: "vimeo.com/",
            id: "/",
            src: "//player.vimeo.com/video/%id%?autoplay=1",
          },
          gmaps: { index: "//maps.google.", src: "%id%&output=embed" },
        },
      },
      proto: {
        initIframe: function () {
          e.types.push("iframe"),
            u("BeforeChange", function (t, e, i) {
              e !== i && ("iframe" === e ? C() : "iframe" === i && C(!0));
            }),
            u("Close.iframe", function () {
              C();
            });
        },
        getIframe: function (i, a) {
          var n = i.src,
            o = e.st.iframe;
          t.each(o.patterns, function () {
            if (n.indexOf(this.index) > -1)
              return (
                this.id &&
                  (n =
                    "string" == typeof this.id
                      ? n.substr(
                          n.lastIndexOf(this.id) + this.id.length,
                          n.length
                        )
                      : this.id.call(this, n)),
                (n = this.src.replace(/%id%/g, n)),
                !1
              );
          });
          var s = {};
          return (
            o.srcAction && (s[o.srcAction] = n),
            e._parseMarkup(a, s, i),
            e.updateStatus("ready"),
            a
          );
        },
      },
    });
    var k = function (t) {
        var i = e.items.length;
        return t > i - 1 ? t - i : t < 0 ? i + t : t;
      },
      I = function (t, e, i) {
        return t.replace(/%curr%/gi, e + 1).replace(/%total%/gi, i);
      };
    t.magnificPopupT4s.registerModule("gallery", {
      options: {
        enabled: !1,
        arrowMarkup:
          '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
        preload: [0, 2],
        navigateByImgClick: !0,
        arrows: !0,
        tPrev: "Previous (Left arrow key)",
        tNext: "Next (Right arrow key)",
        tCounter: "%curr% of %total%",
      },
      proto: {
        initGallery: function () {
          var i = e.st.gallery,
            n = ".mfp-gallery";
          if (((e.direction = !0), !i || !i.enabled)) return !1;
          (o += " mfp-gallery"),
            u("Open" + n, function () {
              i.navigateByImgClick &&
                e.wrap.on("click" + n, ".mfp-img", function () {
                  if (e.items.length > 1) return e.next(), !1;
                }),
                a.on("keydown" + n, function (t) {
                  37 === t.keyCode ? e.prev() : 39 === t.keyCode && e.next();
                });
            }),
            u("UpdateStatus" + n, function (t, i) {
              i.text && (i.text = I(i.text, e.currItem.index, e.items.length));
            }),
            u("MarkupParse" + n, function (t, a, n, o) {
              var s = e.items.length;
              n.counter = s > 1 ? I(i.tCounter, o.index, s) : "";
            }),
            u("BuildControls" + n, function () {
              if (e.items.length > 1 && i.arrows && !e.arrowLeft) {
                var a = i.arrowMarkup,
                  n = (e.arrowLeft = t(
                    a.replace(/%title%/gi, i.tPrev).replace(/%dir%/gi, "left")
                  ).addClass("mfp-prevent-close")),
                  o = (e.arrowRight = t(
                    a.replace(/%title%/gi, i.tNext).replace(/%dir%/gi, "right")
                  ).addClass("mfp-prevent-close"));
                n.click(function () {
                  e.prev();
                }),
                  o.click(function () {
                    e.next();
                  }),
                  e.container.append(n.add(o));
              }
            }),
            u("Change" + n, function () {
              e._preloadTimeout && clearTimeout(e._preloadTimeout),
                (e._preloadTimeout = setTimeout(function () {
                  e.preloadNearbyImages(), (e._preloadTimeout = null);
                }, 16));
            }),
            u("Close" + n, function () {
              a.off(n),
                e.wrap.off("click" + n),
                (e.arrowRight = e.arrowLeft = null);
            });
        },
        next: function () {
          (e.direction = !0), (e.index = k(e.index + 1)), e.updateItemHTML();
        },
        prev: function () {
          (e.direction = !1), (e.index = k(e.index - 1)), e.updateItemHTML();
        },
        goTo: function (t) {
          (e.direction = t >= e.index), (e.index = t), e.updateItemHTML();
        },
        preloadNearbyImages: function () {
          var t,
            i = e.st.gallery.preload,
            a = Math.min(i[0], e.items.length),
            n = Math.min(i[1], e.items.length);
          for (t = 1; t <= (e.direction ? n : a); t++)
            e._preloadItem(e.index + t);
          for (t = 1; t <= (e.direction ? a : n); t++)
            e._preloadItem(e.index - t);
        },
        _preloadItem: function (i) {
          if (((i = k(i)), !e.items[i].preloaded)) {
            var a = e.items[i];
            a.parsed || (a = e.parseEl(i)),
              p("LazyLoad", a),
              "image" === a.type &&
                (a.img = t('<img class="mfp-img" />')
                  .on("load.mfploader", function () {
                    a.hasSize = !0;
                  })
                  .on("error.mfploader", function () {
                    (a.hasSize = !0), (a.loadError = !0), p("LazyLoadError", a);
                  })
                  .attr("src", a.src)),
              (a.preloaded = !0);
          }
        },
      },
    }),
      t.magnificPopupT4s.registerModule("retina", {
        options: {
          replaceSrc: function (t) {
            return t.src.replace(/\.\w+$/, function (t) {
              return "@2x" + t;
            });
          },
          ratio: 1,
        },
        proto: {
          initRetina: function () {
            if (window.devicePixelRatio > 1) {
              var t = e.st.retina,
                i = t.ratio;
              (i = isNaN(i) ? i() : i) > 1 &&
                (u("ImageHasSize.retina", function (t, e) {
                  e.img.css({
                    "max-width": e.img[0].naturalWidth / i,
                    width: "100%",
                  });
                }),
                u("ElementParse.retina", function (e, a) {
                  a.src = t.replaceSrc(a, i);
                }));
            }
          },
        },
      }),
      m();
  });
var fastdomT4s = createCommonjsModule(function (t) {
    !(function (e) {
      function i() {
        (this.reads = []), (this.writes = []), (this.raf = r.bind(e));
      }
      function a(t) {
        t.scheduled ||
          ((t.scheduled = !0),
          t.raf(
            function (t) {
              var e,
                i = t.writes,
                o = t.reads;
              try {
                s("flushing reads", o.length),
                  n(o),
                  s("flushing writes", i.length),
                  n(i);
              } catch (t) {
                e = t;
              }
              (t.scheduled = !1), (o.length || i.length) && a(t);
              if (e) {
                if ((s("task errored", e.message), !t.catch)) throw e;
                t.catch(e);
              }
            }.bind(null, t)
          ));
      }
      function n(t) {
        for (var e; (e = t.shift()); ) e();
      }
      function o(t, e) {
        var i = t.indexOf(e);
        return !!~i && !!t.splice(i, 1);
      }
      var s = function () {},
        r =
          e.requestAnimationFrame ||
          e.webkitRequestAnimationFrame ||
          e.mozRequestAnimationFrame ||
          e.msRequestAnimationFrame ||
          function (t) {
            return setTimeout(t, 16);
          };
      i.prototype = {
        constructor: i,
        measure: function (t, e) {
          var i = e ? t.bind(e) : t;
          return this.reads.push(i), a(this), i;
        },
        mutate: function (t, e) {
          var i = e ? t.bind(e) : t;
          return this.writes.push(i), a(this), i;
        },
        clear: function (t) {
          return o(this.reads, t) || o(this.writes, t);
        },
        extend: function (t) {
          if ("object" != _typeof(t)) throw new Error("expected object");
          var e = Object.create(this);
          return (
            (function (t, e) {
              for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i]);
            })(e, t),
            (e.fastdom = this),
            e.initialize && e.initialize(),
            e
          );
        },
        catch: null,
      };
      var d = (e.fastdom = e.fastdom || new i());
      t.exports = d;
    })("undefined" != typeof window ? window : commonjsGlobal);
  }),
  smoothscroll = createCommonjsModule(function (t, e) {
    !(function () {
      function e() {
        function t(t, e) {
          (this.scrollLeft = t), (this.scrollTop = e);
        }
        function e(t) {
          if (
            null === t ||
            "object" !== _typeof(t) ||
            void 0 === t.behavior ||
            "auto" === t.behavior ||
            "instant" === t.behavior
          )
            return !0;
          if ("object" === _typeof(t) && "smooth" === t.behavior) return !1;
          throw new TypeError(
            "behavior member of ScrollOptions " +
              t.behavior +
              " is not a valid value for enumeration ScrollBehavior."
          );
        }
        function i(t, e) {
          return "Y" === e
            ? t.clientHeight + p < t.scrollHeight
            : "X" === e
            ? t.clientWidth + p < t.scrollWidth
            : void 0;
        }
        function a(t, e) {
          var i = r.getComputedStyle(t, null)["overflow" + e];
          return "auto" === i || "scroll" === i;
        }
        function n(t) {
          var e = i(t, "Y") && a(t, "Y"),
            n = i(t, "X") && a(t, "X");
          return e || n;
        }
        function o(t) {
          var e,
            i,
            a,
            n = (f() - t.startTime) / c;
          (e = (function (t) {
            return 0.5 * (1 - Math.cos(Math.PI * t));
          })((n = n > 1 ? 1 : n))),
            (i = t.startX + (t.x - t.startX) * e),
            (a = t.startY + (t.y - t.startY) * e),
            t.method.call(t.scrollable, i, a),
            (i === t.x && a === t.y) || r.requestAnimationFrame(o.bind(r, t));
        }
        function s(e, i, a) {
          var n,
            s,
            l,
            c,
            p = f();
          e === d.body
            ? ((n = r),
              (s = r.scrollX || r.pageXOffset),
              (l = r.scrollY || r.pageYOffset),
              (c = u.scroll))
            : ((n = e), (s = e.scrollLeft), (l = e.scrollTop), (c = t)),
            o({
              scrollable: n,
              method: c,
              startTime: p,
              startX: s,
              startY: l,
              x: i,
              y: a,
            });
        }
        var r = window,
          d = document;
        if (
          !(
            "scrollBehavior" in d.documentElement.style &&
            !0 !== r.__forceSmoothScrollPolyfill__
          )
        ) {
          var l = r.HTMLElement || r.Element,
            c = 468,
            u = {
              scroll: r.scroll || r.scrollTo,
              scrollBy: r.scrollBy,
              elementScroll: l.prototype.scroll || t,
              scrollIntoView: l.prototype.scrollIntoView,
            },
            f =
              r.performance && r.performance.now
                ? r.performance.now.bind(r.performance)
                : Date.now,
            p = (function (t) {
              return new RegExp(["MSIE ", "Trident/", "Edge/"].join("|")).test(
                t
              );
            })(r.navigator.userAgent)
              ? 1
              : 0;
          (r.scroll = r.scrollTo =
            function () {
              void 0 !== arguments[0] &&
                (!0 !== e(arguments[0])
                  ? s.call(
                      r,
                      d.body,
                      void 0 !== arguments[0].left
                        ? ~~arguments[0].left
                        : r.scrollX || r.pageXOffset,
                      void 0 !== arguments[0].top
                        ? ~~arguments[0].top
                        : r.scrollY || r.pageYOffset
                    )
                  : u.scroll.call(
                      r,
                      void 0 !== arguments[0].left
                        ? arguments[0].left
                        : "object" !== _typeof(arguments[0])
                        ? arguments[0]
                        : r.scrollX || r.pageXOffset,
                      void 0 !== arguments[0].top
                        ? arguments[0].top
                        : void 0 !== arguments[1]
                        ? arguments[1]
                        : r.scrollY || r.pageYOffset
                    ));
            }),
            (r.scrollBy = function () {
              void 0 !== arguments[0] &&
                (e(arguments[0])
                  ? u.scrollBy.call(
                      r,
                      void 0 !== arguments[0].left
                        ? arguments[0].left
                        : "object" !== _typeof(arguments[0])
                        ? arguments[0]
                        : 0,
                      void 0 !== arguments[0].top
                        ? arguments[0].top
                        : void 0 !== arguments[1]
                        ? arguments[1]
                        : 0
                    )
                  : s.call(
                      r,
                      d.body,
                      ~~arguments[0].left + (r.scrollX || r.pageXOffset),
                      ~~arguments[0].top + (r.scrollY || r.pageYOffset)
                    ));
            }),
            (l.prototype.scroll = l.prototype.scrollTo =
              function () {
                if (void 0 !== arguments[0])
                  if (!0 !== e(arguments[0])) {
                    var t = arguments[0].left,
                      i = arguments[0].top;
                    s.call(
                      this,
                      this,
                      void 0 === t ? this.scrollLeft : ~~t,
                      void 0 === i ? this.scrollTop : ~~i
                    );
                  } else {
                    if (
                      "number" == typeof arguments[0] &&
                      void 0 === arguments[1]
                    )
                      throw new SyntaxError("Value could not be converted");
                    u.elementScroll.call(
                      this,
                      void 0 !== arguments[0].left
                        ? ~~arguments[0].left
                        : "object" !== _typeof(arguments[0])
                        ? ~~arguments[0]
                        : this.scrollLeft,
                      void 0 !== arguments[0].top
                        ? ~~arguments[0].top
                        : void 0 !== arguments[1]
                        ? ~~arguments[1]
                        : this.scrollTop
                    );
                  }
              }),
            (l.prototype.scrollBy = function () {
              void 0 !== arguments[0] &&
                (!0 !== e(arguments[0])
                  ? this.scroll({
                      left: ~~arguments[0].left + this.scrollLeft,
                      top: ~~arguments[0].top + this.scrollTop,
                      behavior: arguments[0].behavior,
                    })
                  : u.elementScroll.call(
                      this,
                      void 0 !== arguments[0].left
                        ? ~~arguments[0].left + this.scrollLeft
                        : ~~arguments[0] + this.scrollLeft,
                      void 0 !== arguments[0].top
                        ? ~~arguments[0].top + this.scrollTop
                        : ~~arguments[1] + this.scrollTop
                    ));
            }),
            (l.prototype.scrollIntoView = function () {
              if (!0 !== e(arguments[0])) {
                var t = (function (t) {
                    for (; t !== d.body && !1 === n(t); )
                      t = t.parentNode || t.host;
                    return t;
                  })(this),
                  i = t.getBoundingClientRect(),
                  a = this.getBoundingClientRect();
                t !== d.body
                  ? (s.call(
                      this,
                      t,
                      t.scrollLeft + a.left - i.left,
                      t.scrollTop + a.top - i.top
                    ),
                    "fixed" !== r.getComputedStyle(t).position &&
                      r.scrollBy({
                        left: i.left,
                        top: i.top,
                        behavior: "smooth",
                      }))
                  : r.scrollBy({
                      left: a.left,
                      top: a.top,
                      behavior: "smooth",
                    });
              } else
                u.scrollIntoView.call(
                  this,
                  void 0 === arguments[0] || arguments[0]
                );
            });
        }
      }
      t.exports = { polyfill: e };
    })();
  });
!(function (t) {
  "use strict";
  function e(e) {
    var i = e.find(".t4s-product__media-item:not(.is--media-hide)"),
      a = i.length;
    (4 == a || a > 5) && (a = "normal"),
      e.attr("data-media-sizes", a),
      e
        .find(".t4s-product__media-item:not(.is--media-hide):last")
        .addClass("is--media-last"),
      e.find(".t4s-product__media-item").attr("data-index", ""),
      i.each(function (e) {
        t(this).attr("data-index", e);
      });
  }
  function i(t) {
    return JSON.parse(t || "{}");
  }
  var a = t(window),
    n = t(document),
    o = a.width(),
    s = t("html"),
    r = t("body"),
    d = o < 768,
    l = o <= 1024,
    c = window.T4Srequest.design_mode,
    u = window.T4Sstrings,
    f = T4SThemeSP.cacheNameFirst,
    p = !!(
      "ontouchstart" in window ||
      (window.DocumentTouch && window.document instanceof DocumentTouch) ||
      window.navigator.maxTouchPoints ||
      window.navigator.msMaxTouchPoints
    );
  (T4SThemeSP.isHover = s.hasClass("t4sp-hover")),
    (T4SThemeSP.isTouch = p && (!T4SThemeSP.isHover || l)),
    document.addEventListener("theme:hover", function (t) {
      (T4SThemeSP.isHover = !0), (T4SThemeSP.isTouch = !1);
    }),
    (T4SThemeSP.getToFetchSection = function (t, e = "text", i = null) {
      let a = t ? T4SThemeSP.root_url + t : i;
      return fetch(a, {
        method: "GET",
        headers: { "Cache-Control": "no-cache" },
      })
        .then((t) =>
          t.redirected ? "NVT_94" : "text" == e ? t.text() : t.json()
        )
        .then((t) => t)
        .catch((t) => (console.warn(t), "NVT_94"));
    }),
    (T4SThemeSP.OverflowScroller = (function () {
      function t(t, e) {
        (!t && o > 767) ||
          ((this.element = t),
          (this.options = e),
          (this.lastKnownY = window.scrollY),
          (this.currentTop = 0),
          (this.initialTopOffset =
            e.offsetTop || parseInt(window.getComputedStyle(this.element).top)),
          this._attachListeners(),
          e.updateOffsetTop &&
            ((this.initialTopOffsetCache = this.initialTopOffset),
            this._updateInitialTopOffset()));
      }
      return (
        (t.prototype = Object.assign({}, t.prototype, {
          _updateInitialTopOffset: function () {
            window.addEventListener("T4sHeaderReveal", function () {
              this.initialTopOffset = this.initialTopOffsetCache;
            }),
              window.addEventListener("T4sHeaderHide", function () {
                this.initialTopOffset = 30;
              });
          },
          _attachListeners: function () {
            (this._checkPositionListener = this._checkPosition.bind(this)),
              window.addEventListener("scroll", this._checkPositionListener);
          },
          _checkPosition: function () {
            var t = this;
            fastdomT4s.measure(function () {
              var e =
                  t.element.getBoundingClientRect().top +
                  window.scrollY -
                  t.element.offsetTop +
                  t.initialTopOffset,
                i =
                  t.element.clientHeight -
                  window.innerHeight +
                  (t.options.offsetBottom || 0);
              window.scrollY < t.lastKnownY
                ? (t.currentTop -= window.scrollY - t.lastKnownY)
                : (t.currentTop += t.lastKnownY - window.scrollY),
                (t.currentTop = Math.min(
                  Math.max(t.currentTop, -i),
                  e,
                  t.initialTopOffset
                )),
                (t.lastKnownY = window.scrollY);
            }),
              fastdomT4s.mutate(function () {
                t.element.style.top = "".concat(t.currentTop, "px");
              });
          },
          destroy: function () {
            window.removeEventListener("scroll", this._checkPositionListener);
          },
        })),
        t
      );
    })());
  var h = (function () {
      function a(e) {
        (this.$container = e.$container),
          (this.variants = e.variants),
          (this.productOptions = e.productOptions),
          (this.productOptionSize = e.PrOptionsSize),
          (this.formSelectorId = e.formSelectorId),
          (this.$formSelectorId = t(this.formSelectorId)),
          (this.$originalSelectorId = e.$originalSelectorId),
          (this.originalSelectorId = this.$originalSelectorId[0]),
          (this.enableHistoryState = e.enableHistoryState),
          (this.removeSoldout = e.removeSoldout),
          (this.$options1 = e.$options1),
          (this.$options2 = e.$options2),
          (this.$options3 = e.$options3),
          (this.isNoPick = e.isNoPick),
          (this.isNoPickOriginal = e.isNoPick),
          (this.hasSoldoutUnavailable = e.hasSoldoutUnavailable),
          (this.canMediaGroup = e.canMediaGroup),
          (this.badgesConfigs = e.badgesConfigs),
          (this.$variantImg = e.$variantImg),
          (this.disableVariantImage = e.disableVariantImage),
          (this.swatchWidth = e.swatchWidth),
          (this.$incomingMess = this.$formSelectorId.find(
            "[data-incoming__mess"
          )),
          (this.isSticky = e.isSticky),
          (this.useStickySelect = e.useStickySelect),
          (this.isMainProduct = e.isMainProduct),
          (this.$quantity = this.$formSelectorId.find("[data-quantity-value")),
          (this.$mainMedia = this.$container.find("[data-main-media]")),
          (this.$mainNav = this.$container.find(".t4s-carousel__nav")),
          (this.clickedOptions = []),
          (this.showFirstMedia = !this.isNoPickOriginal && e.showFirstMedia),
          (this.oldVariant = {}),
          (this.currentVariant = {}),
          (this.mediaID = 0),
          (this.eventClickedSwatch = !1),
          (this.variantState = {
            available: !0,
            soldOut: !1,
            onSale: !1,
            preOrder: !1,
            showUnitPrice: !1,
          }),
          (this.$productPrice = this.$container.find("[data-product-price]")),
          (this.formartPrice =
            "ins-del" == this.$productPrice.data("formartPrice")
              ? "<ins>money_ins</ins> <del>money_del</del>"
              : "<del>money_del</del> <ins>money_ins</ins>"),
          (this.saletype = this.$productPrice.data("saletype"));
        let i = this.$container.find("[data-product-unit-price]");
        (this.$unit_price = i.find("[data-unit-price]")),
          (this.$unit_base = i.find("[data-unit-base]"));
        let a = this.$container.find("[data-product-single-badge]"),
          n = this.badgesConfigs.texts,
          o = this.badgesConfigs.saleStyle;
        if (
          ((this.badgeSelector = {
            $onSale: a.find("[data-badge-sale]"),
            $preOrder: a.find("[data-badge-preorder]"),
            $soldOut: a.find("[data-badge-soldout]"),
          }),
          (this.saleLabel = "2" == o ? n.SavePercent : n.sale),
          (this.useComingMess = !1),
          this.$incomingMess[0] &&
            ((this.useComingMess = !0),
            (this.$incomingAvailable = this.$incomingMess.find(
              "[data-incoming-available]"
            )),
            (this.$incomingSoldout = this.$incomingMess.find(
              "[data-incoming-soldout]"
            )),
            (this.$incomingAvailableDate = this.$incomingAvailable.find(
              "[data-incoming-date]"
            )),
            (this.$incomingSoldoutDate = this.$incomingSoldout.find(
              "[data-incoming-date]"
            ))),
          (this.$addToCartButton = this.formSelectorId.find(
            '[type="submit"][name="add"]'
          )),
          (this.$quantityWrapper = this.formSelectorId.find(
            "[data-quantity-wrapper]"
          )),
          (this.$paymentButton = this.formSelectorId.find(
            ".shopify-payment-button"
          )),
          (this.$addToCartButtonText =
            this.$addToCartButton.find(".t4s-btn-atc_text")),
          this.isSticky)
        ) {
          let e = t("[data-sticky-addtocart]");
          (this.$stickyimg = e.find("[data-sticky-img] img")),
            (this.$stickyVtitle = e.find("[data-sticky-v-title]")),
            (this.$stickyPrice = e.find("[data-sticky-price]")),
            (this.$stickyATC = e.find("[data-action-atc]")),
            (this.$stickyATCText = this.$stickyATC.find(".t4s-btn-atc_text")),
            (this.$stickySelect = e.find("[data-sticky-select]")),
            (this.stickyImgOrginal = this.$stickyimg.data("orginal")),
            (this.$stickyQuantityWrapper = e.find("[data-quantity-wrapper]")),
            (this.$stickyQuantity = this.$stickyQuantityWrapper.find(
              "[data-quantity-value]"
            )),
            (this.isStickyChanging = !1);
          (s = this).$stickySelect.on("change:drop", function (t, e, i) {
            (s.eventClickedSwatch = !1),
              (s.isStickyChanging = !0),
              (s.originalSelectorId.value = i),
              s.originalSelectorId.dispatchEvent(
                new Event("change", { bubbles: !0, cancelable: !0 })
              );
          });
        }
        if (
          (T4SThemeSP.isEditCartReplace &&
            ((this.txt_addToCart = h), (this.txt_preOrder = m)),
          (this.unQuickShopInline = e.unQuickShopInline),
          (this.isQuickShopForm = e.isQuickShopForm),
          (this.$imgMainItem = this.$container.find("[data-main-img-change]")),
          e.unQuickShopInline)
        )
          this.originalSelectorId.addEventListener(
            "change",
            this._onSelectChange.bind(this)
          ),
            this._updateSwatchFromSizeOne(),
            this.isNoPick
              ? (this.currentVariant = this._getVariantFromVariantid())
              : this.originalSelectorId.dispatchEvent(
                  new Event("change", { bubbles: !0, cancelable: !0 })
                );
        else {
          var s = this;
          s.$container.one("replace:btnAtc", function () {
            (s.$addToCartButton = s.$container.find(".t4s-pr-addtocart")),
              (s.$quantityWrapper = s.$container.find(
                "[data-quantity-wrapper]"
              )),
              (s.$addToCartButtonText =
                s.$addToCartButton.find(".t4s-text-pr"));
          }),
            (a = s.$container.find("[data-product-badge]")),
            (s.badgeSelector = {
              $onSale: a.find("[data-badge-sale]"),
              $preOrder: a.find("[data-badge-preorder]"),
              $soldOut: a.find("[data-badge-soldout]"),
            }),
            (s.$dataHref = s.$container.find("[data-pr-href]")),
            (s.productHref = s.$dataHref.attr("href")),
            (s.currentVariant = s._getVariantFromVariantid()),
            s.$originalSelectorId.on(
              "change",
              s._onQuickShopInlineChange.bind(s)
            ),
            s._updateSwatchFromSizeOne();
        }
      }
      function n(t) {
        return t ? d : s;
      }
      var o = "[data-swatch-item]",
        s = "is--unavailable",
        d = "is--soldout " + s,
        l = window.T4SProductStrings,
        c = l.unavailable,
        u = l.addToCart,
        f = l.soldOut,
        p = l.preOrder,
        u = l.addToCart,
        h = l.replace_qs_atc,
        m = l.replace_qs_pre,
        g = l.badgeSavePercent2,
        v = l.badgeSaveFixed2,
        y = { disabled: "aria-disabled" };
      return (
        (a.prototype = Object.assign({}, a.prototype, {
          _onSelectChange: function () {
            this.eventClickedSwatch || (this.oldVariant = this.currentVariant);
            var t = this.eventClickedSwatch
              ? this.currentVariant
              : this._getVariantFromVariantid();
            this._setVariantState(t),
              this._updateSwatchSelector(
                t,
                this.oldVariant,
                this.formSelectorId,
                this.hasSoldoutUnavailable
              ),
              this._updatePrice(t, this.oldVariant, this.$container),
              this._updateAddToCartButton(
                t,
                this.oldVariant,
                this.$addToCartButton,
                this.$quantityWrapper,
                this.$paymentButton,
                this.$addToCartButtonText
              ),
              this._updateAvailability(t, this.oldVariant, this.$container),
              this._updateSKU(t, this.oldVariant, this.$container),
              this._updateBarcode(t, this.oldVariant, this.$container),
              this._updateMetafield(t, this.oldVariant, this.$container),
              this._updateDelivery(t, this.oldVariant, this.$container),
              this._updateInventoryQuantity(
                t,
                this.oldVariant,
                this.$container
              ),
              this._updatePickupAvailabilityContent(t, this.$container),
              this._updateNotifyBackinStock(t, this.$container),
              this._updateBadges(),
              this._updateIncomingMess(t),
              t &&
                ((this.currentVariant = t),
                this.canMediaGroup &&
                  this._updateMediaFilter(t, this.oldVariant, this.$container),
                this._updateMedia(t, this.oldVariant, this.$container),
                this._updateQuantity(t),
                this.disableVariantImage || this._updateVariantImageSwatch(t),
                this.isSticky && this._updateStickyATC(t),
                this.enableHistoryState && this._updateHistoryState(t),
                this.$container.trigger({
                  type: "variant:changed",
                  currentVariant: t,
                  oldVariant: this.oldVariant,
                }));
          },
          _onQuickShopInlineChange: function () {
            (this.notSelected = !0),
              this.eventClickedSwatch ||
                (this.oldVariant = this.currentVariant);
            var t = this.eventClickedSwatch
              ? this.currentVariant
              : this._getVariantFromVariantid();
            this._setVariantState(t),
              this._updateSwatchSelector(
                t,
                this.oldVariant,
                this.formSelectorId,
                this.hasSoldoutUnavailable
              ),
              this._updatePrice(t, this.oldVariant, this.$container),
              this._updateAtcBtnQSInline(
                t,
                this.oldVariant,
                this.$addToCartButton,
                this.$quantityWrapper,
                this.$addToCartButtonText
              ),
              this._updateBadges(),
              t &&
                ((this.currentVariant = t),
                this._updateMedia(t, this.oldVariant, this.$container),
                this._updateQuantity(t),
                this.$dataHref.attr(
                  "href",
                  this._getUrlWithVariant(this.productHref, t.id)
                ),
                this.disableVariantImage || this._updateVariantImageSwatch(t),
                this.$container.trigger({
                  type: "variant:changed",
                  currentVariant: t,
                  oldVariant: this.oldVariant,
                }));
          },
          _getVariantFromOptions: function () {
            var t = this.clickedOptions;
            return (
              this.variants.find(function (e) {
                return t.every(function (t) {
                  return e[t.index] === t.value;
                });
              }) || "nathan"
            );
          },
          _getVariantFromSize: function () {
            var e,
              i = this.variants,
              a = this.productOptionSize,
              n = this.removeSoldout,
              o = this.clickedOptions[0].value,
              s = this.clickedOptions[1],
              r = (this.clickedOptions[2], this.clickedCurrentValue),
              d = this.clickedCurrentIndex;
            return (
              1 == a
                ? (e = t.grep(i, function (t, e) {
                    return t.available;
                  }))
                : (3 == a) & n
                ? ((s = s.value),
                  (e = t.grep(i, function (t, e) {
                    return t.option1 == o && t.option2 == s && t.available;
                  }))[0] ||
                    (e = t.grep(i, function (t, e) {
                      return t.available && t[d] == r;
                    })))
                : n
                ? (e = t.grep(i, function (t, e) {
                    return t.option1 == o && t.available;
                  }))[0] ||
                  (e = t.grep(i, function (t, e) {
                    return t.available && t[d] == r;
                  }))
                : 3 == a
                ? ((s = s.value),
                  (e = t.grep(i, function (t, e) {
                    return t.option1 == o && t.option2 == s;
                  }))[0] ||
                    (e = t.grep(i, function (t, e) {
                      return t[d] == r;
                    })))
                : (e = t.grep(i, function (t, e) {
                    return t.option1 == o;
                  }))[0] ||
                  (e = t.grep(i, function (t, e) {
                    return t[d] == r;
                  })),
              e[0]
            );
          },
          _getVariantFromVariantid: function () {
            var t = [],
              e = this.variants,
              i = e.length,
              a = this.$originalSelectorId.val();
            for (let n = 0; n < i; n++)
              if (e[n].id == a) {
                t[0] = e[n];
                break;
              }
            return t[0] || null;
          },
          _getVariantFromOptionIndex: function (e, i) {
            var a,
              n = this.variants,
              o = i.option1,
              s = i.option2,
              r = i.option3;
            switch (e) {
              case 1:
                a = t.grep(n, function (t, e) {
                  return t.option1 == o;
                });
                break;
              case 2:
                a = t.grep(n, function (t, e) {
                  return t.option2 == s;
                });
                break;
              case 3:
                a = t.grep(n, function (t, e) {
                  return t.option3 == r;
                });
                break;
              case 1.2:
                a = t.grep(n, function (t, e) {
                  return t.option1 == o && t.option2 == s;
                });
                break;
              default:
                a = t.grep(n, function (t, e) {
                  return 0 == t.available;
                });
            }
            return a || "nathan";
          },
          _updateMediaFilterNoPick: function () {
            if (
              this.clickedCurrentValue &&
              this.clickedCurrentIndex &&
              this.canMediaGroup
            ) {
              var t = this.clickedCurrentIndex.replace("option", ""),
                i = this.productOptions[parseInt(t) - 1].name || "not4s",
                a = this.clickedCurrentValue || "not4s",
                n = this.$mainMedia,
                o = this.$mainNav,
                s = `[data-grname="${(i + "").toLowerCase()}"][data-grpvl="${(
                  a + ""
                ).toLowerCase()}"]`,
                r = n.find(s),
                d = o.find(s);
              0 != r.length &&
                (n.find("[data-main-slide]").addClass("is--media-hide"),
                r.removeClass("is--media-hide"),
                o.find(".t4s-carousel__nav-item").addClass("is--media-hide"),
                d.removeClass("is--media-hide"),
                n.hasClass("flickityt4s-enabled")
                  ? (n.trigger("update.flickityt4s"),
                    d.hasClass("is-nav-selected") ||
                      d.first().addClass("is-nav-selected"))
                  : n.hasClass("isotopet4s-enabled") && (e(n), n.isotopet4s()));
            }
          },
          _updateSwatchFromSizeOne: function () {
            var t,
              e = this,
              i = e.variants,
              a = i.length,
              n = !1,
              o = 0,
              s = e.productOptionSize,
              r = e.productOptions;
            if (3 == s)
              var d = r[0].values.length,
                l = r[1].values.length,
                c = r[2].values.length;
            else if (2 == s)
              var d = r[0].values.length,
                l = r[1].values.length;
            if (
              (s < 2
                ? ((n = 1), (t = e.$options1))
                : 2 == s && 1 == d
                ? ((n = 1), (t = e.$options2), (o = 1))
                : 2 == s && 1 == l
                ? ((n = 1), (t = e.$options1))
                : 3 == s && 1 == d && 1 == l
                ? ((n = 1), (t = e.$options3), (o = 2))
                : 3 == s && 1 == d && 1 == c
                ? ((n = 1), (t = e.$options2), (o = 1))
                : 3 == s && 1 == l && 1 == c
                ? ((n = 1), (t = e.$options1))
                : 3 == s && 1 == c && (n = 2),
              e.hasSoldoutUnavailable)
            ) {
              let t = r[o].values,
                n = t.length,
                s = e[`$options${o + 1}`].find("[data-swatch-item]");
              for (let e = 0; e < n; e++) {
                let n = !0,
                  r = t[e];
                for (let t = 0; t < a; t++) {
                  let e = i[t];
                  if (e.options[o] == r && e.available) {
                    n = !1;
                    break;
                  }
                }
                n && s.eq(e).addClass("is--soldout");
              }
            }
            (e.getProductSize = n),
              (e.$optionsOne = t),
              (e.$optionsOneIndex = o);
          },
          _updateMediaFilter: function (t, i, a) {
            if (this.currentVariant && this.canMediaGroup) {
              var n,
                o,
                s,
                r,
                d,
                l = this.productOptions,
                c = this.productOptionSize,
                u = this.currentVariant,
                f = this.$mainMedia,
                p = this.$mainNav;
              for (let t = 0; t < c; t++)
                if (
                  ((r = l[t].name || "not4s"),
                  0 !=
                    f.find(`[data-grname="${(r + "").toLowerCase()}"]`).length)
                ) {
                  (d = u.options[t] + ""),
                    (n = `[data-grname="${(
                      r + ""
                    ).toLowerCase()}"][data-grpvl="${d.toLowerCase()}"]`);
                  break;
                }
              if (
                ((o = f.find(n)),
                (s = p.find(n)),
                0 != o.length && d != this.groupValue)
              )
                if (
                  ((this.groupValue = d),
                  f.find("[data-main-slide]").addClass("is--media-hide"),
                  o.removeClass("is--media-hide"),
                  p.find(".t4s-carousel__nav-item").addClass("is--media-hide"),
                  s.removeClass("is--media-hide"),
                  f.hasClass("flickityt4s-enabled"))
                ) {
                  if ((f.trigger("update.flickityt4s"), t.featured_media))
                    var h = f
                      .find(`[data-media-id="${t.featured_media.id}"`)
                      .index();
                  f.flickityt4s("selectCell", h, !1, !1);
                } else
                  f.hasClass("isotopet4s-enabled") && (e(f), f.isotopet4s());
            }
          },
          _updateSwatchSelector: function (t, e, i, a) {
            var r,
              l,
              c,
              u,
              f,
              p,
              h,
              m = this,
              g = 1,
              v = m.$options1,
              y = m.$options2,
              b = m.$options3,
              S = m.getProductSize || m.productOptionSize,
              w = [],
              T = 0,
              _ = t.option1,
              $ = t.option2,
              C = t.option3,
              k = [],
              I = [],
              x = [];
            if (
              (i.find(".is--selected").removeClass("is--selected"),
              i.find("[data-current-value]").html(""),
              (k = m.productOptions[0].values),
              v.find("[data-current-value]").html(_),
              v.find(o).eq(k.indexOf(_)).addClass("is--selected"),
              y[0] &&
                ((I = m.productOptions[1].values),
                y.find("[data-current-value]").html($),
                y.find(o).eq(I.indexOf($)).addClass("is--selected")),
              b[0] &&
                ((x = m.productOptions[2].values),
                b.find("[data-current-value]").html(C),
                b.find(o).eq(x.indexOf(C)).addClass("is--selected")),
              a)
            )
              switch (S) {
                case 3:
                  for (
                    1 == x.length
                      ? ((r = v),
                        (l = k),
                        (c = "option3"),
                        (u = C),
                        (f = "option1"),
                        (g = 3))
                      : ((r = b),
                        (l = x),
                        (c = "option1"),
                        (u = _),
                        (f = "option3")),
                      T = (w = this._getVariantFromOptionIndex(g, t)).length,
                      r.find(o).addClass(d),
                      y.find(o).addClass(d),
                      h = 0;
                    h < T;
                    h++
                  )
                    (p = w[h])[c] == u &&
                      (p.available
                        ? (y.find(o).eq(I.indexOf(p.option2)).removeClass(d),
                          p.option2 == $ &&
                            r.find(o).eq(l.indexOf(p[f])).removeClass(d))
                        : (y.find(o).eq(I.indexOf(p.option2)).removeClass(s),
                          p.option2 == $ &&
                            r.find(o).eq(l.indexOf(p[f])).removeClass(s)));
                  break;
                case 2:
                  for (
                    T = (w = this._getVariantFromOptionIndex(1, t)).length,
                      y.find(o).addClass(d),
                      h = 0;
                    h < T;
                    h++
                  )
                    (p = w[h]).option1 == _ &&
                      y
                        .find(o)
                        .eq(I.indexOf(p.option2))
                        .removeClass(n(p.available));
                  break;
                default:
                  m.removeSoldout &&
                    m.$optionsOne.find(".is--selected").is(":hidden") &&
                    m.$optionsOne
                      .find("[data-swatch-item]:visible:first")
                      .trigger("click");
              }
          },
          _updateMetafield: function (e, i, a) {
            e &&
              e.id != i.id &&
              (a.find("[data-variant-toggle]").hide(),
              a.find(`[data-variant-toggle="${e.id}"]`).show(),
              this.isMainProduct &&
                (t("[data-variant-tab][data-variant-toggle]").hide(),
                t(`[data-variant-tab][data-variant-toggle="${e.id}"]`).show()));
          },
          _updateMedia: function (t, e, i) {
            if (
              t.featured_media &&
              JSON.stringify(t.featured_media) !==
                JSON.stringify(e.featured_media) &&
              !this.showFirstMedia
            ) {
              if (!this.unQuickShopInline || this.isQuickShopForm) {
                let e = t.featured_media.preview_image,
                  i = !0,
                  a =
                    this.$imgMainItem.hasClass("lazyloadt4sed") && i ? 0 : 100;
                return (
                  setTimeout(
                    function () {
                      this.$imgMainItem.attr(
                        "srcset",
                        T4SThemeSP.Images.getNewImageUrl(e.src, 1)
                      ),
                        (i = !1);
                    }.bind(this),
                    a
                  ),
                  void (
                    this.notSelected &&
                    (this.$container.addClass("t4s-colors-selected"),
                    (this.notSelected = !1))
                  )
                );
              }
              this.mediaID = t.featured_media.id;
              var a = i.find("[data-main-media]");
              if (a.hasClass("flickityt4s-enabled")) {
                var n = a
                  .find('[data-media-id="' + this.mediaID + '"]')
                  .index();
                a.flickityt4s("select", n, !1, !0),
                  (this.eventClickedSwatch = !1);
              } else if (!a.hasClass("t4s-of-scrollIntoView")) {
                var o = a.find('[data-media-id="' + this.mediaID + '"]'),
                  s = o[0];
                if (!s || T4SThemeSP.isVisible(o) || this.isStickyChanging)
                  return;
                this.header ||
                  (this.header = document.querySelector(".t4s-section-header")),
                  this.header.dispatchEvent(new Event("preventHeaderReveal")),
                  window.setTimeout(() => {
                    (a[0].scrollLeft = 0),
                      s.scrollIntoView({ behavior: "smooth" });
                  });
              }
            } else this.showFirstMedia = !1;
          },
          _updateMediaFirst: function (t) {
            if (this.unQuickShopInline) return;
            var e = t.closest("[data-swatch-option]");
            if (!e.hasClass("is-t4s-style__color")) return;
            let i = this.variants,
              a = i.length,
              n = e.data("id");
            let o = (function (t) {
              for (let e = 0; e < a; e++) {
                let a = i[e];
                if (a.featured_media && (a.options[n] + "").toLowerCase() == t)
                  return a.featured_media.preview_image;
              }
            })((t.data("value") + "").toLowerCase());
            o &&
              this.$imgMainItem.attr(
                "srcset",
                T4SThemeSP.Images.getNewImageUrl(o.src, 1)
              );
          },
          _updatePrice: function (t, e, i) {
            if (!t) return void this.$productPrice.hide();
            let a = t.price,
              n = t.compare_at_price;
            if (
              !this.isNoPickOriginal &&
              a === e.price &&
              n === e.compare_at_price &&
              t.unit_price === e.unit_price
            )
              return;
            this.isNoPickOriginal && (this.isNoPickOriginal = !1);
            let o = T4SThemeSP.Currency.formatMoney(a);
            if ((this.$productPrice.show(), this.variantState.onSale)) {
              let t = T4SThemeSP.Currency.formatMoney(n),
                e = this.formartPrice
                  .replace("money_ins", o)
                  .replace("money_del", t),
                i = n - a,
                s = (100 * i) / n,
                r = Math.round(s);
              void 0 !== l.price_template &&
                (e = l.price_template.replace("INS", o).replace("DEL", t)),
                this.isSticky && this.$stickyPrice.html(e),
                this.badgeSelector.$onSale.html(
                  this.saleLabel.replace("[sale]", r)
                ),
                "1" == this.saletype
                  ? (e += ` <span class="t4s-badge-price">${g.replace(
                      "[sale]",
                      r
                    )}</span>`)
                  : "2" == this.saletype &&
                    (e += ` <span class="t4s-badge-price">${v.replace(
                      "[sale]",
                      T4SThemeSP.Currency.formatMoney(i)
                    )}</span>`),
                this.$productPrice.html(e);
            } else
              this.$productPrice.html(o),
                this.isSticky && this.$stickyPrice.html(o);
            this.variantState.showUnitPrice &&
              (this.$unit_price.html(
                T4SThemeSP.Currency.formatMoney(t.unit_price)
              ),
              this.$unit_base.html(T4SThemeSP.Currency.getBaseUnit(t))),
              this.$container
                .find("shopify-payment-terms")
                .attr("variant-id", t.id),
              r.trigger("currency:update");
          },
          _updateQuantity: function (t) {
            var e = t.quantity_rule ? t.quantity_rule.min : 1,
              i =
                t.quantity_rule && t.quantity_rule.max
                  ? t.quantity_rule.max
                  : 9999;
            if (this.variantState.preOrder)
              this.$quantity.attr({ min: e, max: i }),
                this.isSticky && this.$stickyQuantity.attr({ min: e, max: i });
            else if (
              null != t.inventory_management &&
              "continue" != t.inventory_policy
            ) {
              let a = t.inventory_quantity;
              a < i && (i = a),
                this.$quantity.attr({ min: e, max: i }),
                this.isSticky && this.$stickyQuantity.attr({ min: e, max: i }),
                parseInt(this.$quantity.val()) > a &&
                  this.$quantity.attr("value", 1).val(1),
                this.isSticky &&
                  parseInt(this.$stickyQuantity.val()) > a &&
                  this.$stickyQuantity.attr("value", 1).val(1);
            } else
              this.$quantity.attr({ min: e, max: i }),
                this.isSticky && this.$stickyQuantity.attr({ min: e, max: i });
          },
          _updateAvailability: function (t, e, i) {
            var a = i.find("[data-product-available]");
            if (a[0]) {
              var n = a.find("[data-available-status]"),
                o = a.find("[data-soldout-status]"),
                s = a.find("[data-instock-status]"),
                r = a.find("[data-preorder-status]");
              t
                ? (a.show(),
                  this.variantState.available
                    ? (n.show(),
                      o.hide(),
                      this.variantState.preOrder
                        ? (r.show(), s.hide())
                        : (s.show(), r.hide()))
                    : (o.show(), n.hide()))
                : a.hide();
            }
          },
          _updateBarcode: function (t, e, i) {
            var a = i.find("[data-product-barcode]");
            if (a[0]) {
              var n = a.find("[data-product__barcode-number]");
              if (t && "" !== t.barcode) {
                if (e && e.barcode === t.barcode) return;
                n.text(t.barcode), a.show(0);
              } else a.hide(0);
            }
          },
          _updateSKU: function (t, e, i) {
            var a = i.find("[data-product-sku]");
            if (a[0]) {
              var n = a.find("[data-product__sku-number]");
              if (t && "" !== t.sku) {
                if (e && e.sku === t.sku) return;
                n.text(t.sku), a.show(0);
              } else a.hide(0);
            }
          },
          _updateAddToCartButton: function (t, e, i, a, n, o) {
            if (i[0] || n[0])
              if (
                (T4SThemeSP.isEditCartReplace &&
                  !i.is("[data-replace-item]") &&
                  i.attr("data-replace-item", ""),
                t && "nathan" != t)
              )
                if (t.available) {
                  let t = this.variantState.preOrder
                    ? this.txt_preOrder || p
                    : this.txt_addToCart || u;
                  a.show(),
                    i
                      .removeAttr("disabled " + y.disabled)
                      .attr("data-atc-form", ""),
                    o.text(t),
                    n.show(),
                    this.isSticky &&
                      (this.$stickyQuantityWrapper.show(),
                      this.$stickyATC.removeAttr("disabled " + y.disabled),
                      this.$stickyATCText.text(t));
                } else
                  a.hide(),
                    i
                      .attr("disabled", "disabled")
                      .attr(y.disabled, !0)
                      .removeAttr("data-atc-form", ""),
                    o.text(f),
                    n.hide(),
                    this.isSticky &&
                      (this.$stickyQuantityWrapper.hide(),
                      this.$stickyATC
                        .attr("disabled", "disabled")
                        .attr(y.disabled, !0),
                      this.$stickyATCText.text(f));
              else
                i
                  .attr("disabled", "disabled")
                  .attr(y.disabled, !0)
                  .removeAttr("data-atc-form"),
                  o.text(c),
                  a.hide(),
                  n.hide(),
                  this.isSticky &&
                    (this.$stickyQuantityWrapper.hide(),
                    this.$stickyATC
                      .attr("disabled", "disabled")
                      .attr(y.disabled, !0),
                    this.$stickyATCText.text(c));
          },
          _updateAtcBtnQSInline: function (t, e, i, a, n) {
            if (i[0])
              if (t && "nathan" != t)
                if (t.available) {
                  let e = this.variantState.preOrder
                    ? this.txt_preOrder || p
                    : this.txt_addToCart || u;
                  a.show(),
                    i
                      .removeAttr("disabled " + y.disabled)
                      .attr("data-action-atc", "")
                      .attr("data-variant-id", t.id),
                    n.text(e);
                } else
                  a.hide(),
                    i
                      .attr("disabled", "disabled")
                      .attr(y.disabled, !0)
                      .removeAttr("data-action-atc", ""),
                    n.text(f);
              else
                i
                  .attr("disabled", "disabled")
                  .attr(y.disabled, !0)
                  .removeAttr("data-action-atc"),
                  n.text(c),
                  a.hide();
          },
          _updateDelivery: function (t, e, a) {
            var n = a.find("[data-order-delivery]");
            if (n[0])
              if (t && t.available) {
                var o = i(n.attr("data-order-delivery"));
                this.variantState.preOrder && o.hideWithPreorder
                  ? n.hide()
                  : n.show();
              } else n.hide();
          },
          _updateInventoryQuantity: function (t, e, i) {
            var a = i.find("[data-inventory-qty]");
            a[0] &&
              (t && t.available
                ? a.trigger({
                    type: "variant:inventory",
                    currentVariant: t,
                    oldVariant: this.oldVariant,
                  })
                : a.hide());
          },
          _updatePickupAvailabilityContent: function (t, e) {
            let i = t.available
              ? "pickupAvailability:update"
              : "pickupAvailability:clear";
            e.trigger({ type: i, currentVariant: t });
          },
          _updateNotifyBackinStock: function (t, e) {
            let i = this.variantState.available
              ? "notifyBackinStock:hide"
              : "notifyBackinStock:show";
            e.trigger({ type: i, currentVariant: t });
          },
          _updateBadges: function () {
            let t = this.variantState,
              e = this.badgeSelector;
            t.onSale
              ? e.$onSale.removeAttr("hidden")
              : e.$onSale.attr("hidden", !0),
              t.preOrder
                ? e.$preOrder.removeAttr("hidden")
                : e.$preOrder.attr("hidden", !0),
              t.soldOut
                ? e.$soldOut.removeAttr("hidden")
                : e.$soldOut.attr("hidden", !0);
          },
          _setVariantState: function (t) {
            t
              ? (this.variantState = {
                  available: t.available,
                  soldOut: !t.available,
                  onSale: t.compare_at_price > t.price,
                  showUnitPrice: !!t.unit_price,
                  preOrder:
                    "shopify" == t.inventory_management &&
                    t.inventory_quantity <= 0 &&
                    t.available,
                })
              : (this.variantState.available = !1);
          },
          _updateVariantImageSwatch: function (t) {
            if (!t.featured_image) return;
            let e = this.$variantImg.find(".is--selected"),
              i = e.find("[data-img-el]");
            (e = i[0] ? i : e).attr(
              "data-bg",
              T4SThemeSP.Images.getNewImageUrl(
                t.featured_image.src,
                this.swatchWidth
              )
            );
          },
          _updateIncomingMess: function (t) {
            if (!this.useComingMess) return;
            let e = t.next_incoming_date,
              i = t.inventory_quantity,
              a = t.incoming,
              n = t.inventory_management;
            t && e && !(i > 0) && a && "shopify" == n
              ? (this.$incomingMess.removeAttr("hidden"),
                this.variantState.available
                  ? (this.$incomingAvailableDate.html(e),
                    this.$incomingSoldout.hide(),
                    this.$incomingAvailable.show())
                  : (this.$incomingSoldoutDate.html(e),
                    this.$incomingAvailable.hide(),
                    this.$incomingSoldout.show()))
              : this.$incomingMess.attr("hidden", "");
          },
          _updateStickyATC: function (t) {
            (this.isStickyChanging = !1),
              this.$stickyimg.attr(
                "src",
                t.featured_image
                  ? T4SThemeSP.Images.lazyloadImagePath(t.featured_image.src)
                  : this.stickyImgOrginal
              ),
              this.useStickySelect
                ? t.available &&
                  (this.$stickyVtitle
                    .find("[data-dropdown-open]>span")
                    .text(t.title),
                  this.$stickySelect
                    .find("[data-dropdown-item]")
                    .removeClass("is--selected"),
                  this.$stickySelect
                    .find(`[data-dropdown-item][data-value="${t.id}"]`)
                    .addClass("is--selected"))
                : this.$stickyVtitle.html(t.title),
              this.$stickyATC.attr("data-variant-id", t.id);
          },
          _updateHistoryState: function (t) {
            if (!history.replaceState || !t) return;
            let e = new URL(document.location);
            e.searchParams.set("variant", t.id),
              window.history.replaceState({ path: e.href }, "", e.href);
          },
          _getUrlWithVariant: function (t, e) {
            return /variant=/.test(t)
              ? t.replace(/(variant=)[^&]+/, "$1" + e)
              : /\?/.test(t)
              ? t.concat("&variant=").concat(e)
              : t.concat("?variant=").concat(e);
          },
        })),
        a
      );
    })(),
    m = (function () {
      function e(t) {
        (this.$container = t), this.BootSalesInt();
      }
      function a(t) {
        if (0 != t.length) {
          var e = i(t.attr(n)),
            a = e.ani;
          if ("none" != a) {
            var o = "is--animated " + a,
              s = parseInt(e.time),
              r = parseInt(e.animTime) || 1e3;
            setInterval(function () {
              t.addClass(o),
                setTimeout(function () {
                  t.removeClass(o);
                }, r);
            }, s);
          }
        }
      }
      var n = "data-animation-atc",
        o = T4Sconfigs.timezone,
        s = "t4_nt_guess";
      try {
        s = dayjs.tz.guess();
      } catch (t) {}
      var r = "not4" != o && s != o;
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          BootSalesInt: function () {
            this._liveView(),
              this._flashSold(),
              this._animationATC(),
              this._orderDelivery(),
              this._inventoryQuantity(),
              this._countdown();
          },
          _getRandomInt: function (t, e) {
            return Math.floor(Math.random() * (e - t + 1)) + t;
          },
          _animationATC: function () {
            var t = this.$container.find("[" + n + "]");
            if ((a(t), t.length, 0)) {
              var e = i(t.attr(n)),
                o = e.ani;
              if ("none" != o) {
                var s = "is--animated " + o,
                  r = parseInt(e.time),
                  d = parseInt(e.animTime) || 1100;
                setInterval(function () {
                  t.addClass(s),
                    setTimeout(function () {
                      t.removeClass(s);
                    }, d);
                }, r);
              }
            }
          },
          _liveView: function () {
            function t() {
              if (
                ((u = Math.floor(Math.random() * l.length)),
                (f = l[u]),
                (d = parseInt(d) + parseInt(f)),
                o >= d)
              ) {
                p = Math.floor(Math.random() * c.length);
                var t = c[p];
                d += t;
              }
              (d < o || d > s) && (d = n._getRandomInt(o, s)),
                h.html(parseInt(d));
            }
            var e = this.$container.find("[data-live-view]");
            if (0 != e.length) {
              var a = i(e.attr("data-live-view")),
                n = this,
                o = a.min,
                s = a.max,
                r = a.interval,
                d = n._getRandomInt(o, s),
                l = [
                  "1",
                  "2",
                  "4",
                  "3",
                  "6",
                  "10",
                  "-1",
                  "-3",
                  "-2",
                  "-4",
                  "-6",
                ],
                c = ["10", "20", "15"],
                u = "",
                f = "",
                p = "",
                h = e.find("[data-count]");
              t(), e.show(), setInterval(t, r);
            }
          },
          _flashSold: function () {
            function t(t, e) {
              g.html(t),
                v.html(Math.floor(h)),
                sessionStorage.setItem("soldS" + c, t),
                sessionStorage.setItem("soldT" + c, e);
            }
            function e() {
              p > r && (p = o._getRandomInt(s, r)),
                h > l && (h = o._getRandomInt(d, l));
            }
            var a = this.$container.find("[data-flash-sold]");
            if (0 != a.length) {
              var n = i(a.attr("data-flash-sold")),
                o = this,
                s = n.mins,
                r = n.maxs,
                d = n.mint,
                l = n.maxt,
                c = n.id,
                u =
                  sessionStorage.getItem("soldS" + c) || o._getRandomInt(s, r),
                f =
                  sessionStorage.getItem("soldT" + c) || o._getRandomInt(d, l),
                p = parseInt(u),
                h = parseInt(f),
                m = parseInt(n.time),
                g = a.find("[data-sold]"),
                v = a.find("[data-hour]");
              e(),
                t(p, h),
                a.show(),
                setInterval(function () {
                  (p += o._getRandomInt(1, 4)),
                    (h += 1 * (Math.random() * (0.8 - 0.1) + 0.1).toFixed(1)),
                    e(),
                    t(p, h);
                }, m);
            }
          },
          _orderDelivery: function () {
            function e(t) {
              return t.filter(function (t, e, i) {
                return i.indexOf(t) === e;
              });
            }
            function a(t) {
              if (t > 3 && t < 21) return "th";
              switch (t % 10) {
                case 1:
                  return "st";
                case 2:
                  return "nd";
                case 3:
                  return "rd";
                default:
                  return "th";
              }
            }
            var n = this.$container.find("[data-order-delivery]");
            if (0 != n.length) {
              var s = i(n.attr("data-order-delivery")),
                d = s.format_day,
                l = s.time.replace("24:00:00", "23:59:59") || "19041994",
                c = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
                u = s.estimateStartDate || 0,
                f = s.estimateEndDate || 0,
                p = s.cut_day.replace(/ /g, "").split(","),
                h = dayjs(),
                m = 0,
                g = dayjs(),
                v = 0,
                y = s.timezone,
                b = dayjs(),
                S = b.format("HHmmss"),
                w = l.replace(/ /g, "").replace(/:/g, ""),
                T = T4SProductStrings.order_dayNames
                  .replace(/ /g, "")
                  .split(","),
                _ = T4SProductStrings.order_monthNames
                  .replace(/ /g, "")
                  .split(",");
              if (r && y)
                try {
                  S = (b = dayjs.tz(b, o)).format("HHmmss");
                } catch (t) {
                  console.log("Timezone error: " + o);
                }
              if (
                (parseInt(S) >= parseInt(w) &&
                  ((b = b.add(1, "day")),
                  (h = h.add(1, "day")),
                  (g = g.add(1, "day"))),
                "2" == s.mode)
              ) {
                for (; p.indexOf(c[h.format("d")]) > -1; ) h = h.add(1, "day");
                for (; m < u; )
                  m++,
                    (h = h.add(1, "day")),
                    p.indexOf(c[h.format("d")]) > -1 && m--;
                for (; p.indexOf(c[g.format("d")]) > -1; ) g = g.add(1, "day");
                for (; v < f; )
                  v++,
                    (g = g.add(1, "day")),
                    p.indexOf(c[g.format("d")]) > -1 && v--;
              } else {
                for (h = h.add(u, "day"); p.indexOf(c[h.format("d")]) > -1; )
                  h = h.add(1, "day");
                for (g = g.add(f, "day"); p.indexOf(c[g.format("d")]) > -1; )
                  g = g.add(1, "day");
              }
              (T = e(T)), (_ = e(_));
              var $ = parseInt(h.format("D")),
                C = $ + a($),
                k = _[parseInt(h.format("M")) - 1],
                I = T[parseInt(h.format("d"))],
                x = parseInt(g.format("D")),
                P = x + a(x),
                M = _[parseInt(g.format("M")) - 1],
                O = T[parseInt(g.format("d"))];
              if (
                (n
                  .find("[data-start-delivery]")
                  .html(
                    h
                      .format(d)
                      .replace("t44", I)
                      .replace("t45", C)
                      .replace("t46", k)
                  ),
                n
                  .find("[data-end-delivery]")
                  .html(
                    g
                      .format(d)
                      .replace("t44", O)
                      .replace("t45", P)
                      .replace("t46", M)
                  ),
                "19041994" != l)
              ) {
                var V = n.find("[data-hour-delivery]");
                V.countdown(b.format("YYYY-MM-DD " + l), { elapse: !0 }).on(
                  "update.countdown",
                  function (e) {
                    if (e.elapsed) n.hide();
                    else {
                      var i = 24 * e.offset.totalDays + e.offset.hours;
                      V.html(
                        e.strftime(t.trim(V.html().replace("[totalHours]", i)))
                      ).show();
                    }
                  }
                );
              }
              n.show();
            }
          },
          _inventoryQuantity: function () {
            function t(t, e, i) {
              (t = parseInt(t)),
                isStorageSpSession && sessionStorage.setItem("probar" + m, t),
                (d = a.attr("data-ttcalc") || d > t ? d : t + d),
                a.attr("data-ttcalc", d);
              var n = (100 * t) / d,
                o = t < 10 ? i : e;
              k.css("background-color", o),
                setTimeout(function () {
                  k.css("width", n + "%");
                }, 300),
                k.css("background-color", o);
            }
            function e(t) {
              return t || 0;
            }
            var a = this.$container.find("[data-inventory-qty]");
            if (0 != a.length) {
              a.removeAttr("data-ttcalc");
              var n = i(a.attr("data-inventory-qty")),
                o = this,
                s = n.stock,
                r = n.qty,
                d = n.total,
                l = n.min,
                u = n.max,
                f = n.reduce,
                p = n.bgprocess,
                h = n.bgten,
                m = n.id,
                g = n.inventoryQty || 0,
                v = null,
                y = null,
                b = 1,
                S = 1.7,
                w = 0.17,
                T = o._getRandomInt(l, u),
                _ = a.find("[data-count]"),
                $ = a.find("[data-progressbar]"),
                C = a.find("[data-message]"),
                k = $.find(">div");
              if (
                (a.on("variant:inventory", function (t) {
                  if ("2" != s) {
                    var e = t.currentVariant,
                      i = e.inventory_quantity || 0;
                    if (((m = e.id), (i >= r || i < 1) && "1" == s)) a.hide();
                    else {
                      (i >= r || 0 == i) &&
                        isStorageSpSession &&
                        ((i =
                          sessionStorage.getItem("probar" + m) ||
                          o._getRandomInt(l, u)),
                        a.attr("data-variant-qty" + m, i)),
                        a.attr("data-variant-qty" + m, i),
                        sessionStorage.setItem("probar" + m, i),
                        _.text(i);
                      var n = (100 * i) / a.attr("data-ttcalc"),
                        d = i < 10 ? h : p;
                      k.css({ "background-color": d, width: n + "%" }),
                        C.show(),
                        $.show(),
                        a.show();
                    }
                  } else a.show();
                }),
                !(g >= r || g < 1) || "1" != s)
              ) {
                if (
                  (g < r && g > 0 && (T = g),
                  isStorageSpSession && !c && "1" != s)
                ) {
                  var I = sessionStorage.getItem("probar" + m);
                  I > 0 && (T = I);
                }
                _.text(T).css({ "background-color": "#fff", color: p }),
                  t(T, p, h),
                  C.show(),
                  $.show(),
                  f &&
                    ((v = setTimeout(function () {
                      --T < b &&
                        (T =
                          e(a.attr("data-variant-qty" + m)) ||
                          o._getRandomInt(l, u)),
                        _.css({ "background-color": p, color: "#fff" }),
                        setTimeout(function () {
                          _.css({ "background-color": "#fff", color: p });
                        }, 1800),
                        _.text(T),
                        t(T, p, h);
                    }, 6e4 * w)),
                    (y = setInterval(function () {
                      --T < b &&
                        ((T =
                          e(a.attr("data-variant-qty" + m)) ||
                          o._getRandomInt(l, u)),
                        a.on("destroy:inventoryQty").hide()),
                        _.css({ "background-color": p, color: "#fff" }),
                        setTimeout(function () {
                          _.css({ "background-color": "#fff", color: p });
                        }, 1800),
                        _.text(T),
                        t(T, p, h);
                    }, 6e4 * S))),
                  a.on("destroy:inventoryQty", function () {
                    clearTimeout(v), clearInterval(y);
                  }),
                  a.on("update:inventoryQty", function () {
                    var t = parseInt(_.text()) - 1;
                    if (!(t < 1)) {
                      _.text(t);
                      var e = (100 * t) / a.attr("data-ttcalc"),
                        i = t < 10 ? h : p;
                      k.css({ "background-color": i, width: e + "%" });
                    }
                  });
              }
            }
          },
          _countdown: function () {
            var t = this.$container.find("[data-countdown-pr]");
            if (0 != t.length) {
              var e,
                a = t.find("[data-cd-options]"),
                n = i(a.attr("data-cd-options"));
              if (!n.isCountdownMeta) {
                e = n.cd_date.replace("24:00:00", "23:59:59").split(",");
                var s,
                  d,
                  l = dayjs(),
                  c = l.format("HHmmss"),
                  u = e.length;
                if (r)
                  try {
                    c = (l = dayjs.tz(l, o)).format("HHmmss");
                  } catch (t) {
                    console.log("Timezone error: " + o);
                  }
                for (s = 0; s < u; s++) {
                  if (parseInt(e[s].replace(/:/g, "")) >= c) {
                    d = e[s];
                    break;
                  }
                  s == u - 1 && (d = e[s]);
                }
                a.attr("data-date", l.format("YYYY-MM-DD") + " " + d);
              }
              a.attr("data-countdown-t4s", ""), T4SThemeSP.Countdown();
            }
          },
        })),
        { init: e, ani: a }
      );
    })(),
    g = (function () {
      function t(t, i) {
        if (t) {
          var r = t.querySelector("iframe, video");
          if (r) {
            var d = t.getAttribute("data-nt-media-id");
            (a[d] = {
              mediaId: d,
              sectionId: i,
              host: (function (t) {
                if ("VIDEO" === t.tagName) return n.shopify;
                return n.external;
              })(r),
              container: t,
              element: r,
              ready: function () {
                !(function (t) {
                  if (t.player) return;
                  var e = t.container.closest(o.productMediaWrapper),
                    i =
                      "true" === e.getAttribute("data-" + s.enableVideoLooping),
                    a =
                      "true" === e.getAttribute("data-" + s.enableVideoMuting),
                    n =
                      "true" ===
                      e.getAttribute("data-" + s.enableVideoAutoplaying);
                  (t.player = new Shopify.Video(t.element, {
                    loop: { active: i },
                    muted: a,
                  })),
                    e.classList.add("is-media__initialized");
                  var r = function () {
                    t.player && t.player.pause();
                  };
                  e.addEventListener("mediaHidden", r),
                    e.addEventListener("xrLaunch", r),
                    e.addEventListener("mediaVisible", function () {
                      !T4SThemeSP.isTouch && n && t.player && t.player.play();
                    });
                })(this);
              },
            }),
              window.Shopify.loadFeatures([
                { name: "video-ui", version: "2.0", onLoad: e },
              ]),
              T4SThemeSP.LibraryLoader.load("plyrShopifyStyles");
          }
        }
      }
      function e(t) {
        t
          ? (function () {
              for (var t in a)
                if (a.hasOwnProperty(t)) {
                  var e = a[t];
                  if (e.nativeVideo) continue;
                  e.host === n.shopify &&
                    (e.element.setAttribute("controls", "controls"),
                    (e.nativeVideo = !0));
                }
            })()
          : i();
      }
      function i() {
        for (var t in a)
          if (a.hasOwnProperty(t)) {
            a[t].ready();
          }
      }
      var a = {},
        n = { shopify: "shopify", external: "external" },
        o = { productMediaWrapper: "[data-product-single-media-wrapper]" },
        s = {
          enableVideoLooping: "enable-video-looping",
          enableVideoMuting: "enable-video-muting",
          enableVideoAutoplaying: "enable-video-autoplaying",
          videoId: "video-id",
        };
      return {
        init: t,
        hosts: n,
        loadVideos: i,
        removeSectionVideos: function (t) {
          for (var e in a)
            if (a.hasOwnProperty(e)) {
              var i = a[e];
              i.sectionId === t &&
                (i.player && i.player.destroy(), delete a[e]);
            }
        },
      };
    })(),
    v = (function () {
      function t(e) {
        if (!e)
          if (window.ShopifyXR) {
            for (var a in i)
              if (i.hasOwnProperty(a)) {
                var n = i[a];
                if (n.loaded) continue;
                var o = document.querySelector("#ModelJson-" + a);
                window.ShopifyXR.addModels(JSON.parse(o.innerHTML)),
                  (n.loaded = !0);
              }
            window.ShopifyXR.setupXRElements();
          } else
            document.addEventListener("shopify_xr_initialized", function () {
              t();
            });
      }
      function e(t) {
        if (!t)
          for (var e in a)
            if (a.hasOwnProperty(e)) {
              var i = a[e];
              i.modelViewerUi ||
                (i.modelViewerUi = new Shopify.ModelViewerUI(i.element)),
                (function (t) {
                  var e = n[t.sectionId];
                  t.container.classList.add("is-media__initialized"),
                    t.container.addEventListener("mediaVisible", function () {
                      e.element &&
                        e.element.setAttribute(
                          "data-shopify-model3d-id",
                          t.modelId
                        ),
                        T4SThemeSP.isTouch || t.modelViewerUi.play();
                    }),
                    t.container.addEventListener("mediaHidden", function () {
                      e.element &&
                        e.element.setAttribute(
                          "data-shopify-model3d-id",
                          e.defaultId
                        ),
                        t.modelViewerUi.pause();
                    }),
                    t.container.addEventListener("xrLaunch", function () {
                      t.modelViewerUi.pause();
                    });
                })(i);
            }
      }
      var i = {},
        a = {},
        n = {},
        o = {
          mediaGroup: "[data-product-single-media-group]",
          xrButton: "[data-shopify-xr]",
        };
      return {
        init: function (s, r) {
          (i[r] = { loaded: !1 }),
            s.forEach(function (t, e) {
              var i = t.getAttribute("data-nt-media-id"),
                s = t.querySelector("model-viewer"),
                d = s.getAttribute("data-model-id");
              if (0 === e) {
                var l = t.closest(o.mediaGroup).querySelector(o.xrButton);
                n[r] = { element: l, defaultId: d };
              }
              a[i] = { modelId: d, sectionId: r, container: t, element: s };
            }),
            window.Shopify.loadFeatures([
              { name: "shopify-xr", version: "1.0", onLoad: t },
              { name: "model-viewer-ui", version: "1.0", onLoad: e },
            ]),
            T4SThemeSP.LibraryLoader.load("modelViewerUiStyles");
        },
        removeSectionModels: function (t) {
          for (var e in a)
            a.hasOwnProperty(e) &&
              a[e].sectionId === t &&
              (a[e].modelViewerUi.destroy(), delete a[e]);
          delete i[t];
        },
      };
    })(),
    y = (function () {
      function e(e, i) {
        e = e[0];
        let a = JSON.parse(document.querySelector("#Json360-" + i).innerHTML),
          n = a.imgArray,
          o = parseFloat(e.getAttribute("data-min")) || 1.194,
          s = parseFloat(e.getAttribute("data-max")) || 2,
          r = window.devicePixelRatio < o ? o : window.devicePixelRatio,
          d = r > s ? s : r,
          l = Math.round(e.clientWidth * d);
        a.imgArray = [];
        for (let t in n) a.imgArray.push(`${n[t]}&width=${l}`);
        a.onReady = function () {
          !(function (e, i) {
            i.classList.add("is-media__initialized"),
              i.addEventListener("mediaVisible", function () {
                if (!T4SThemeSP.isTouch)
                  try {
                    e.play(),
                      t(i.querySelector(".nav_bar_play"))
                        .removeClass("nav_bar_play")
                        .addClass("nav_bar_stop");
                  } catch (t) {}
              }),
              t(i).hasClass("is-selected") &&
                (e.play(),
                setTimeout(function () {
                  t(i.querySelector(".nav_bar_play"))
                    .removeClass("nav_bar_play")
                    .addClass("nav_bar_stop");
                }, 50));
            i.addEventListener("mediaHidden", function () {
              e.stop(),
                t(i.querySelector(".nav_bar_stop"))
                  .removeClass("nav_bar_stop")
                  .addClass("nav_bar_play");
            });
          })(c, e);
        };
        var c = t(e.querySelector(".t4s-threesixty")).ThreeSixty(a);
      }
      var i = !1;
      return {
        init: function (t, a) {
          i
            ? e(t, a)
            : $script(T4Sconfigs.script12b, function () {
                e(t, a), (i = !0);
              });
        },
      };
    })(),
    b = (function () {
      function e(t, e) {
        (this.container = e),
          (this.idPopup = this.container.dataset.idPopup),
          (this.hasOnlyDefaultVariant =
            "true" === this.container.dataset.hasOnlyDefaultVariant),
          (this.rootUrl = this.container.dataset.rootUrl),
          (this.variantId = this.container.dataset.variantId);
        var i = this;
        t.on("pickupAvailability:update", function (t) {
          i.updateContent(t.currentVariant.id);
        }),
          t.on("pickupAvailability:clear", function (t) {
            i.clearContent();
          });
      }
      var i = {
          pickupAvailabilityPopupOpen: "[data-pickup-availability-popup-open]",
          pickupAvailabilityPopupClose:
            "[data-pickup-availability-popup-close]",
        },
        a = u.mfp_close,
        n = u.mfp_loading,
        o = {};
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          updateContent: function (t = this.variantId) {
            let e = this.rootUrl;
            e.endsWith("/") || (e += "/");
            var a = e + "variants/" + t + "/?section_id=pickup-availability",
              n = this,
              s = f + "pickup-availability" + t,
              r = n.container.querySelector(i.pickupAvailabilityPopupOpen);
            (n.container.style.opacity = 0.5),
              r && ((r.disabled = !0), r.setAttribute("aria-busy", !0)),
              o[s]
                ? n.updateResponse(o[s])
                : T4SThemeSP.getToFetchSection(null, "text", a).then((t) => {
                    "NVT_94" != t && ((o[s] = t), n.updateResponse(t));
                  });
          },
          updateResponse: function (t) {
            if ("" !== t.trim()) {
              (this.container.innerHTML = t),
                (this.container.innerHTML =
                  this.container.firstElementChild.innerHTML),
                (this.container.style.opacity = 1);
              var e = this.container.querySelector(
                i.pickupAvailabilityPopupOpen
              );
              e &&
                ((this.container.querySelector("#pickupAvailabilityPopup").id =
                  this.idPopup),
                e.addEventListener("click", this._onClickModalOpen.bind(this)));
            }
          },
          clearContent: function () {
            this.container.innerHTML = "";
          },
          _onClickModalOpen: function () {
            var e = this;
            t.magnificPopupT4s.open({
              items: { src: `#${e.idPopup}` },
              type: "inline",
              removalDelay: 500,
              tClose: a,
              tLoading: n,
              callbacks: {
                beforeOpen: function () {
                  this.st.mainClass =
                    "mfp-move-horizontal t4s-pickup-availability_pp_wrapper";
                },
                open: function () {
                  r.trigger("NTpopupInline:offClose"),
                    r.trigger("currency:update");
                  var t = document.querySelector(
                    `#${e.idPopup} ${i.pickupAvailabilityPopupClose}`
                  );
                  t &&
                    (t.removeEventListener("click", e._onClickModalClose),
                    t.addEventListener("click", e._onClickModalClose));
                },
                beforeClose: function () {},
                close: function () {},
                afterClose: function () {
                  r.trigger("NTpopupInline:onClose");
                },
              },
            });
          },
          _onClickModalClose: function () {
            t.magnificPopupT4s.close();
          },
        })),
        e
      );
    })(),
    S = (function () {
      function e(e, n, s) {
        if (!e[0]) return;
        var f,
          p = this,
          h = "2" == n;
        (d = e.offset().top + e.outerHeight()),
          p._updateContent(),
          (l = o.find("[data-action-info-close]")),
          m.ani(o.find("[data-action-atc]")),
          p._stickyAddToCartToggle(),
          h || (o.addClass(c.isShow), r.addClass(c.isActive)),
          a.scroll(function () {
            f && clearTimeout(f),
              (f = setTimeout(function () {
                p._stickyAddToCartToggle(h);
              }, 30));
          });
        var g = o.find("[data-quantity-wrapper] [data-quantity-value]"),
          b = e.find("[data-quantity-value");
        g.change(function () {
          b.val(this.value);
        }),
          b.change(function () {
            g.val(this.value);
          }),
          s ||
            o.find("[data-sticky-v-title]").on(u, function (i) {
              i.preventDefault(),
                t("html, body").animate(
                  { scrollTop: e.offset().top - 100 },
                  isBehaviorSmooth ? 0 : 500
                ),
                l.trigger(u);
            });
        let S = o.find(".t4s-sticky-atc__product"),
          w = o.find("[data-action-atc]"),
          T = !0;
        o.find("[data-action-atc][data-action-delay]").on(u, function (e) {
          !t(this)[0].hasAttribute("data-action-delay") ||
            a.width() > 767 ||
            (e.preventDefault(),
            e.stopPropagation(),
            (T = !0),
            S.slideDown({
              start: function () {
                t(this).css({ display: "flex" }),
                  w.removeAttr("data-action-delay"),
                  t(v).removeClass(y);
              },
              complete: function () {
                i(), t(v).addClass(y);
              },
            }));
        }),
          l.on(u, function (e) {
            !T ||
              a.width() > 767 ||
              (e.preventDefault(),
              (T = !1),
              S.slideUp({
                start: function () {
                  w.attr("data-action-delay", ""), t(v).removeClass(y);
                },
                complete: function () {
                  i(), t(v).addClass(y);
                },
              }));
          }),
          a.on("resize.sticky", i);
      }
      function i() {
        (g = o.outerHeight()),
          h != g &&
            ((h = g), s.css({ "--stickyATC-height": o.outerHeight() + "px" }));
      }
      var o,
        d,
        l,
        c = {
          isShow: "is--shown",
          isActive: "sticky-is--active",
          isHiddenMb: "is-hidden--mobile",
        },
        u = "click.sticky",
        f = a.height(),
        p = n.height(),
        h = 0,
        g = 0,
        v = "#t4s-backToTop",
        y = "is--show";
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          _updateContent: function () {
            T4SThemeSP.$appendComponent.after(t("#t4s-sticky-atc-temp").html()),
              (o = t("[data-sticky-addtocart]"));
          },
          _stickyAddToCartToggle: function (t) {
            var e = a.scrollTop(),
              s = parseInt(e + f) + 60;
            (p = n.height()),
              d < e && s !== p && s < p
                ? (o.addClass(c.isShow), r.addClass(c.isActive), i())
                : (s === p || s > p || (d > e && t)) &&
                  (o.removeClass(c.isShow),
                  r.removeClass(c.isActive),
                  o.find("[data-dropdown-open].is--clicked").click(),
                  l.trigger(u));
          },
        })),
        e
      );
    })();
  (T4SThemeSP.Product = (function () {
    function l(e) {
      if (
        ((this.$container = t(e)), this.$container.is("[data-product-options]"))
      )
        this._itemQuickShopInline();
      else if (
        ((this.productConfigs = i(this.$container.attr(c))),
        (this.productID = this.productConfigs.id),
        (this.container = e),
        (this.$mainMedia = this.$container.find(_)),
        (this.mainMedia = this.$mainMedia[0]),
        (this.sectionId = this.productConfigs.sectionId),
        (this.disableSwatch = this.productConfigs.disableSwatch),
        (this.isSticky = this.productConfigs.isSticky),
        (this.isStickyMB = this.productConfigs.isStickyMB),
        (this.stickyShow = this.productConfigs.stickyShow),
        (this.useStickySelect = this.productConfigs.useStickySelect),
        (this.$shortDes = this.$container.find("[data-des-height]")),
        (this.eventHandlers = {}),
        this._createBadgesProduct(),
        this._initBootSales(),
        this._initSubmit(),
        this.productConfigs.id)
      ) {
        (this.$variantImg = this.$container.find(T)),
          (this.disableVariantImage = !this.$variantImg[0]),
          (this.$formSelectorId = this.$container.find(
            this.productConfigs.formID
          )),
          (this.$formSelectorIdLength = this.$formSelectorId.length),
          (this.pickupAvailabilityContainer = this.$container.find($)[0]),
          this.pickupAvailabilityContainer &&
            this.$formSelectorIdLength > 0 &&
            (this._initPickupAvailability(),
            this.disableSwatch && this.pickupAvailability.updateContent()),
          this._initNotifyBackinStock(),
          d && !this.isStickyMB && (this.isSticky = !1),
          this.isSticky && this._initStickyAddToCart(),
          !this.disableSwatch &&
            this.$formSelectorIdLength > 0 &&
            ((this.$originalSelectorId =
              this.$formSelectorId.find('select[name="id"]')),
            (this.$options1 = this.$formSelectorId.find(
              '[data-swatch-option][data-id="0"]'
            )),
            (this.$options2 = this.$formSelectorId.find(
              '[data-swatch-option][data-id="1"]'
            )),
            (this.$options3 = this.$formSelectorId.find(
              '[data-swatch-option][data-id="2"]'
            )),
            this.PrOptionsSize,
            this.disableVariantImage ||
              ((this.$variantImgItems =
                this.$variantImg.find("[data-swatch-item]")),
              (this.colorOptionIndex = this.$variantImg.data("id")),
              (this.swatchWidth = 2 * this.$variantImgItems.outerWidth())),
            this._initVariants(),
            this._swatchesEventListeners(),
            this._changeMediaSlider(),
            this.disableVariantImage || this._updateVariantImageSwatchFirst());
        var a = this;
        a.mainMedia && a._initProductIsotope(),
          setTimeout(function () {
            a.mainMedia &&
              (a._initLoadContent(),
              setTimeout(function () {
                a._initProductVideo(),
                  a._initModelViewerLibraries(),
                  a._initShopifyXrLaunch(),
                  a._init360ViewerLibraries();
                var t = a.container.querySelector(
                  ".t4s-product__info-container--sticky"
                );
                t &&
                  a.productConfigs.infoOverflowScroller &&
                  (a.infoOverflowScroller = new T4SThemeSP.OverflowScroller(t, {
                    offsetTop: 109,
                    offsetBottom: 30,
                    updateOffsetTop: !0,
                  }));
              }, 100));
          }, 1e3);
        var n = a.productConfigs.main_click;
        if ("none" != n && a.mainMedia) {
          if (
            (T4SThemeSP.isTouch && a.productConfigs.enable_zoom_click_mb) ||
            (T4SThemeSP.isHover && "pswp" == n)
          ) {
            var s = this.$mainMedia.find("." + w);
            s.removeClass(w),
              T4SThemeSP.isTouch &&
                a.productConfigs.enable_zoom_click_mb &&
                o > 1024 &&
                document.addEventListener("theme:hover", function (t) {
                  s.addClass(w);
                });
          }
          this.$shortDes &&
            (this.$shortDes.each(function (e, i) {
              t(i)
                .parent()
                .css("--full-h", t(i).height() + "px");
            }),
            this.$shortDes.on("click", function () {
              t(this)
                .parent()
                .css("--full-h", t(this).height() + "px");
            }));
        }
      }
    }
    var c = "data-product-featured",
      u = {},
      f = {},
      p = !s.hasClass("is-remove-unavai-0"),
      w = "is-pswp-disable",
      T = ".t4s-color-mode__variant_image .is--first-color",
      _ = "[data-main-media]",
      $ = "[data-pickup-availability-container]",
      C = T4Sconfigs,
      k = T4SProductStrings,
      I = C.nowTimestamp,
      x = C.new_day_int,
      P = C.use_sale_badge,
      M = C.label_sale_style,
      O = C.use_preorder_badge,
      V = C.use_new_badge,
      A = C.use_soldout_badge,
      L = C.use_custom_badge,
      E = {
        sale: k.badgeSale,
        new: k.badgeNew,
        preOrder: k.badgepreOrder,
        soldout: k.badgeSoldout,
        SavePercent: k.badgeSavePercent,
      },
      D = { texts: E, saleStyle: M };
    return (
      (l.prototype = Object.assign({}, l.prototype, {
        _itemQuickShopInline: function () {
          var t = this;
          (t.$qsInline = t.$container.find("[data-qs-inl]")),
            (t.$formSelectorId = t.$qsInline.find("form")),
            (t.$originalSelectorId =
              t.$formSelectorId.find('select[name="id"]')),
            (t.$options1 = t.$formSelectorId.find(
              '[data-swatch-option][data-id="0"]'
            )),
            (t.$options2 = t.$formSelectorId.find(
              '[data-swatch-option][data-id="1"]'
            )),
            (t.$options3 = t.$formSelectorId.find(
              '[data-swatch-option][data-id="2"]'
            )),
            (t.productConfigs = i(
              t.$originalSelectorId.attr("data-product-featured")
            )),
            (t.productID = t.productConfigs.id),
            (t.$variantImg = t.$qsInline.find(T)),
            (t.disableVariantImage = !t.$variantImg[0]),
            t.disableVariantImage ||
              ((t.$variantImgItems = t.$variantImg.find("[data-swatch-item]")),
              (t.colorOptionIndex = t.$variantImg.data("id")),
              (t.swatchWidth = 2 * t.$variantImgItems.outerWidth())),
            t._initVariants(),
            t._swatchesEventListeners(),
            t._initSubmit(),
            t.disableVariantImage || this._updateVariantImageSwatchFirst();
        },
        _initVariants: function () {
          var e,
            i,
            a,
            n = this.productConfigs;
          if (
            (n.isGrouped &&
              (n.isGrouped =
                this.$container.find("form[data-groups-pr-form]").length > 0),
            !n.isGrouped)
          ) {
            if (u[this.productID])
              (a = u[this.productID]),
                (i = f[this.productID]),
                (this.PrOptionsSize = i.length);
            else
              try {
                (a = JSON.parse(
                  this.$container.find(".pr_variants_json").html()
                )),
                  this.$originalSelectorId.find("> option").each(function (i) {
                    (e = t(this)),
                      (a[i].incoming = e.data("incoming")),
                      (a[i].next_incoming_date =
                        e.data("nextincomingdate") || null),
                      (a[i].inventory_policy =
                        e.data("inventorypolicy") || null),
                      (a[i].inventory_quantity = e.data("inventoryquantity"));
                  }),
                  (u[this.productID] = a),
                  (i = JSON.parse(
                    this.$container.find(".pr_options_json").html()
                  )),
                  (f[this.productID] = i),
                  (this.PrOptionsSize = i.length);
              } catch (t) {
                return void console.log("not found pr json");
              }
            "boolean" != typeof n.unQuickShopInline &&
              (n.unQuickShopInline = !0);
            var o = {
              enableHistoryState: n.enableHistoryState || !1,
              $container: this.$container,
              formSelectorId: this.$formSelectorId,
              $originalSelectorId: this.$originalSelectorId,
              $options1: this.$options1,
              $options2: this.$options2,
              $options3: this.$options3,
              variants: a,
              productOptions: i,
              PrOptionsSize: this.PrOptionsSize,
              removeSoldout: n.removeSoldout,
              isNoPick: n.isNoPick,
              hasSoldoutUnavailable: n.hasSoldoutUnavailable,
              canMediaGroup: n.canMediaGroup,
              isMainProduct: n.isMainProduct,
              oldVariant: {},
              badgesConfigs: D,
              $variantImg: this.$variantImg,
              disableVariantImage: this.disableVariantImage,
              swatchWidth: this.swatchWidth,
              isSticky: this.isSticky,
              useStickySelect: this.useStickySelect,
              showFirstMedia: n.showFirstMedia,
              unQuickShopInline: n.unQuickShopInline,
              isQuickShopForm: n.isQuickShopForm,
            };
            this.Variants = new h(o);
          }
        },
        _swatchesEventListeners: function () {
          if (this.PrOptionsSize) {
            var e,
              i,
              a,
              n = !0,
              o = this.$formSelectorId.hasClass("is-form-t4spritem"),
              s = this;
            s.$formSelectorId.on(
              "click",
              "[data-swatch-item]:not(.is--selected)",
              function (d) {
                d.preventDefault();
                var l = t(this);
                if (
                  (l
                    .addClass("is--selected")
                    .siblings()
                    .removeClass("is--selected"),
                  l
                    .closest("[data-swatch-option]")
                    .find("[data-current-value]")
                    .html(l.data("value")),
                  o &&
                    n &&
                    (s.$formSelectorId.addClass("t4sproduct-swatched"),
                    s.$formSelectorId
                      .find(
                        '[data-swatch-option][data-id="0"] [data-swatch-name],[data-swatch-option][data-id="1"],[data-swatch-option][data-id="2"]'
                      )
                      .show(150),
                    (n = !1)),
                  (s.Variants.clickedCurrentValue = l.data("value") + ""),
                  (a = l.closest("[data-swatch-option]").data("id")),
                  (s.Variants.clickedCurrentIndex = "option" + ++a),
                  s.$formSelectorId.find(".is--selected").length <
                    s.PrOptionsSize && s.Variants.isNoPick)
                )
                  return (
                    s.Variants._updateMediaFilterNoPick(),
                    void s.Variants._updateMediaFirst(l)
                  );
                (s.Variants.eventClickedSwatch = !0),
                  (s.Variants.clickedOptions = []),
                  s.$formSelectorId
                    .find("[data-swatch-option] .is--selected")
                    .each(function (e, i) {
                      s.Variants.clickedOptions.push({
                        value: t(i).data("value") + "",
                        index: "option" + ++e,
                      });
                    }),
                  s.Variants.isNoPick ||
                    (s.Variants.oldVariant = s.Variants.currentVariant),
                  s.Variants.isNoPick &&
                    (r.trigger("hide.t4s.notices"),
                    s.isSticky &&
                      t("[data-sticky-addtocart]").removeAttr("hidden"),
                    (s.Variants.isNoPick = !1),
                    s.$container.trigger("replace:btnAtc")),
                  (i = s.Variants._getVariantFromOptions()),
                  s.$originalSelectorId.val(i.id),
                  (e = s.$originalSelectorId.val()),
                  !p ||
                    (null !== e && "" !== e) ||
                    ((i = s.Variants._getVariantFromSize()),
                    s.$originalSelectorId.val(i.id),
                    (e = s.$originalSelectorId.val())),
                  (s.Variants.currentVariant = i),
                  s.$originalSelectorId[0].dispatchEvent(
                    new Event("change", { bubbles: !0, cancelable: !0 })
                  );
              }
            );
          }
        },
        _changeMediaSlider: function () {
          if (
            this.PrOptionsSize &&
            this.productConfigs.changeVariantByImg &&
            0 !=
              this.$container.find(
                ".flickityt4s[data-main-media] .t4s-product__media-item--variant"
              ).length
          ) {
            var e,
              i,
              a,
              n,
              o = this;
            this.$container
              .find(".flickityt4s[data-main-media]")
              .off("select.flickityt4s")
              .on("select.flickityt4s", function (s, r) {
                t(this).trigger("select.carousel"),
                  (n = t(this)
                    .find(".flickityt4s-slider>[data-main-slide]")
                    .eq(r)).hasClass("t4s-product__media-item--variant") &&
                    !o.Variants.eventClickedSwatch &&
                    ((e = n.data("media-id")),
                    (a = o.$originalSelectorId.val()),
                    void 0 ===
                      (i = o.$originalSelectorId
                        .find('option[data-mdid="' + e + '"]:not(:disabled)')
                        .val()) ||
                      a == i ||
                      o.Variants.isNoPick ||
                      o.Variants.mediaID == e ||
                      (o.$originalSelectorId.val(i),
                      o.$originalSelectorId[0].dispatchEvent(
                        new Event("change", { bubbles: !0, cancelable: !0 })
                      )));
              });
          }
        },
        _initBootSales: function () {
          this.BootSales = new m.init(this.$container);
        },
        _initSubmit: function () {
          n.trigger({ type: "submitAtc:t4s", $container: this.$container });
        },
        _initProductVideo: function () {
          var t = this.sectionId,
            e = this.mainMedia.querySelectorAll(
              '[data-media-type="video"], [data-media-type="external_video"]'
            );
          e.length < 1 ||
            e.forEach(function (e) {
              g.init(e, t);
            });
        },
        _init360ViewerLibraries: function () {
          var t = this.mainMedia.querySelectorAll('[data-media-type="360"]');
          t.length < 1 || y.init(t, this.sectionId);
        },
        _initModelViewerLibraries: function () {
          var t = this.mainMedia.querySelectorAll('[data-media-type="model"]');
          t.length < 1 || v.init(t, this.sectionId);
        },
        _initShopifyXrLaunch: function () {
          (this.eventHandlers.initShopifyXrLaunchHandler =
            this._initShopifyXrLaunchHandler.bind(this)),
            document.addEventListener(
              "shopify_xr_launch",
              this.eventHandlers.initShopifyXrLaunchHandler
            );
        },
        _initShopifyXrLaunchHandler: function () {
          this.mainMedia
            .querySelector("[data-product-single-media-wrapper]")
            .dispatchEvent(
              new CustomEvent("xrLaunch", { bubbles: !0, cancelable: !0 })
            );
        },
        loadContent: function (t) {
          if (t.getAttribute("loaded")) return;
          const e = document.createElement("div"),
            i = t.querySelector("template");
          e.appendChild(i.content.firstElementChild.cloneNode(!0)),
            t.setAttribute("loaded", !0);
          t.appendChild(e.querySelector("video, model-viewer, iframe"));
          i.remove();
        },
        _initLoadContent: function () {
          var t = this;
          t.mainMedia
            .querySelectorAll("[data-deferred-media]")
            .forEach(function (e) {
              e.classList.add("is--adding"),
                t.loadContent(e.querySelector(".t4s-pr"));
            });
        },
        _initProductIsotope: function () {
          var t = this;
          !d &&
            t.productConfigs.hasIsotope &&
            (e(this.$mainMedia),
            T4SThemeSP.Isotopet4s.init(this.$mainMedia),
            a.on("resize.prIstope", function () {
              a.width() < 768 && t.$mainMedia.hasClass("isotopet4s-enabled")
                ? t.$mainMedia
                    .isotopet4s("destroy")
                    .removeClass("isotopet4s-enabled")
                : a.width() >= 768 &&
                  !t.$mainMedia.hasClass("isotopet4s-enabled") &&
                  setTimeout(function () {
                    T4SThemeSP.Isotopet4s.init(t.$mainMedia);
                  }, 500);
            }));
        },
        _initPickupAvailability: function () {
          this.pickupAvailability = new b(
            this.$container,
            this.pickupAvailabilityContainer
          );
        },
        _initNotifyBackinStock: function () {
          let e = this,
            i = this.$container.find(".t4s-product-notify-stock"),
            a = this.$container.find("[data-notify-stock-btn]");
          if (i[0] || a[0])
            if (i[0])
              this.$container.on("notifyBackinStock:show", function (a) {
                let n = t("#ContactFormNotifyStock" + e.productID);
                i.show();
                let o = `${a.currentVariant.name.replace("- ", "( ")} ) ${
                  e.productConfigs.orgUrl
                }?variants=${a.currentVariant.id}`;
                n.find('[name="contact[product]"]').text(o);
              }),
                this.$container.on("notifyBackinStock:hide", function (t) {
                  i.hide();
                });
            else {
              var n = this.$container.find("[data-notify-stock-btn]"),
                o = n.data("root-url"),
                s = "";
              if (
                (o.endsWith("/") || (o += "/"),
                (s = `${o}variants/${n.data(
                  "variant-id"
                )}/?section_id=back-in-stock`),
                n.attr("data-mfp-src", s).hide().removeClass("t4s-d-none"),
                !this.productConfigs.available &&
                  this.productConfigs.disableSwatch)
              )
                return void n.show();
              this.$container.on("notifyBackinStock:show", function (t) {
                (s = `${o}variants/${t.currentVariant.id}/?section_id=back-in-stock`),
                  n
                    .attr({
                      "data-mfp-src": s,
                      "data-storageid": `notify-stock${t.currentVariant.id}`,
                    })
                    .show();
              }),
                this.$container.on("notifyBackinStock:hide", function (t) {
                  n.hide();
                });
            }
        },
        _createBadgesProduct: function () {
          let t = this.$container.find("[data-product-single-badge]"),
            e = (t.attr("data-sort") || "").replace(/ /g, "").split(","),
            i = this.productConfigs,
            a = "";
          if (0 == e.length || 0 == t.length) return;
          let n = e.length;
          for (let t = 0; t < n; t++)
            switch (e[t]) {
              case "sale":
                if (!P) break;
                let n = i.compare_at_price,
                  c = i.price;
                if (n <= c) {
                  a +=
                    '<span data-badge-sale class="t4s-badge-item t4s-badge-sale" hidden></span>';
                  break;
                }
                if ("2" == M)
                  var o = (100 * (n - c)) / n,
                    s = E.SavePercent.replace("[sale]", Math.round(o));
                else if ("3" == M)
                  var r = n - c,
                    s = T4SThemeSP.Currency.formatMoney(r);
                else s = E[e[t]];
                a +=
                  '<span data-badge-sale class="t4s-badge-item t4s-badge-sale">' +
                  s +
                  "</span>";
                break;
              case "preOrder":
                if (!O) break;
                a += `<span data-badge-preorder class="t4s-badge-item t4s-badge-preorder"${
                  i.isPreoder ? "" : " hidden"
                }>${E[e[t]]}</span>`;
                break;
              case "new":
                var d = I - i.dateStart,
                  l = Math.floor(d / 3600);
                if ((l = Math.floor(l / 24)) >= x || !V) break;
                a +=
                  '<span class="t4s-badge-item t4s-badge-new">' +
                  E[e[t]] +
                  "</span>";
                break;
              case "soldout":
                if (!A) break;
                a += `<span data-badge-soldout class="t4s-badge-item t4s-badge-soldout"${
                  i.available ? " hidden" : ""
                }>${E[e[t]]}</span>`;
                break;
              default:
                let u = i.customBadge;
                if (!u || !L) break;
                let f = u.length;
                for (let t = 0; t < f; t++)
                  a +=
                    '<span class="t4s-badge-item t4s-badge-custom t4s-badge-' +
                    i.customBadgeHandle[t] +
                    '">' +
                    u[t] +
                    "</span>";
            }
          t.html(a);
        },
        _updateVariantImageSwatchFirst: function () {
          let e = this,
            i = e.Variants.variants,
            a = i.length,
            n = this.colorOptionIndex;
          e.$variantImgItems.each(function (o) {
            let s = t(this),
              r = (function (t) {
                for (let e = 0; e < a; e++) {
                  let a = i[e];
                  if (
                    a.featured_image &&
                    (a.options[n] + "").toLowerCase() == t
                  )
                    return a.featured_image;
                }
              })((s.data("value") + "").toLowerCase());
            if (!r) return;
            let d = s.find("[data-img-el]");
            (s = d[0] ? d : s).attr(
              "data-bg",
              T4SThemeSP.Images.getNewImageUrl(r.src, e.swatchWidth)
            );
          });
        },
        _initStickyAddToCart: function () {
          this.stickyAddToCart = new S(
            this.$formSelectorId,
            this.stickyShow,
            this.useStickySelect
          );
        },
      })),
      l
    );
  })()),
    (T4SThemeSP._initProducts = (function () {
      var e = "data-product-featured",
        i = "initProducts__enabled";
      return function () {
        t("[" + e + "]:not(." + i + ")").each(function () {
          t(this).addClass(i), new T4SThemeSP.Product(this);
        });
      };
    })()),
    (T4SThemeSP._initBundlePrs = (function () {
      function e() {
        t("[" + i + "]:not(." + a + ")").each(function () {
          let e = t(this);
          e.addClass(a),
            m.ani(e.find("[data-atc-form]")),
            (function (e) {
              if (T4SThemeSP.isTouch || 0 == e.length) return;
              let i = e.find("[data-bundles-pr-form]"),
                a = e.find("[data-bundle-image]");
              e.hoverIntent({
                selector: "[data-bundle-pin]",
                sensitivity: 6,
                interval: 40,
                timeout: 40,
                over: function (e) {
                  a.addClass(n),
                    i.addClass(n),
                    t(this).addClass(o),
                    t(t(this).data("trigger")).addClass(s);
                },
                out: function () {
                  a.removeClass(n),
                    i.removeClass(n),
                    a.find("." + o).removeClass(o),
                    i.find("." + s).removeClass(s);
                },
              });
            })(e);
        });
      }
      var i = "data-product-bundles",
        a = "initBundles__enabled",
        n = "has--hover-pin",
        o = "is--hover",
        s = "is--trigger-hover";
      return e;
    })()),
    (T4SThemeSP.Cookies = (function () {
      function t() {
        (function () {
          var t = navigator.cookieEnabled;
          return (
            t ||
              ((document.cookie = "testcookie"),
              (t = -1 !== document.cookie.indexOf("testcookie"))),
            t
          );
        })() || s.addClass("not--cookies");
      }
      return t;
    })()),
    (T4SThemeSP.isVisible = function (e, i, n, o, s) {
      if (!(e.length < 1)) {
        o = o || "both";
        var r = a,
          d = e.length > 1 ? e.eq(0) : e,
          l = void 0 !== s && null !== s,
          c = l ? t(s) : r,
          u = l ? c.position() : 0,
          f = d.get(0),
          p = c.outerWidth(),
          h = c.outerHeight(),
          m = !0 !== n || f.offsetWidth * f.offsetHeight;
        if ("function" == typeof f.getBoundingClientRect) {
          var g = f.getBoundingClientRect(),
            v = l
              ? g.top - u.top >= 0 && g.top < h + u.top
              : g.top >= 0 && g.top < h,
            y = l
              ? g.bottom - u.top > 0 && g.bottom <= h + u.top
              : g.bottom > 0 && g.bottom <= h,
            b = l
              ? g.left - u.left >= 0 && g.left < p + u.left
              : g.left >= 0 && g.left < p,
            S = l
              ? g.right - u.left > 0 && g.right < p + u.left
              : g.right > 0 && g.right <= p,
            w = i ? v || y : v && y,
            T = i ? b || S : b && S,
            w = (g.top < 0 && g.bottom > h) || w,
            T = (g.left < 0 && g.right > p) || T;
          if ("both" === o) return m && w && T;
          if ("vertical" === o) return m && w;
          if ("horizontal" === o) return m && T;
        } else {
          var _ = l ? 0 : u,
            $ = _ + h,
            C = c.scrollLeft(),
            k = C + p,
            I = d.position(),
            x = I.top,
            P = x + d.height(),
            M = I.left,
            O = M + d.width(),
            V = !0 === i ? P : x,
            A = !0 === i ? x : P,
            L = !0 === i ? O : M,
            E = !0 === i ? M : O;
          if ("both" === o) return !!m && A <= $ && V >= _ && E <= k && L >= C;
          if ("vertical" === o) return !!m && A <= $ && V >= _;
          if ("horizontal" === o) return !!m && E <= k && L >= C;
        }
      }
    }),
    (T4SThemeSP.Tabs = (function () {
      var e,
        i,
        a,
        n,
        o = "t4s-tabs-enabled",
        s = "t4s-tabs-simple-enabled",
        r = "t4s-tabs-accordion-enabled",
        d = "t4s-active",
        l = 300,
        c = 150;
      return {
        Default: function () {
          0 != (i = t(`[data-t4s-tabs]:not(.${o})`)).length &&
            (i.addClass(o),
            i.on(
              "click",
              "[data-t4s-tab-ul] [data-t4s-tab-item]",
              function (i) {
                i.preventDefault();
                var a = t(this),
                  n = a.closest("[data-t4s-tabs]"),
                  o = a.attr("href") || a.data("id-tab"),
                  s = n.find(o),
                  r = s.find(".flickityt4s"),
                  l = s.find(".isotopet4s");
                n.find("." + d).removeClass(d),
                  n.find("[data-t4s-tab-content]").hide(),
                  a.addClass(d),
                  s.show().addClass(d),
                  s.closest("[data-t4s-tab-wrapper]").addClass(d),
                  clearTimeout(e),
                  (e = setTimeout(function () {
                    r.hasClass("flickityt4s-enabled")
                      ? r.flickityt4s("resize")
                      : l.hasClass("isotopet4s-enabled") &&
                        l.isotopet4s("layout");
                  }, 200));
              }
            ));
        },
        Simple: function () {
          0 != (a = t(`[data-t4s-tabs2]:not(.${s})`)).length &&
            (a.addClass(s),
            a.on(
              "click",
              "[data-t4s-tab-ul2] [data-t4s-tab-item]",
              function (e) {
                e.preventDefault();
                var i = t(this),
                  a = i.closest("[data-t4s-tabs2]"),
                  n = i.attr("href") || i.data("id-tab"),
                  o = a.find(n);
                a.find("." + d).removeClass(d),
                  i.addClass(d),
                  o.addClass(d),
                  o.closest("[data-t4s-tab-wrapper]").addClass(d),
                  o
                    .closest("[data-t4s-tabs2]")
                    .attr("data-tab-active", n.replace("#", "")),
                  i.is("[data-triger-btns-tab]") &&
                    (o.hasClass("flickityt4s flickityt4s-enabled")
                      ? o.trigger("updateBtnTab.flickityt4s")
                      : o
                          .find(".flickityt4s.flickityt4s-enabled")
                          .trigger("updateBtnTab.flickityt4s"));
              }
            ));
        },
        Accordion: function () {
          0 != (n = t(`[data-t4s-tabs]:not(.${r})`)).length &&
            (n.addClass(r),
            t(".t4s-type-accordion, [data-t4s-accordion-pr]")
              .find("." + d)
              .find("[data-t4s-tab-content]")
              .css("display", "block"),
            n.on(
              "click",
              "[data-t4s-tab-wrapper] [data-t4s-tab-item]",
              function (e) {
                e.preventDefault();
                var i = t(this),
                  a = i.closest("[data-t4s-tabs]"),
                  n = a.find("[data-t4s-tab-ul]"),
                  o = a.find(
                    "[data-t4s-tab-wrapper]:not([data-no-auto-close])." + d
                  ),
                  s = o.find("[data-t4s-tab-content]"),
                  r = i.closest("[data-t4s-tab-wrapper]"),
                  u = r.find("[data-t4s-tab-content]"),
                  f = i.closest(".t4s-section"),
                  p = u.find(".flickityt4s"),
                  h = u.find(".isotopet4s");
                0 == f.length &&
                  (f = i.closest(".t4s-section,.shopify-section")),
                  r.hasClass(d)
                    ? (n.find("." + d).removeClass(d),
                      r.removeClass(d),
                      u.slideUp(l).removeClass(d))
                    : (o.removeClass(d),
                      n.find("." + d).removeClass(d),
                      r.addClass(d),
                      n
                        .find(
                          `a[href="${i.attr("href")}"], [data-href="${i.attr(
                            "href"
                          )}"]`
                        )
                        .addClass(d),
                      s.slideUp(c).removeClass(d),
                      u
                        .stop(!0, !0)
                        .slideDown(l, function () {
                          if (
                            (p.hasClass("flickityt4s-enabled")
                              ? p.flickityt4s("resize")
                              : h.hasClass("isotopet4s-enabled") &&
                                h.isotopet4s("layout"),
                            !T4SThemeSP.isVisible(i, !0))
                          ) {
                            var e = t(".t4s-section-header").height() || 0,
                              a =
                                f.find(".t4s-tab-wrapper.t4s-active").offset()
                                  .top -
                                e -
                                10;
                            t("body,html").animate({ scrollTop: a });
                          }
                        })
                        .addClass(d));
              }
            ));
        },
      };
    })()),
    (T4SThemeSP.RenderRefresh = (function () {
      function e(t) {
        r.trigger("currency:update");
        let e = t.find(".flickityt4s"),
          i = t.find(".isotopet4s");
        t.find(".t4s-products").length > 0 &&
          "function" == typeof T4SThemeSP.reinitProductGridItem &&
          T4SThemeSP.reinitProductGridItem(),
          i.length > 0 && T4SThemeSP.Isotopet4s.init(i),
          e.length > 0 && (e[0].flickityt4s = new T4SThemeSP.Carousel(e[0])),
          T4SThemeSP.ProductItem.resizeObserver(),
          T4SThemeSP.initLoadMore && T4SThemeSP.initLoadMore();
      }
      return function () {
        0 != t("[data-render-lazy-component]").length &&
          (t("[data-render-lazy-component].lazyloadt4sed").each(function () {
            e(t(this));
          }),
          t("[data-render-lazy-component]:not(.lazyloadt4sed)").one(
            "lazyincluded",
            function (i) {
              var a = t(i.target)[0];
              e(t(a));
            }
          ),
          t("[data-render-lazy-component]:not(.lazyloadt4s)").addClass(
            "lazyloadt4s"
          ));
      };
    })()),
    (T4SThemeSP.ParallaxInt = function () {
      var e = t("[data-parallax-t4strue]:not(.parallax_enabled)");
      0 != e.length &&
        e.each(function () {
          var e = t(this),
            i =
              e.attr("data-imgsl") ||
              e.find(".t4s-parallax-img:visible")[0] ||
              ".t4s-parallax-img";
          (e.find(i).length > 0 || e.is(".t4s-parallax-bg.lazyloadt4sed")) &&
            e
              .addClass("parallax_enabled")
              .t4sJarallax({
                speed: e.attr("data-speed") || 0.8,
                imgElement: i,
              });
        });
    }),
    (T4SThemeSP.Countdown = (function () {
      function e() {
        var e = t("[data-countdown-t4s]:not(.t4s-countdown-enabled)");
        0 != e.length &&
          e.each(function () {
            var e = t(this),
              n =
                t(e.attr("data-keyid")).html() ||
                t.trim(e.html()) ||
                "%D days %H:%M:%S",
              o = e.is("[data-refresh-owl]"),
              s = e.data("loop"),
              r = e.data("date"),
              d = parseInt(e.data("dayl")),
              l = dayjs(),
              c = r.replace(/\//g, "").replace(/-/g, "") + "",
              u = parseInt(c),
              f = c.length < 9 ? "YYYYMMDD" : "YYYYMMDDHHmmss";
            if (
              ((u > parseInt(l.format(f)) || d < 1) && (s = !1),
              s || "true" == s)
            ) {
              var p = dayjs(r).format(" HH:mm:ss"),
                h = d - (l.diff(r.replace(/\//g, "-"), "days") % d);
              (r = (l = l.add(h, "day")).format("YYYY/MM/DD") + p),
                e.attr("data-dateloop", r);
            }
            if (
              (e
                .countdown(
                  (function (t) {
                    if (void 0 !== t) {
                      var e = t.replace("24:00:00", "23:59:59");
                      if ("not4" != i && a != i)
                        try {
                          e = dayjs.tz(t.replace(/\//g, "-"), i).toDate();
                        } catch (t) {
                          console.log("Timezone error: " + i);
                        }
                      else e = new Date(e);
                      return e;
                    }
                  })(r),
                  { elapse: !0 }
                )
                .on("update.countdown", function (t) {
                  if (t.elapsed)
                    e.html("")
                      .addClass("expired_cdt4s")
                      .closest("[data-countdown-wrap]")
                      .html("")
                      .addClass("expired_cdt4s");
                  else {
                    var i = 24 * t.offset.totalDays + t.offset.hours;
                    e.html(t.strftime(n.replace("[totalHours]", i)));
                  }
                })
                .addClass("t4s-countdown-enabled")
                .closest("[data-countdown-wrap]")
                .addClass("t4s-countdown-enabled"),
              o)
            ) {
              var m;
              clearTimeout(m),
                (m = setTimeout(() => {
                  e.closest(".flickityt4s-enabled").flickityt4s("resize");
                }, 600));
            }
          });
      }
      var i = T4Sconfigs.timezone,
        a = "t4_nt_guess";
      try {
        a = dayjs.tz.guess();
      } catch (t) {}
      return e;
    })());
  var w = (function () {
    function e(e, a) {
      const n = "object" == typeof a ? a : {};
      (this.$element = t(e)),
        (this.options = Object.assign({}, i, this._dataOptions(), n)),
        this._init();
    }
    const i = {
      from: 0,
      to: 0,
      speed: 1e3,
      refreshInterval: 100,
      decimals: 0,
      formatter: function (t, e) {
        return t.toFixed(e.decimals);
      },
      onUpdate: null,
      onComplete: null,
    };
    return (
      (e.prototype = Object.assign({}, e.prototype, {
        _init: function () {
          (this.value = this.options.from),
            (this.loops = Math.ceil(
              this.options.speed / this.options.refreshInterval
            )),
            (this.loopCount = 0),
            (this.increment =
              (this.options.to - this.options.from) / this.loops),
            this._start();
        },
        _dataOptions: function () {
          var t = {
              from: this.$element.data("from"),
              to: this.$element.data("to"),
              speed: this.$element.data("speed"),
              refreshInterval: this.$element.data("refresh-interval"),
              decimals: this.$element.data("decimals"),
            },
            e = Object.keys(t);
          for (var i in e) {
            var a = e[i];
            void 0 === t[a] && delete t[a];
          }
          return t;
        },
        _update: function () {
          (this.value += this.increment),
            this.loopCount++,
            this._render(),
            "function" == typeof this.options.onUpdate &&
              this.options.onUpdate.call(this.$element, this.value),
            this.loopCount >= this.loops &&
              (clearInterval(this.interval),
              (this.value = this.options.to),
              "function" == typeof this.options.onComplete &&
                this.options.onComplete.call(this.$element, this.value));
        },
        _render: function () {
          var t = this.options.formatter.call(
            this.$element,
            this.value,
            this.options
          );
          this.$element.text(t);
        },
        _start: function () {
          this._stop(),
            this._render(),
            (this.interval = setInterval(
              this._update.bind(this),
              this.options.refreshInterval
            ));
        },
        _stop: function () {
          this.interval && clearInterval(this.interval);
        },
      })),
      e
    );
  })();
  (T4SThemeSP.AnimateOnScroll = (function () {
    var e = T4Sconfigs.timeani || 200,
      i = new IntersectionObserver(function (a, n) {
        a.forEach(function (a) {
          var n = a.target;
          a.isIntersecting &&
            !n.classList.contains("t4s_animated") &&
            (setTimeout(function () {
              n.classList.add("t4s_animated"),
                t(n).is("[data-count-to]") && (this.countTo = new w(n));
            }, e),
            i.unobserve(n));
        });
      });
    return function () {
      var e = t("[data-t4s-animate]:not(.t4s-animate-init)");
      0 != e.length &&
        window.IntersectionObserver &&
        e.each(function (e) {
          i.observe(this), t(this).addClass("t4s-animate-init");
        });
    };
  })()),
    (T4SThemeSP.PopupMFP = (function () {
      function e() {
        void 0 !== i &&
          ((function () {
            if (0 == o.length) return;
            o.magnificPopupT4s({
              type: "inline",
              removalDelay: 500,
              tClose: a,
              tLoading: n,
              callbacks: {
                beforeOpen: function () {
                  s.addClass(p),
                    (this.st.mainClass =
                      "mfp-move-horizontal t4s-inline-popup-wrapper t4s-rte " +
                        t(this.st.el).data("id") || "");
                },
                open: function () {
                  r.trigger("NTpopupInline:offClose"),
                    r.trigger("currency:update");
                },
                afterClose: function () {
                  r.trigger("NTpopupInline:onClose"), s.removeClass(p);
                },
              },
            }).addClass("t4s-mfp-enabled");
          })(),
          (function () {
            if (
              0 ==
              (d = t("[data-open-mfp-iframe]:not(.t4s-mfp-enabled)")).length
            )
              return;
            d.magnificPopupT4s({
              type: "iframe",
              tClose: a,
              tLoading: n,
              iframe: {
                markup:
                  '<div class="mfp-iframe-scaler t4s-pr t4s-mfp-iframe"><div class="mfp-close"></div><iframe class="mfp-iframe" allow="autoplay; encrypted-media" frameborder="0" allowfullscreen></iframe></div>',
                patterns: {
                  youtube: {
                    index: "youtube.com/",
                    id: "v=",
                    src: "//www.youtube.com/embed/%id%?enablejsapi=1&autoplay=0&rel=0&playlist=%id%&loop=1",
                  },
                  vimeo: {
                    index: "vimeo.com/",
                    id: "/",
                    src: "//player.vimeo.com/video/%id%?autoplay=0&loop=1",
                  },
                  gmaps: { index: "//maps.google.", src: "%id%&output=embed" },
                },
                srcAction: "iframe_src",
              },
              callbacks: {
                beforeOpen: function () {
                  s.addClass(p),
                    (this.st.mainClass =
                      "t4s-iframe-popup-wrapper " + t(this.st.el).data("id") ||
                      "");
                },
                change: function () {},
                open: function () {
                  var e = t(this.st.el),
                    i = t(".t4s-mfp-iframe").find(".mfp-iframe"),
                    a = i.attr("src");
                  e.is("[data-autoplay-true]") &&
                    (a = a.replace("autoplay=0", "autoplay=1")),
                    e.is("[data-loop-false]") &&
                      ((a = a.split("&playlist=")[0]),
                      (a = a.replace("loop=1", "loop=0"))),
                    i.attr("src", a);
                },
                close: function () {},
                afterClose: function () {
                  s.removeClass(p);
                },
              },
            }).addClass("t4s-mfp-enabled");
          })(),
          (function () {
            if (
              0 == (l = t("[data-open-mfp-video]:not(.t4s-mfp-enabled)")).length
            )
              return;
            l.on("click", function (e) {
              e.preventDefault();
              var i,
                o = t(this),
                r = JSON.parse(o.attr("data-options") || "{}"),
                d = r.type,
                l = r.vid,
                c = r.autoplay,
                u = r.loop,
                f =
                  '<iframe src="src_t4s" class="class_t4s" title="" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
                h = { html5: "html5", youtube: "youtube", vimeo: "vimeo" };
              switch (d) {
                case h.html5:
                  let e = r.id,
                    a = "";
                  (a =
                    e && t(e)[0]
                      ? t(e).html()
                      : '<video class="mfp-video" src="' +
                        r.srcDefault +
                        '" preload="auto" controls ' +
                        (c ? "autoplay" : "") +
                        (c ? " loop" : "") +
                        " playsinline></video>"),
                    (i = `<div class="mfp-video-scaler t4s-pr t4s-mfp-video">${a.replace(
                      "<video",
                      '<video  class="mfp-video"'
                    )}</div>`);
                  break;
                case h.youtube:
                  (f = f
                    .replace(
                      "src_t4s",
                      "//www.youtube.com/embed/" +
                        l +
                        "?enablejsapi=1&showinfo=0&controls=1&modestbranding=1&autoplay=" +
                        +c +
                        "&rel=0" +
                        (u ? "&playlist=" + l + "&loop=1" : "")
                    )
                    .replace("class_t4s", "js-youtube")),
                    (i =
                      '<div class="mfp-iframe-scaler t4s-pr t4s-mfp-iframe">' +
                      f +
                      "</div>");
                  break;
                case h.vimeo:
                  (f = f
                    .replace(
                      "src_t4s",
                      "//player.vimeo.com/video/" +
                        l +
                        "?&portrait=0&byline=0&color=" +
                        r.accent_color +
                        "&autoplay=" +
                        +c +
                        "&loop=" +
                        +u
                    )
                    .replace("class_t4s", "js-vimeo")),
                    (i =
                      '<div class="mfp-iframe-scaler t4s-pr t4s-mfp-iframe">' +
                      f +
                      "</div>");
              }
              t.magnificPopupT4s.open({
                items: { src: i, type: "inline" },
                tClose: a,
                tLoading: n,
                callbacks: {
                  beforeOpen: function () {
                    s.addClass(p),
                      (this.st.mainClass =
                        "t4s-video-popup-wrapper mfp-video-holder " +
                          o.data("id") || "");
                  },
                  open: function () {
                    o.addClass("t4s-mfp-enabled");
                  },
                  afterClose: function () {
                    o.removeClass("t4s-mfp-enabled"), s.removeClass(p);
                  },
                },
              });
            });
          })(),
          (function () {
            if (
              0 == (c = t("[data-open-mfp-ajax]:not(.t4s-mfp-enabled)")).length
            )
              return;
            c.magnificPopupT4s({
              type: "ajax",
              removalDelay: 500,
              tClose: a,
              tLoading:
                '<div class="t4s-loading-spin t4s-spin-centered t4s-spin-dark t4s-spin-medium"></div>',
              callbacks: {
                parseAjax: function (e) {
                  var i = t(this.st.el),
                    a = i.data("id") || "",
                    n = i.data("class") || "",
                    o = i.data("style") || "",
                    s = e.data;
                  e.data = `<div class="mfp-with-anim t4s-mfp-popup t4s-rte ${n}" id="${a}" style="${o}">${
                    s.split("[t4splitlz]")[1] || s
                  }</div>`;
                },
                ajaxContentAdded: function () {},
                beforeOpen: function () {
                  s.addClass(p),
                    (this.st.mainClass =
                      "mfp-move-horizontal t4s-ajax-popup-wrapper");
                },
                open: function () {
                  var e = t(this.st.el).data("custom"),
                    i = t(this.st.el).data("phone"),
                    a = t(".t4s-ajax-popup-wrapper:not(.mfp-bg) .mfp-content");
                  if (
                    (r.trigger("NTpopupInline:offClose"),
                    r.trigger("currency:update"),
                    0 == i &&
                      (a.find("#t4s-ContactFormAsk__phone").remove(),
                      setTimeout(function () {
                        a.find("#t4s-ContactFormAsk__phone").remove();
                      }, 400)),
                    e)
                  ) {
                    var n = e.split("||");
                    t.each(n, function (t, e) {
                      var i = e.split("=>");
                      a.find(i[0]).html(i[1]);
                    }),
                      setTimeout(function () {
                        t.each(n, function (t, e) {
                          var i = e.split("=>");
                          a.find(i[0]).html(i[1]);
                        });
                      }, 400);
                  }
                },
                afterClose: function () {
                  r.trigger("NTpopupInline:onClose"), s.removeClass(p);
                },
              },
            }).addClass("t4s-mfp-enabled");
          })(),
          (function () {
            if (0 == f.length) return;
            r.on("click", "[data-open-mfp]", function (e) {
              e.preventDefault();
              var i = t(e.currentTarget),
                a = (t("html"), i.data()),
                n = a.opennt,
                o = a.color,
                r = a.bg,
                d = a.pos,
                l = a.ani || "has_ntcanvas",
                c = a.remove,
                u = a.class,
                f = a.close || !1,
                h = a.focuslast || !1,
                m = i.attr("data-focus"),
                g = window.pageYOffset;
              window.height,
                t("#shopify-section-header_banner").outerHeight(),
                t(".ntheader_wrapper").outerHeight();
              i.addClass("current_clicked"),
                t.magnificPopupT4s.open({
                  items: {
                    src: n,
                    type: "inline",
                    tLoading: '<div class="loading-spin dark"></div>',
                  },
                  tClose: nt_settings.close,
                  removalDelay: 300,
                  closeBtnInside: f,
                  focus: m,
                  autoFocusLast: h,
                  callbacks: {
                    beforeOpen: function () {
                      (this.st.mainClass = l + " " + o + " " + l + "_" + d),
                        s.addClass(p);
                    },
                    open: function () {
                      s.addClass(l),
                        s.addClass(l + "_" + d),
                        u && t(".mfp-content").addClass(u),
                        r && t(".mfp-bg").addClass(r),
                        body.on("click", ".close_pp", function (e) {
                          e.preventDefault(), t.magnificPopup.close();
                        }),
                        (function () {
                          if (!g) return;
                          t("html, body").scrollTop(g);
                        })();
                    },
                    beforeClose: function () {
                      s.removeClass(l);
                    },
                    afterClose: function () {
                      s.removeClass(l + "_" + d),
                        t(".current_clicked").removeClass("current_clicked"),
                        c && t(n).removeClass("mfp-hide"),
                        s.removeClass(p);
                    },
                  },
                });
            });
          })());
      }
      var i = t.fn.magnificPopupT4s,
        a = u.mfp_close,
        n = u.mfp_loading,
        o = t("[data-open-mfp-inline]:not(.t4s-mfp-enabled)"),
        d = t("[data-open-mfp-iframe]:not(.t4s-mfp-enabled)"),
        l = t("[data-open-mfp-video]:not(.t4s-mfp-enabled)"),
        c = t("[data-open-mfp-ajax]:not(.t4s-mfp-enabled)"),
        f = t("[data-open-mfp]"),
        p = "is-opening-mfp";
      return e;
    })()),
    (T4SThemeSP.NTpopupInline = (function () {
      function e(e, y, b, S = null) {
        (o = S),
          r.off(l).on(l, function (t) {
            i() ? r.trigger(u) : r.trigger(c);
          }),
          r.off(c).on(c, function (a) {
            i() ||
              ((function (e) {
                T4SThemeSP.$appendComponent.after(d), o && s.addClass(o);
                t(".t4s-modal__content").html(e);
              })(e),
              (function (e) {
                s.addClass(h),
                  s.css({ "margin-right": T4SThemeSP.scrollbarWidth }),
                  t(".t4s-modal").addClass(p),
                  t(".t4s-modal").on(v, function () {
                    t(this).focus().off(v);
                  }),
                  setTimeout(function () {
                    t(".t4s-modal").focus();
                  }, 500),
                  e();
              })(b));
          }),
          r.off(u).on(u, function (e) {
            i() &&
              (t(".t4s-modal .flickityt4s-enabled").trigger("destroy.t4s"),
              t("html").css({ "margin-right": "" }),
              t("html").removeClass(h).addClass("t4s-modal-closing"),
              t(".t4s-modal").removeClass(p).addClass("t4s-modal--is-closing"),
              setTimeout(function () {
                t(".t4s-modal").remove(),
                  t("html").removeClass("t4s-modal-closing"),
                  o && s.removeClass(o),
                  (T4SThemeSP.isEditCartReplace = !1);
              }, 500),
              r.trigger(f),
              r.trigger("t4s:hideTooltip"));
          }),
          r.off(f).on(f, function (t) {
            r.off(l).off(c).off(u).off(f).off(m).off(g);
          }),
          r.on(m, "[data-t4s-modal-close]", function (t) {
            t.preventDefault(), r.trigger(u);
          }),
          r.on(m, n),
          r.on(g, a),
          r.on("NTpopupInline:offClose", function (t) {
            r.off(g, a), r.off(m, n);
          }),
          r.on("NTpopupInline:onClose", function (t) {
            r.on(g, a), r.on(m, n);
          });
      }
      function i() {
        return t("html").hasClass(h);
      }
      function a(t) {
        27 === t.keyCode && r.trigger(u);
      }
      function n(e) {
        t(e.target).parents().is(".t4s-modal__inner") ||
          t(e.target).parents().is(".mfp-ready") ||
          t(e.target).is("#t4s-notices__wrapper") ||
          t(e.target).parents().is("#t4s-notices__wrapper") ||
          (e.preventDefault(), r.trigger(u));
      }
      var o,
        d = t("#t4s_temp_modal").html(),
        l = "modalt4s:trigger",
        c = "modalt4s:opened",
        u = "modalt4s:closed",
        f = "modalt4s:destroy",
        p = "t4s-modal--is-active",
        h = "t4s-modal-opened",
        m = "click.t4s_qv",
        g = "keyup.t4s_qv",
        v = "transitionend webkitTransitionEnd oTransitionEnd";
      return e;
    })()),
    (T4SThemeSP.Currency = (function () {
      var t = "${{amount}}",
        e = T4SThemeSP.settings && T4SThemeSP.settings.superScriptPrice,
        i = window.T4Sconfigs.moneyFormat,
        a = function (t, e) {
          return null == t || t != t ? e : t;
        };
      return {
        formatMoney: function (n, o) {
          function s(t, e, i, n) {
            if (
              ((e = a(e, 2)),
              (i = a(i, ",")),
              (n = a(n, ".")),
              isNaN(t) || null == t)
            )
              return 0;
            var o = (t = (t / 100).toFixed(e)).split(".");
            return (
              o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
              (o[1] ? n + o[1] : "")
            );
          }
          o || (o = i), "string" == typeof n && (n = n.replace(".", ""));
          var r = "",
            d = /\{\{\s*(\w+)\s*\}\}/,
            l = o || t;
          switch (l.match(d)[1]) {
            case "amount":
              (r = s(n, 2)),
                e &&
                  r &&
                  r.includes(".") &&
                  (r = r.replace(".", "<sup>") + "</sup>");
              break;
            case "amount_no_decimals":
              r = s(n, 0);
              break;
            case "amount_with_comma_separator":
              (r = s(n, 2, ".", ",")),
                e &&
                  r &&
                  r.includes(".") &&
                  (r = r.replace(",", "<sup>") + "</sup>");
              break;
            case "amount_no_decimals_with_comma_separator":
              r = s(n, 0, ".", ",");
              break;
            case "amount_no_decimals_with_space_separator":
              r = s(n, 0, " ");
              break;
            case "amount_with_apostrophe_separator":
              r = s(n, 2, "'");
          }
          return l.replace(d, r);
        },
        getBaseUnit: function (t) {
          if (
            t &&
            t.unit_price_measurement &&
            t.unit_price_measurement.reference_value
          )
            return 1 === t.unit_price_measurement.reference_value
              ? t.unit_price_measurement.reference_unit
              : t.unit_price_measurement.reference_value +
                  t.unit_price_measurement.reference_unit;
        },
      };
    })()),
    (T4SThemeSP.slate = {});
  var T = T4SThemeSP.slate;
  (T.utils = {
    getParameterByName: function (t, e) {
      e || (e = window.location.href), (t = t.replace(/[[\]]/g, "\\$&"));
      var i = new RegExp("[?&]" + t + "(=([^&#]*)|&|#|$)").exec(e);
      return i
        ? i[2]
          ? decodeURIComponent(i[2].replace(/\+/g, " "))
          : ""
        : null;
    },
    removeParameterByName: function (t, e) {
      e || (e = window.location.href), (t = t.replace(/[[\]]/g, "\\$&"));
      var i = e.split("?")[0],
        a = [],
        n = -1 !== e.indexOf("?") ? e.split("?")[1] : "";
      if ("" !== n) {
        for (var o = (a = n.split("&")).length - 1; o >= 0; o -= 1)
          a[o].split("=")[0] === t && a.splice(o, 1);
        a.length && (i = i + "?" + a.join("&"));
      }
      return i;
    },
    resizeSelects: function (e) {
      e.each(function () {
        var e = t(this),
          i = e.find("option:selected").text(),
          a = t("<span>").html(i);
        a.appendTo("body");
        var n = a.width();
        a.remove(), e.width(n + 10);
      });
    },
    keyboardKeys: {
      TAB: 9,
      ENTER: 13,
      ESCAPE: 27,
      LEFTARROW: 37,
      RIGHTARROW: 39,
    },
  }),
    (T.rte = {
      wrapTable: function (t) {
        t.$tables.wrap('<div class="' + t.tableWrapperClass + '"></div>');
      },
      wrapIframe: function (e) {
        e.$iframes.each(function () {
          t(this).wrap('<div class="' + e.iframeWrapperClass + '"></div>'),
            (this.src = this.src);
        });
      },
    }),
    (T.a11y = {
      pageLinkFocus: function (t) {
        var e = "js-focus-hidden";
        t.first()
          .attr("tabIndex", "-1")
          .focus()
          .addClass(e)
          .one("blur", function () {
            t.first().removeClass(e).removeAttr("tabindex");
          });
      },
      focusHash: function () {
        var e = window.location.hash;
        e && document.getElementById(e.slice(1)) && this.pageLinkFocus(t(e));
      },
      bindInPageLinks: function () {
        t("a[href*=#]").on(
          "click",
          function (e) {
            this.pageLinkFocus(t(e.currentTarget.hash));
          }.bind(this)
        );
      },
      trapFocus: function (e) {
        var i = {
            focusin: e.namespace ? "focusin." + e.namespace : "focusin",
            focusout: e.namespace ? "focusout." + e.namespace : "focusout",
            keydown: e.namespace
              ? "keydown." + e.namespace
              : "keydown.handleFocus",
          },
          a = e.$container.find(
            t(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
            ).filter(":visible")
          ),
          n = a[0],
          o = a[a.length - 1];
        e.$elementToFocus || (e.$elementToFocus = e.$container),
          e.$container.attr("tabindex", "-1"),
          e.$elementToFocus.focus(),
          t(document).off("focusin"),
          t(document).on(i.focusout, function () {
            t(document).off(i.keydown);
          }),
          t(document).on(i.focusin, function (e) {
            (e.target !== o && e.target !== n) ||
              t(document).on(i.keydown, function (t) {
                !(function (t) {
                  t.keyCode === T.utils.keyboardKeys.TAB &&
                    (t.target !== o ||
                      t.shiftKey ||
                      (t.preventDefault(), n.focus()),
                    t.target === n &&
                      t.shiftKey &&
                      (t.preventDefault(), o.focus()));
                })(t);
              });
          });
      },
      removeTrapFocus: function (e) {
        var i = e.namespace ? "focusin." + e.namespace : "focusin";
        e.$container &&
          e.$container.length &&
          e.$container.removeAttr("tabindex"),
          t(document).off(i);
      },
      accessibleLinks: function (e) {
        var i = document.querySelector("body"),
          a = {
            newWindow: "a11y-new-window-message",
            external: "a11y-external-message",
            newWindowExternal: "a11y-new-window-external-message",
          };
        (void 0 !== e.$links && e.$links.jquery) ||
          (e.$links = t("a[href]:not([aria-describedby])")),
          t.each(e.$links, function () {
            var e = t(this),
              i = e.attr("target"),
              n = e.attr("rel"),
              o = (function (t) {
                var e = window.location.hostname;
                return t[0].hostname !== e;
              })(e),
              s = "_blank" === i;
            o && e.attr("aria-describedby", a.external),
              s &&
                ((void 0 !== n && -1 !== n.indexOf("noopener")) ||
                  e.attr("rel", function (t, e) {
                    return (void 0 === e ? "" : e + " ") + "noopener";
                  }),
                e.attr("aria-describedby", a.newWindow)),
              o && s && e.attr("aria-describedby", a.newWindowExternal);
          }),
          (function (e) {
            "object" != typeof e && (e = {});
            var n = t.extend(
                {
                  newWindow: "Opens in a new window.",
                  external: "Opens external website.",
                  newWindowExternal: "Opens external website in a new window.",
                },
                e
              ),
              o = document.createElement("ul"),
              s = "";
            for (var r in n) s += "<li id=" + a[r] + ">" + n[r] + "</li>";
            o.setAttribute("hidden", !0), (o.innerHTML = s), i.appendChild(o);
          })(e.messages);
      },
    }),
    (T4SThemeSP.LinkMyltiLang = (function () {
      var e = T4SThemeSP.root_url,
        i = window.location.hostname,
        a = T4Sroutes.root_url,
        n = "is--checked-link",
        o = i + a;
      return function () {
        "/" != e &&
          t(`a[href*="${i}"]:not(.${n}):not([href*="@"])`).each(function () {
            let s = t(this),
              r = s.attr("href");
            s.addClass(n),
              (r.indexOf(i + e) >= 0 && "/" != r) ||
                r.indexOf("preview_theme_id=") > -1 ||
                ("/" != r
                  ? s.attr("href", r.replace(i, o))
                  : s.attr("href", a));
          });
      };
    })());
  var _ = (function () {
    function e(e) {
      var i = this;
      if (
        ((i.$slider = t(e)),
        (i.slideWrap = i.$slider.closest("[data-slide-wrap]")[0] || e),
        !i.slideWrap)
      )
        return;
      if (
        ((i.sliderOptions = JSON.parse(i.$slider.attr("data-options") || "{}")),
        (i.slider = e),
        (i.sliderItems = e.querySelectorAll(".t4s-slider__slide")),
        (i.pageCount = i.slideWrap.querySelector(
          ".t4s-slider-counter--current"
        )),
        (i.pageTotal = i.slideWrap.querySelector(".t4s-slider-counter--total")),
        (i.prevButton = i.slideWrap.querySelector(".t4s-slider__slide-prev")),
        (i.nextButton = i.slideWrap.querySelector(".t4s-slider__slide-next")),
        !i.slider || !i.nextButton)
      )
        return;
      new ResizeObserver((t) => i._initPages()).observe(i.slider),
        i.slider.addEventListener("scroll", i._update.bind(i)),
        i.prevButton.addEventListener("click", i._onButtonClick.bind(i)),
        i.nextButton.addEventListener("click", i._onButtonClick.bind(i));
    }
    return (
      (e.prototype = Object.assign({}, e.prototype, {
        _initPages: function () {
          this.slider.classList.remove("is--active"),
            0 !== !this.sliderItems.length &&
              (this.slider.classList.add("is--active"),
              (this.slidesPerPage = Math.floor(
                this.slider.clientWidth / this.sliderItems[0].clientWidth
              )),
              (this.totalPages =
                this.sliderItems.length - this.slidesPerPage + 1),
              this._update());
        },
        _update: function () {
          this.pageCount &&
            this.pageTotal &&
            ((this.currentPage =
              Math.round(
                this.slider.scrollLeft / this.sliderItems[0].clientWidth
              ) + 1),
            1 === this.currentPage
              ? this.prevButton.setAttribute("disabled", !0)
              : this.prevButton.removeAttribute("disabled"),
            this.currentPage === this.totalPages
              ? this.nextButton.setAttribute("disabled", !0)
              : this.nextButton.removeAttribute("disabled"),
            (this.pageCount.textContent = this.currentPage),
            (this.pageTotal.textContent = this.totalPages));
        },
        _onButtonClick: function (t) {
          t.preventDefault();
          const e =
            "next" === t.currentTarget.name
              ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
              : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
          this.slider.scrollTo({ left: e });
        },
      })),
      e
    );
  })();
  (T4SThemeSP.SliderComponentInt = (function () {
    var e = t(".t4s-slider:not(.t4s-enabled)");
    0 != e.length &&
      e.each(function (t) {
        this.classList.add("t4s-enabled"), (this.sliderComponent = new _(this));
      });
  })()),
    (T4SThemeSP.LibraryLoader = (function () {
      function t(t, a) {
        var s = o[t];
        if (s) {
          if (c && "youtubeSdk" == t && window.YT)
            return a(), void n.trigger("youtube:ready");
          if (s.status !== i.requested)
            if (((a = a || function () {}), s.status !== i.loaded)) {
              s.status = i.requested;
              var r;
              switch (s.type) {
                case e.script:
                  r = (function (t, e) {
                    var a = document.createElement("script");
                    return (
                      (a.src = t.src),
                      a.addEventListener("load", function () {
                        (t.status = i.loaded), e();
                      }),
                      a
                    );
                  })(s, a);
                  break;
                case e.link:
                  r = (function (t, e) {
                    var a = document.createElement("link");
                    return (
                      (a.href = t.src),
                      (a.rel = "stylesheet"),
                      (a.type = "text/css"),
                      a.addEventListener("load", function () {
                        (t.status = i.loaded), e();
                      }),
                      a
                    );
                  })(s, a);
              }
              (r.id = s.tagId), (s.element = r);
              var d = document.getElementsByTagName(s.type)[0];
              d.parentNode.insertBefore(r, d);
            } else a();
        }
      }
      var e = { link: "link", script: "script" },
        i = { requested: "requested", loaded: "loaded" },
        a = "https://cdn.shopify.com/shopifycloud/",
        o = {
          youtubeSdk: {
            tagId: "youtube-sdk",
            src: "https://www.youtube.com/iframe_api",
            type: e.script,
          },
          vimeoSdk: {
            tagId: "vimeo-sdk",
            src: "https://player.vimeo.com/api/player.js",
            type: e.script,
          },
          plyrShopifyStyles: {
            tagId: "plyr-shopify-styles",
            src: a + "plyr/v2.0/shopify-plyr.css",
            type: e.link,
          },
          modelViewerUiStyles: {
            tagId: "shopify-model-viewer-ui-styles",
            src: a + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
            type: e.link,
          },
        };
      return { load: t };
    })());
  var $ = (function () {
    function e(e) {
      var a = this;
      switch (
        ((a.$video = t(e)),
        (a.video_options = JSON.parse(a.$video.attr("data-options") || "{}")),
        (a.video_type = a.video_options.type),
        (a.video_mute = a.video_options.mute),
        (a.$videoInsert = a.$video.find("[data-bgvideo-insert]")),
        (a.$elementToInsert = a.$videoInsert.length
          ? a.$videoInsert
          : a.$video),
        (a.elementToInsert = a.$elementToInsert[0]),
        a.$video.attr("loaded", !0),
        a.video_type)
      ) {
        case i.html5:
          a._setupBgHtml5Video();
          break;
        case i.youtube:
          window.YT
            ? a._setupBgYouTubeVideo()
            : (a._triggerBgYouTubeVideo(),
              o || (T4SThemeSP.LibraryLoader.load("youtubeSdk"), (o = !0)));
          break;
        case i.vimeo:
          window.Vimeo
            ? a._setupBgVimeoVideo()
            : (a._triggerBgVimeoVideo(),
              s ||
                (T4SThemeSP.LibraryLoader.load(
                  "vimeoSdk",
                  a._loadedVimeoSDK.bind(a)
                ),
                (s = !0)));
      }
    }
    var i = { html5: "html5", youtube: "youtube", vimeo: "vimeo" },
      o = !1,
      s = !1;
    return (
      (e.prototype = Object.assign({}, e.prototype, {
        _triggerBgYouTubeVideo: function () {
          var t = this;
          n.on("youtube:ready", function (e) {
            t._setupBgYouTubeVideo();
          });
        },
        _loadedVimeoSDK: function () {
          n.trigger("vimeo:ready");
        },
        _triggerBgVimeoVideo: function () {
          var t = this;
          n.on("vimeo:ready", function (e) {
            t._setupBgVimeoVideo();
          });
        },
        _setupBgHtml5Video: function () {
          var e = this,
            i = e.video_options.id;
          let a =
            i && t(i)[0]
              ? t(i).html()
              : '<video class="t4s_bg_vid_html5" src="' +
                e.video_options.srcDefault +
                '" preload="auto" playsinline autoplay ' +
                (e.video_mute ? "muted " : " ") +
                "loop></video>";
          e.$elementToInsert.replaceWith(a);
          e.$video.find(".t4s_bg_vid_html5").on("playing", function (t) {
            e.$video.addClass("t4s-bgvideo-playing");
          });
        },
        _setupBgYouTubeVideo: function () {
          if (window.YT) {
            var t = this;
            (t.player = new YT.Player(t.elementToInsert, {
              videoId: t.video_options.vid,
              playerVars: {
                iv_load_policy: 3,
                enablejsapi: 1,
                disablekb: 1,
                autoplay: 0,
                controls: 0,
                rel: 0,
                loop: 0,
                playsinline: 1,
                modestbranding: 1,
                autohide: 1,
                branding: 0,
                cc_load_policy: 0,
                fs: 0,
                quality: "hd1080",
                wmode: "transparent",
                height: "100%",
                width: "100%",
                origin: t.video_options.requestHost,
              },
              events: {
                onReady: t.onPlayerReady.bind(this),
                onStateChange: t.onPlayerStateChange.bind(this),
              },
            })),
              t.resizeVideoBackground(),
              a.on(
                "resize",
                T4SThemeSP.debounce(
                  300,
                  function () {
                    t.resizeVideoBackground();
                  }.bind(t)
                )
              );
          }
        },
        onPlayerReady: function (t) {
          this.video_mute && this.player.mute(), this.player.playVideo();
        },
        onPlayerStateChange: function (t) {
          t.data === YT.PlayerState.PLAYING
            ? this.$video.addClass("t4s-bgvideo-playing")
            : t.data === YT.PlayerState.ENDED && this.player.playVideo();
        },
        _setupBgVimeoVideo: function () {
          if (window.Vimeo) {
            var t = this;
            (t.player = new Vimeo.Player(t.elementToInsert.parentNode, {
              id: t.video_options.vid,
              autoplay: !0,
              autopause: !1,
              muted: !0,
              background: !0,
              loop: t.video_mute,
            })),
              t.$videoInsert.remove(),
              t.resizeVideoBackground(),
              a.on(
                "resize",
                T4SThemeSP.debounce(
                  300,
                  function () {
                    t.resizeVideoBackground();
                  }.bind(t)
                )
              ),
              t.player.on("play", function () {
                t.$video.addClass("t4s-bgvideo-playing");
              }),
              t.player.on("ended", function () {});
          }
        },
        resizeVideoBackground: function () {
          var t,
            e,
            i,
            a,
            n = this.$video,
            o = n.innerWidth(),
            s = n.innerHeight();
          o / s < 16 / 9
            ? ((t = s * (16 / 9)),
              (e = s),
              (i = -Math.round((t - o) / 2) + "px"),
              (a = -Math.round((e - s) / 2) + "px"))
            : ((e = (t = o) * (9 / 16)),
              (a = -Math.round((e - s) / 2) + "px"),
              (i = -Math.round((t - o) / 2) + "px")),
            (t += "px"),
            (e += "px"),
            n
              .find("iframe")
              .css({
                maxWidth: "1000%",
                marginLeft: i,
                marginTop: a,
                width: t,
                height: e,
              });
        },
      })),
      e
    );
  })();
  (T4SThemeSP.BgVideo = function () {
    var e = t('[data-video-background]:not([loaded="true"])');
    0 != e.length &&
      e.each(function (t) {
        this.bgVideo = new $(this);
      });
  }),
    (T4SThemeSP.Footer = (function () {
      function e() {
        t("[data-footer-open]")
          .off("click")
          .on("click", function () {
            var e = t(this).parent(),
              i = e.find("> [data-footer-content]");
            e.hasClass(n.opened)
              ? (e.removeClass(n.opened), i.stop().slideUp(o))
              : (e.addClass(n.opened), i.stop().slideDown(o));
          }),
          a.off("resize.FooterCollapse");
      }
      function i() {
        a.on("resize.FooterCollapse", e),
          a.width() < 768 && t(".is--footer-collapse-true").length > 0 && e();
      }
      var n = { opened: "is--footer_opened" },
        o = 200;
      return i;
    })()),
    (T4SThemeSP.Notices = (function () {
      function e(e, c = "warning") {
        g ||
          (T4SThemeSP.$appendComponent.after(u),
          (a = t("#t4s-notices__wrapper")),
          (n = a.find(".t4s-notices__mess")),
          (o = a.find(".t4s-notices__progressbar")),
          (d = o.show().find(">span")),
          (g = !0),
          (u = null),
          d.css("animation-duration", `${b}ms`)),
          a.attr("data-notices-status", c),
          "object" == typeof e
            ? (n.html(""),
              t.each(e, function (t, e) {
                n.append('<span class="t4s-d-block">' + e[0] + "</span>");
              }))
            : n.html(e),
          y ? o.show() : o.hide(),
          setTimeout(function () {
            a.addClass(f), s.addClass(p);
          }, v),
          y &&
            (l = setTimeout(function () {
              i();
            }, b + v)),
          a.on(h, function () {
            i();
          }),
          r.on(m, function () {
            i();
          });
      }
      function i() {
        o.hide(),
          clearTimeout(l),
          a.removeClass(f),
          s.removeClass(p),
          a.off(h).off(m);
      }
      var a,
        n,
        o,
        d,
        l,
        c = t("#t4s-notices__tmp"),
        u = c.html(),
        f = "is--show",
        p = "is--active-notices",
        h = "click.notices",
        m = "hide.t4s.notices",
        g = !1,
        v = 200,
        y = T4Sconfigs.autoHideNotices,
        b = T4Sconfigs.timeOutNotices;
      return c.remove(), e;
    })()),
    (T4SThemeSP.FormShopifyMessSuccess = function () {
      t(document).on("submit", 'form[action^="/contact"]', function (e) {
        localStorage.setItem("t4s-recentform", t(this).attr("id"));
      });
      let e = location.href,
        i = localStorage.getItem("t4s-recentform") || "";
      (e.indexOf("contact_posted=true") < 0 && "" !== i) ||
        (e.indexOf("contact_posted=true#ContactFormNotifyStock") > -1 ||
        i.includes("ContactFormNotifyStock")
          ? T4SThemeSP.Notices(u.frm_notify_stock_success, "success")
          : e.indexOf("contact_posted=true#ContactFormAsk") > -1 ||
            i.includes("ContactFormAsk")
          ? T4SThemeSP.Notices(u.frm_contact_ask_success, "success")
          : (e.indexOf("contact_posted=true#t4sNewsletterFormPopup") > -1 ||
              i.includes("t4sNewsletterFormPopup")) &&
            T4SThemeSP.Notices(u.frm_newsletter_popup_success, "success"));
    }),
    (T4SThemeSP.PreloadStylePopup = function () {
      var e = t("#t4s-style-popup");
      0 != e.length && t("#t4s-assets-pre").html(e.html());
    }),
    (T4SThemeSP.BtnMore = (function () {
      function e(e) {
        (this.el = e),
          (this.$el = t(e)),
          this.clickHandler(),
          this.$el.addClass(i.enabled),
          (this.selector = this.$el.data("slector")),
          (this.tMore = this.$el.data("tmore")),
          (this.tLess = this.$el.data("tless")),
          (this.hasIsotope = this.$el.hasClass("isotopet4s"));
      }
      var i = {
        enabled: "is--enabled",
        btn: "[data-btn-toogle]",
        open: "is--open",
      };
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          clickHandler: function () {
            var e = this;
            e.$el.on("click.more", i.btn, function (a) {
              a.preventDefault();
              let n = t(this);
              n.parent().find(e.selector).slideToggle(200),
                n.toggleClass(i.open),
                n.hasClass(i.open) ? n.html(e.tLess) : n.html(e.tMore),
                e.hasIsotope &&
                  (e.$el.isotopet4s("layout"),
                  setTimeout(function () {
                    e.$el.isotopet4s("layout");
                  }, 219));
            });
          },
        })),
        e
      );
    })()),
    (T4SThemeSP.initBtnMore = (function () {
      var e = t("[data-wrap-toogle]:not(.is--enabled)");
      0 != e.length &&
        e.each(function () {
          this.btnMore = new T4SThemeSP.BtnMore(this);
        });
    })()),
    (T4SThemeSP.fixHand = function () {
      var t = navigator.userAgent.indexOf("Windows Phone") >= 0;
      !(/iP(ad|hone|od)/.test(navigator.userAgent) && !t) ||
        o > 1199 ||
        $script(T4Sconfigs.script12c, function () {
          T4SThemeSP.FastClick.attach(document.body),
            T4Sconfigs.disFlashyApp ||
              (function () {
                const t = document.querySelector("body");
                new MutationObserver(function () {
                  let t = document.querySelector("flashy-popup");
                  t &&
                    !t.classList.contains("needsclick") &&
                    t.classList.add("needsclick");
                }).observe(t, { attributes: !0, childList: !0, subtree: !0 });
              })();
        });
    });
})(jQuery_T4NT),
  jQuery_T4NT(document).ready(function (t) {
    smoothscroll.polyfill(),
      T4SThemeSP.FormShopifyMessSuccess(),
      T4SThemeSP.BgVideo(),
      T4SThemeSP.ParallaxInt(),
      t(".t4s-parallax-bg:not(.lazyloadt4sed)").on("lazyloaded", function (t) {
        T4SThemeSP.ParallaxInt();
      }),
      T4SThemeSP.Countdown(),
      T4SThemeSP.AnimateOnScroll(),
      T4SThemeSP._initProducts(),
      T4SThemeSP.slate.a11y.accessibleLinks({
        $links: t("a[href]:not([aria-describedby])"),
      }),
      T4SThemeSP.Tabs.Default(),
      T4SThemeSP.Tabs.Simple(),
      T4SThemeSP.Tabs.Accordion(),
      T4SThemeSP.Footer(),
      T4SThemeSP.PopupMFP(),
      T4SThemeSP.Cookies(),
      T4SThemeSP.fixHand(),
      $script([T4Sconfigs.script3, T4Sconfigs.script6]),
      setTimeout(function () {
        T4SThemeSP.LinkMyltiLang();
      }, 500),
      setTimeout(function () {
        T4SThemeSP.PreloadStylePopup();
      }, 1500);
  });
